import BookingDoctorReviewSection from "./BookingDoctorReviewSection";
import BookingAdditionalEquipment, {
  BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS,
  BookingAdditionalEquipmentField,
  normalizeBookingAdditionalEquipment,
  readBookingAdditionalEquipment,
} from "./BookingAdditionalEquipment";
import React, { Component, Fragment, useState } from "react";
import {
  Col,
  Row,
  Card,
  Modal,
  Button,
  Overlay,
  Popover,
} from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import multiMonthPlugin from "@fullcalendar/multimonth";
import { Calendar } from "@fullcalendar/core";
import { db, functions, auth, storage } from "../../../firebase";
import {
  ref,
  uploadBytes,
  deleteObject,
  listAll,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { httpsCallable } from "firebase/functions";
import { assertNodeAcceptsNewBooking } from "../../../utils/nodeBookingAvailability";
// import { sleepStudyReportMail } from "../../../../functions";
import {
  setDoc,
  getDoc,
  getDocFromServer,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  collection,
  query,
  where,
  getCollections,
  collectionGroup,
  orderBy,
  limit,
  Timestamp,
  onSnapshot,
  runTransaction,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
  updateEmail,
  updatePassword,
} from "firebase/auth";
import { async } from "@firebase/util";
import Alert from "sweetalert2";
// import { isExists } from "date-fns";
// import EditEvent from "./EditEvent";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../toast/SetToast";
import Toast from "../toast/SetToast";
import { AuthContext } from "../../../context/AuthContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./BookingCalendarFilters.css";
import swal from "sweetalert";
import { connectStorageEmulator } from "firebase/storage";
import {
  orderList,
  typeList,
  colorList,
  statusList,
  paymentPrivilages,
  PatientDropDownForm,
  PatientTextInfo,
  PatientLinkInfo,
  eventTmp,
  statusOrder,
  // sendNotification,
} from "./BookingUtils";
import {
  getBookingDateChangeConfirmation,
  getBookingEventDateInput,
  getLocalBookingDateString,
  getNextLocalBookingDateString,
  isSameLocalBookingDate,
} from "./BookingDateUtils";
import {
  buildExternalBookingEventData,
  createBookingEventDraft,
  ensureBookingEventDraft,
  getDefaultBookingCustomer,
  getBookingAssignmentConfirmationData,
  getBookingExtendedPropsForSave,
  getBookingEventColorProps,
  getBookingEventDisplayColor,
  getPatientPagePath,
  getPatientSearchBookingLocation,
  normalizeBookingHn,
  trimBookingHnInput,
} from "./BookingEventUtils";
import { mergeBookingExtendedPropsWithAutomationState } from "./BookingAutomationStateUtils";
import { assertScheduledBookingPatientUnchanged } from "./BookingPatientConflict";
import BookingPatientConflictModal from "./BookingPatientConflictModal";
import {
  canPartTimeTechnicianSetBookingStatus,
  getPartTimeTechnicianBookingStatusOptions,
  isPartTimeSleepTechnician,
} from "./BookingTechnicianPermissions";
import {
  BOOKING_SALE_FILTER_ALL,
  BOOKING_SALE_FILTER_UNASSIGNED,
  canEditBookingSale,
  filterBookingsBySaleSelection,
  filterBookingsForSaleAccess,
  getBookingSaleOptions,
  getBookingSaleSaveValue,
  isBookingSaleScopedUser,
} from "./BookingSaleAccess";
import { countBookingEventsByDate } from "./BookingCountUtils";
import {
  BOOKING_CALENDAR_MESSAGE_MAX_LENGTH,
  BOOKING_CALENDAR_MESSAGES_COLLECTION,
  canDeleteBookingCalendarMessages,
  canViewBookingCalendarMessages,
  groupBookingCalendarMessagesByDate,
  normalizeBookingCalendarMessage,
} from "./BookingCalendarMessageUtils";
import {
  getBookingReportChecklist as buildBookingReportChecklist,
  getBookingReportReadinessMap,
  matchesBookingReportFilter,
  mergeBookingReportRows,
} from "./BookingReportChecklistUtils";
import {
  BOOKING_PATIENT_NOTE_PARTS,
  getBookingPatientNoteChecklist as buildBookingPatientNoteChecklist,
  getBookingPatientNoteFileNames,
  normalizeBookingPatientNoteTitle,
} from "./BookingPatientNoteChecklistUtils";
import { buildSleepstudyUploadMetadata } from "./BookingMonitorWorkflow";
import {
  SCORED_SLEEP_STUDY_UPLOAD_TYPE,
  UNSCORED_SLEEP_STUDY_UPLOAD_TYPE,
  splitSleepStudyUploads,
  isSleepStudyCollection,
  getSleepStudyFileCollection,
  getSleepStudyUploadCollection,
} from "../../../utils/sleepStudyFiles";
import { loadPatientSleepStudyFiles } from "../../../utils/loadSleepStudyFiles";
import { buildUniqueNoteFileEntries } from "../../../actions/noteFileNames";
import {
  startAddReport,
  startSetReports,
  startRemoveReport,
  startEditReport,
} from "../../../actions/reports";
import selectReports from "../../../selectors/reports";
import moneyBag from "../../../images/money-bag.png";
import house from "../../../images/house.png";
import ConfirmUploadModal from "./confirmUploadModal";
import {
  filterCustomersForStaffNode,
  filterRecordsByStaffCustomerAccess,
  normalizeAccessValue,
} from "../../../utils/staffCustomerAccess";
// import moneyBag from "../../../images/avatar/1.png";

// import "react-datepicker/dist/react-datepicker-cssmodules.css";

const BOOKING_FILE_DELETE_ROLES = {
  report: ["super_admin"],
  sleepstudy: ["super_admin", "sleep_technician"],
  scoredsleepstudy: ["super_admin", "sleep_technician"],
};

const CALENDAR_REPORT_FETCH_EXCLUDED_STATUSES = [
  "Sleep Test Scheduled",
  "Reserve Sleep Set",
  "Transferred To Center",
  "Assigned",
  "Technician Scored",
  "Assigned to Doctor",
];

const CALENDAR_REPORT_READINESS_ICON_STATUSES = [
  "Doctor Scored",
  "Post-Consult",
  "Sale Follow Up",
  "Sale Follow Up [MC]",
  "Sale Follow Up [STM]",
  "Ready for CPAP Purchase",
  "Ship",
  "Ship [CPAP Purchase]",
  "Ship [CPAP Trial]",
  "Ship [CPAP Rental]",
  "Ship [No CPAP]",
];

const canDeleteBookingFile = (role, type) =>
  (BOOKING_FILE_DELETE_ROLES[type] || []).includes(role);

class EventCalendar extends Component {
  constructor(props) {
    super(props);
    this.calendarComponentRef = React.createRef();
    this.state = {
      calendarEvents: [],
      baseCalendarEvents: [],
      allEvents: [],
      totalDevice: 15,
      nodeList: [],
      hasNoAssignedNode: false,
      customerList: [],
      customerAllList: [],
      itemList: [],
      events: [
        {
          title: "Event",
          id: "6",
          order: "",
          hn: "",
          type: "",
          status: "",
          color: "green",
        },
      ],
      eventTmp: {
        title: "",
        startStr: "",
        id: "",
        extendedProps: {
          order: "",
          hn: "",
          type: "",
          status: "",
          sale: "",
          firstname: "",
          lastname: "",
          nationalId: "",
          healthInsurance: "",
          phone: "",
          note: "",
          node: "",
          customer: "",
          items: [],
          totalValue: 0,
          time: "",
          technician: "",
          doctor: "",
          referDoctor: "",
          postDoctor: "",
          techrecord: "",
          sleepDate: "",
          stopBangScore: "",
          techConsult: "",
          additionalEquipment: [],
        },
      },
      items: [],
      technicianList: [{ name: "กรุณาเลือก", nickname: "กรุณาเลือก" }],
      techrecordList: [{ name: "กรุณาเลือก", nickname: "กรุณาเลือก" }],
      doctorList: [],
      saleList: [],
      nodeIdDocs: [],
      allowedNodeDocs: [],
      staffAdminProfile: null,
      totalValue: 0,
      dateTmp: getLocalBookingDateString(new Date()),
      resetDateTmp: getLocalBookingDateString(new Date()),
      isAddEventModal: false,
      isNoti: false,
      isEditEventModal: false,
      isNewPatient: false,
      isEditBookingDetail: false,
      errStatus: false,
      isDatetime: false,
      isLoading: true,
      isPartTimeSleepTechnician: false,
      isCalendarRefreshing: false,
      isMovingBookingToRecovery: false,
      bookingRecoveryProgressData: {
        order: "-",
        patientName: "-",
      },
      pastEmptyHnCleanupStatus: "",
      createModal: false,
      fileUrl: null,
      filePreviewTitle: "Report",
      filePreviewType: "document",
      modalEmail: false,
      emailList: [],
      confirmVisible: false,
      bookingPatientConflict: null,
      isReloadingBookingPatient: false,
      bookingEditorVersion: 0,
      confirmData: {
        order: "-",
        patientName: "-",
        oldStatus: "-",
        newStatus: "-",
        oldTechnician: "Not selected",
        newTechnician: "Not selected",
        oldDoctor: "Not selected",
        newDoctor: "Not selected",
        statusChanged: false,
        technicianChanged: false,
        doctorChanged: false,
        previousUpdatedBy: "Unknown user",
        updatedBy: "Unknown user",
      },
      dateChangeConfirmVisible: false,
      dateChangeConfirmData: {
        order: "-",
        patientName: "-",
        oldDate: "-",
        oldStatus: "-",
        newDate: "-",
        newStatus: "-",
        updatedBy: "-",
      },
      confirmUploadModal: {
        show: false,
        message: "",
        resolver: null,
      },
      bookingSearchText: "",
      bookingSaleFilter: BOOKING_SALE_FILTER_ALL,
      bookingSearchReturnDate: null,
      bookingStatusFilter: "All Status",
      bookingDoctorFilter: "",
      bookingCustomerFilter: "",
      bookingCustomerOptions: [],
      bookingPostConsultTechFilter: "",
      bookingPostConsultDoctorFilter: "",
      bookingReportFilter: "all",
      calendarDisplayDate: new Date(),
      rangeStart: null,
      rangeEnd: null,
      reportReadinessByEventId: {},
      isBookingReportLoading: false,
      modalBookingReportHn: "",
      modalBookingReports: [],
      isBookingPatientNotesLoading: false,
      modalBookingPatientNoteHn: "",
      modalBookingPatientNotes: [],
      bookingPatientNoteLoadError: "",
      bookingPatientNoteUploadingKey: "",
      calendarMessagesByDate: {},
      isCalendarMessagesLoading: false,
      calendarMessageLoadError: "",
      isCalendarMessagePopoverOpen: false,
      calendarMessageDate: "",
      calendarMessageDraft: "",
      calendarMessageSubmitError: "",
      isCalendarMessageSaving: false,
      calendarMessageDeletingId: "",
    };
    this._isMounted = false;
    this.cache = {};
    this.customerCache = {};
    this.bookingCustomerLookupCache = new Map();
    this.bookingLookupCache = null;
    this.bookingLookupCachePromise = null;
    this.calendarEventElements = {};
    this.reportReadinessRequestId = 0;
    this.calendarReportVisibleRange = null;
    this.calendarReportReadinessScopeKey = "";
    this.calendarReportsByHn = {};
    this.calendarMessageRangeKey = "";
    this.calendarMessageUnsubscribe = null;
    this.calendarMessageTarget = null;
    this.editDropdownWheelSelect = null;
    this.editingEventSnapshot = null;
  }

  static contextType = AuthContext;

  dateRef = React.createRef();
  titleRef = React.createRef();
  idRef = React.createRef();
  orderRef = React.createRef();
  nodeRef = React.createRef();
  customerRef = React.createRef();
  hnRef = React.createRef();
  typeRef = React.createRef();
  statusRef = React.createRef();
  saleRef = React.createRef();
  colorRef = React.createRef();
  firstnameRef = React.createRef();
  lastnameRef = React.createRef();
  nationalIdRef = React.createRef();
  genderRef = React.createRef();
  healthInsuranceRef = React.createRef();
  phoneRef = React.createRef();
  noteRef = React.createRef();
  itemsRef = React.createRef([]);
  techRef = React.createRef([]);
  docRef = React.createRef([]);
  referDocRef = React.createRef([]);
  postDoctorRef = React.createRef([]);
  stopBangScoreRef = React.createRef();
  techRecordRef = React.createRef([]);
  techConsultRef = React.createRef([]);
  fileInputRef = React.createRef(null);
  fileInputStudyRef = React.createRef(null);
  fileInputScoredStudyRef = React.createRef(null);
  patientNoteFileInputRefs = BOOKING_PATIENT_NOTE_PARTS.reduce(
    (inputRefs, part) => ({
      ...inputRefs,
      [part.key]: React.createRef(),
    }),
    {},
  );
  hospitalNumberRef = React.createRef();
  ahiRef = React.createRef();
  additionalEquipmentRefs = BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS.reduce(
    (refs, option) => ({ ...refs, [option]: React.createRef() }),
    {},
  );
  currentEmailRef = React.createRef();

  nodeSelectRef = React.createRef();
  techSelectRef = React.createRef();
  statusSelectRef = React.createRef();

  copyRef = React.createRef();

  getInputValue = (inputRef, fallback = "") =>
    inputRef && inputRef.current ? inputRef.current.value : fallback;

  setInputValue = (inputRef, value = "") => {
    if (inputRef && inputRef.current) {
      inputRef.current.value = value || "";
    }
  };

  handleBookingNodeChange = async (e) => {
    const nodeName = e.target.value;
    const nodeChangeRequestId = (this.nodeChangeRequestId || 0) + 1;
    this.nodeChangeRequestId = nodeChangeRequestId;

    const eventTmp = ensureBookingEventDraft(this.state.eventTmp);
    eventTmp.setExtendedProp("node", nodeName);
    eventTmp.setExtendedProp("customer", "");

    this.setState({ eventTmp, customerList: [] }, () => {
      this.setInputValue(this.customerRef, "");
    });

    const customerList = await this.ensureCustomersForNode(nodeName);
    if (this.nodeChangeRequestId !== nodeChangeRequestId) {
      return;
    }

    const defaultCustomer = this.state.isAddEventModal
      ? getDefaultBookingCustomer(nodeName, customerList)
      : customerList[0] || "";
    const latestEventTmp = ensureBookingEventDraft(this.state.eventTmp);
    latestEventTmp.setExtendedProp("node", nodeName);
    latestEventTmp.setExtendedProp("customer", defaultCustomer);

    this.setState({ eventTmp: latestEventTmp, customerList }, () => {
      this.setInputValue(this.nodeRef, nodeName);
      this.setInputValue(this.customerRef, defaultCustomer);
    });
  };

  nodeName = "brain dynamics";
  typeList = typeList;
  statusList = statusList;
  colorList = colorList;
  orderList = orderList;
  paymentPrivilages = paymentPrivilages;
  PatientDropDownForm = PatientDropDownForm;
  PatientTextInfo = PatientTextInfo;
  PatientLinkInfo = PatientLinkInfo;
  statusOrder = statusOrder;

  getPatienBySearch = httpsCallable(functions, "getPatienBySearch");
  sendNotification = httpsCallable(functions, "sendNotification");
  createPatient = httpsCallable(functions, "createPatient");
  getSignedUrl = httpsCallable(functions, "getSignedUrl");
  sleepStudyReportMail = httpsCallable(functions, "sleepStudyReportMail");
  softDeleteBooking = httpsCallable(functions, "softDeleteBooking");
  getPastEmptyHnBookingCount = httpsCallable(
    functions,
    "getPastEmptyHnBookingCount",
  );
  movePastEmptyHnBookingsToRecovery = httpsCallable(
    functions,
    "movePastEmptyHnBookingsToRecovery",
  );
  completeBookingNodeMove = httpsCallable(functions, "completeBookingNodeMove");

  isSuperAdmin = () => {
    const currentUser = this.context && this.context.currentUser;
    const roles =
      currentUser && Array.isArray(currentUser.roles)
        ? currentUser.roles
        : [];

    return roles.includes("super_admin");
  };

  canManageBookingDeletion = () => {
    const currentUser = this.context && this.context.currentUser;
    const roles =
      currentUser && Array.isArray(currentUser.roles)
        ? currentUser.roles
        : [];

    return roles.some((role) => ["super_admin", "admin"].includes(role));
  };

  canFilterBookingsBySale = () => {
    const currentUser = this.context && this.context.currentUser;
    const roles =
      currentUser && Array.isArray(currentUser.roles)
        ? currentUser.roles
        : [];

    return roles.some((role) =>
      ["super_admin", "admin", "accountant", "sleep_technician"].includes(
        role,
      ),
    );
  };

  getBookingSaleOptions = (currentSale = "") =>
    getBookingSaleOptions({
      currentUser: this.context && this.context.currentUser,
      saleNames: this.state.saleList,
      currentSale,
    });

  getSelectedBookingSale = (currentSale = "") => {
    const currentUser = this.context && this.context.currentUser;
    const options = this.getBookingSaleOptions(currentSale);
    return isBookingSaleScopedUser(currentUser)
      ? options[0] || ""
      : currentSale || "";
  };

  getBookingSaleValueForSave = (currentSale = "") =>
    getBookingSaleSaveValue({
      currentUser: this.context && this.context.currentUser,
      saleNames: this.state.saleList,
      selectedSale: this.getInputValue(this.saleRef, currentSale),
      currentSale,
    });

  renderBookingAdditionalEquipmentField = (eventProps, idPrefix) => (
    <BookingAdditionalEquipmentField
      value={eventProps.additionalEquipment}
      inputRefs={this.additionalEquipmentRefs}
      idPrefix={idPrefix}
      disabled={
        this.props.modalOnly &&
        this.getCurrentUserRoles().includes("sleep_technician") &&
        !this.isCurrentUserPartTimeSleepTechnician()
      }
    />
  );

  renderBookingSaleField = (currentSale = "") => (
    <this.PatientDropDownForm
      title="Sale"
      id="sale"
      refvalue={this.saleRef}
      selected={this.getSelectedBookingSale(currentSale)}
      options={this.getBookingSaleOptions(currentSale)}
      disabled={
        !canEditBookingSale(this.context && this.context.currentUser)
      }
    ></this.PatientDropDownForm>
  );

  isCurrentUserPartTimeSleepTechnician = () =>
    this.state.isPartTimeSleepTechnician === true;

  sanitizeData = (obj) => {
    if (typeof obj !== "object" || obj === null) {
      return obj === undefined || obj === null ? "" : obj;
    }

    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        this.sanitizeData(value),
      ]),
    );
  };

  componentDidMount() {
    this._isMounted = true;
    if (typeof window !== "undefined") {
      window.addEventListener(
        "focus",
        this.refreshVisibleCalendarReportReadiness,
      );
    }
    this.rehydrateState();
    this.fetchData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.calendarMessageUnsubscribe) {
      this.calendarMessageUnsubscribe();
      this.calendarMessageUnsubscribe = null;
    }
    if (typeof window !== "undefined") {
      window.removeEventListener(
        "focus",
        this.refreshVisibleCalendarReportReadiness,
      );
    }
  };

  rehydrateState = () => {
    const cachedState = JSON.parse(localStorage.getItem("eventCalendarState"));
    if (cachedState) {
      this.setState(cachedState);
    }
  };

  cacheState = () => {
    const stateToCache = {
      // calendarEvents: this.state.calendarEvents,
      nodeList: this.state.nodeList,
      customerAllList: this.state.customerAllList,
      itemList: this.state.itemList,
      technicianList: this.state.technicianList,
      techrecordList: this.state.techrecordList,
      doctorList: this.state.doctorList,
      saleList: this.state.saleList,
      nodeIdDocs: this.state.nodeIdDocs,
    };
    localStorage.setItem("eventCalendarState", JSON.stringify(stateToCache));
  };

  logFetchTime = (label, startTime) => {
    const endTime = Date.now();
    console.log(`${label} took ${endTime - startTime} ms`);
  };

  showCalendarLoading = () => {
    if (this._isMounted) {
      this.setState({ isCalendarRefreshing: true });
    }
  };

  hideCalendarLoading = () => {
    if (this._isMounted) {
      this.setState({ isCalendarRefreshing: false });
    }
  };

  normalizeBookingEvent = (bookingDoc) => {
    const bookingData = bookingDoc.data ? bookingDoc.data() : bookingDoc;
    const bookingDocId = bookingDoc.id || bookingData.id;
    const extendedProps = {
      ...(bookingData.extendedProps || {}),
    };
    if (bookingDocId && !extendedProps.uuid) {
      extendedProps.uuid = bookingDocId;
    }
    const startValue = bookingData.start;
    const normalizedBookingData = {
      ...bookingData,
      id: bookingDocId || bookingData.id,
      extendedProps,
      allDay: bookingData.allDay !== false,
    };

    if (startValue && startValue.toDate) {
      const dateStart = new Date(startValue.toDate());
      dateStart.setHours(dateStart.getHours() + 7);
      const startDateString = dateStart.toISOString().slice(0, 10);
      return {
        ...normalizedBookingData,
        start: startDateString,
        startStr: startDateString,
        end: getNextLocalBookingDateString(startDateString),
      };
    }

    if (startValue) {
      const startDateString = getLocalBookingDateString(startValue);
      return {
        ...normalizedBookingData,
        start: startDateString,
        startStr: startDateString,
        end: getNextLocalBookingDateString(startDateString),
      };
    }

    return {
      ...normalizedBookingData,
      end: null,
    };
  };

  filterBookingsForRole = (bookings, allowedNodeDocs = null) => {
    const currentUser = this.context.currentUser;
    const currentUserRoles = Array.isArray(currentUser.roles)
      ? currentUser.roles
      : [];
    const currentUserName = currentUser.displayName;

    let roleFilteredBookings = bookings;

    if (currentUserRoles.includes("sleep_physician")) {
      roleFilteredBookings = roleFilteredBookings.filter(
        (bookingData) =>
          bookingData.extendedProps &&
          bookingData.extendedProps.doctor === currentUserName,
      );
    }

    if (currentUserRoles.includes("sleep_technician")) {
      roleFilteredBookings = roleFilteredBookings.filter(
        (bookingData) =>
          bookingData.extendedProps &&
          (bookingData.extendedProps.techrecord === currentUserName ||
            bookingData.extendedProps.technician === currentUserName),
      );
    }

    return filterBookingsForSaleAccess({
      records: roleFilteredBookings,
      currentUser,
      assignedNodes: allowedNodeDocs || this.state.allowedNodeDocs,
    });
  };

  normalizeCalendarFilterValue = (value, defaultValue) => {
    const normalizedValue = (value || "").trim();

    if (
      !normalizedValue ||
      normalizedValue === defaultValue ||
      normalizedValue.toLowerCase() === defaultValue.toLowerCase() ||
      normalizedValue.toLowerCase() === "all node"
    ) {
      return defaultValue;
    }

    return normalizedValue;
  };

  getSelectedNodeFilter = (nodeName) =>
    this.normalizeCalendarFilterValue(
      nodeName !== undefined
        ? nodeName
        : this.nodeSelectRef.current
          ? this.nodeSelectRef.current.value
          : "All Node",
      "All Node",
    );

  getSelectedTechFilter = (techName) =>
    this.normalizeCalendarFilterValue(
      techName !== undefined
        ? techName
        : this.techSelectRef.current
          ? this.techSelectRef.current.value
          : "กรุณาเลือก",
      "กรุณาเลือก",
    );

  getSelectedStatusFilter = (statusName) =>
    this.normalizeCalendarFilterValue(
      statusName !== undefined
        ? statusName
        : this.statusSelectRef.current
          ? this.statusSelectRef.current.value
          : this.state.bookingStatusFilter,
      "All Status",
    );

  getBookingCustomerFilterOptions = (nodeName = this.getSelectedNodeFilter()) => {
    const customerRecords = [
      ...(this.state.bookingCustomerOptions || []),
      ...this.state.baseCalendarEvents.map((booking) => booking.extendedProps || {}),
    ];
    const allowedCustomers = filterRecordsByStaffCustomerAccess({
      records: customerRecords,
      currentUser: this.context && this.context.currentUser,
      adminData: this.state.staffAdminProfile,
      nodes: this.state.allowedNodeDocs,
      getNodeValue: (record) => record.node,
      getCustomerValue: (record) => record.customer,
    });

    return Array.from(new Set(allowedCustomers
      .filter((record) => nodeName === "All Node" || record.node === nodeName)
      .map((record) => normalizeAccessValue(record.customer))
      .filter((customer) => customer && customer !== "กรุณาเลือก")))
      .sort((left, right) => left.localeCompare(right, "th"));
  };

  normalizeBookingSearchValue = (value) =>
    String(value || "")
      .normalize("NFKC")
      .toLowerCase()
      .replace(/[‐‑‒–—―]/g, "-")
      .trim();

  compactBookingSearchValue = (value) =>
    this.normalizeBookingSearchValue(value).replace(/[^a-z0-9ก-๙]+/g, "");

  getFilteredCalendarEvents = (
    events = this.state.baseCalendarEvents,
    nodeName = this.getSelectedNodeFilter(),
    techName = this.getSelectedTechFilter(),
    searchText = this.state.bookingSearchText,
    statusName = this.getSelectedStatusFilter(),
    saleName = this.state.bookingSaleFilter,
    doctorName = this.state.bookingDoctorFilter,
    customerName = this.state.bookingCustomerFilter,
  ) => {
    nodeName = this.getSelectedNodeFilter(nodeName);
    techName = this.getSelectedTechFilter(techName);
    statusName = this.getSelectedStatusFilter(statusName);
    let filteredEvents = events;

    if (customerName) {
      filteredEvents = filteredEvents.filter((bookingData) =>
        normalizeAccessValue((bookingData.extendedProps || {}).customer) === customerName,
      );
    }

    [
      ["techConsult", this.state.bookingPostConsultTechFilter],
      ["postDoctor", this.state.bookingPostConsultDoctorFilter],
    ].forEach(([field, selectedName]) => {
      if (selectedName) {
        filteredEvents = filteredEvents.filter((bookingData) => {
          const assignedName = String((bookingData.extendedProps || {})[field] || "").trim();
          return selectedName === "__not_assigned__"
            ? !assignedName || assignedName === "กรุณาเลือก"
            : assignedName === selectedName;
        });
      }
    });

    if (doctorName) {
      filteredEvents = filteredEvents.filter(
        (bookingData) =>
          bookingData.extendedProps &&
          (bookingData.extendedProps.doctor || "").trim() === doctorName,
      );
    }

    if (nodeName && nodeName !== "All Node") {
      filteredEvents = filteredEvents.filter(
        (bookingData) =>
          bookingData.extendedProps &&
          bookingData.extendedProps.node === nodeName,
      );
    }

    if (techName && techName !== "กรุณาเลือก") {
      filteredEvents = filteredEvents.filter(
        (bookingData) =>
          bookingData.extendedProps &&
          (bookingData.extendedProps.techrecord === techName ||
            bookingData.extendedProps.technician === techName),
      );
    }

    if (statusName && statusName !== "All Status") {
      filteredEvents = filteredEvents.filter(
        (bookingData) =>
          bookingData.extendedProps &&
          (bookingData.extendedProps.status || "").trim() === statusName,
      );
    }

    filteredEvents = filterBookingsBySaleSelection({
      records: filteredEvents,
      selectedSale: saleName,
    });

    const normalizedSearch = this.normalizeBookingSearchValue(searchText);
    const compactSearch = this.compactBookingSearchValue(searchText);
    if (normalizedSearch) {
      filteredEvents = filteredEvents.filter((bookingData) => {
        const props = bookingData.extendedProps || {};
        const searchableText = [
          props.order,
          bookingData.title,
          props.hn,
          props.firstname,
          props.lastname,
          `${props.firstname || ""} ${props.lastname || ""}`,
        ]
          .filter(Boolean)
          .join(" ");
        const normalizedSearchableText =
          this.normalizeBookingSearchValue(searchableText);
        const compactSearchableText =
          this.compactBookingSearchValue(searchableText);

        return (
          normalizedSearchableText.includes(normalizedSearch) ||
          (compactSearch &&
            compactSearchableText.includes(compactSearch))
        );
      });
    }

    return filteredEvents;
  };

  getCalendarEventId = (eventData) =>
    eventData &&
    eventData.extendedProps &&
    (eventData.extendedProps.uuid || eventData.id);

  isCalendarReportReadinessIconStatus = (eventData) => {
    const eventProps = (eventData && eventData.extendedProps) || {};
    const status = String(eventProps.status || "").trim();

    return CALENDAR_REPORT_READINESS_ICON_STATUSES.includes(status);
  };

  getCalendarReportReadiness = (eventData) => {
    if (!this.isCalendarReportReadinessIconStatus(eventData)) return null;

    const eventId = this.getCalendarEventId(eventData);

    if (!eventId) return null;

    return this.state.reportReadinessByEventId[String(eventId)] || null;
  };

  getCalendarReportVisibleRange = () => {
    if (this.calendarReportVisibleRange) {
      return this.calendarReportVisibleRange;
    }

    const displayDate = new Date(this.state.calendarDisplayDate || new Date());
    const rangeStart = new Date(
      displayDate.getFullYear(),
      displayDate.getMonth(),
      1,
    );
    const rangeEnd = new Date(
      displayDate.getFullYear(),
      displayDate.getMonth() + 1,
      1,
    );

    return {
      start: getLocalBookingDateString(rangeStart),
      end: getLocalBookingDateString(rangeEnd),
    };
  };

  getVisibleCalendarReportBookings = (bookings = []) => {
    const reportRange = this.getCalendarReportVisibleRange();

    return (Array.isArray(bookings) ? bookings : []).filter((booking) => {
      const bookingDate = this.getCalendarEventDateString(booking);
      const bookingProps = (booking && booking.extendedProps) || {};
      const status = String(bookingProps.status || "").trim();

      return (
        !CALENDAR_REPORT_FETCH_EXCLUDED_STATUSES.includes(status) &&
        bookingDate &&
        bookingDate >= reportRange.start &&
        bookingDate < reportRange.end
      );
    });
  };

  loadVisibleCalendarReportReadiness = (
    bookings = this.state.calendarEvents,
    forceRefresh = false,
  ) => {
    const reportRange = this.getCalendarReportVisibleRange();
    const visibleBookings = this.getVisibleCalendarReportBookings(bookings);
    const visibleEventIds = visibleBookings
      .map((booking) => {
        const bookingProps = (booking && booking.extendedProps) || {};
        const eventId = this.getCalendarEventId(booking);

        if (!eventId) return "";

        // Node and payment type determine which report parts are required.
        return [
          eventId,
          bookingProps.hn,
          bookingProps.node,
          bookingProps.healthInsurance,
        ]
          .map((value) => String(value || ""))
          .join("::");
      })
      .filter(Boolean)
      .sort()
      .join("|");
    const scopeKey = `${reportRange.start}|${reportRange.end}|${visibleEventIds}`;

    if (!forceRefresh && scopeKey === this.calendarReportReadinessScopeKey) {
      return;
    }

    this.calendarReportReadinessScopeKey = scopeKey;
    this.loadCalendarReportReadiness(visibleBookings, forceRefresh);
  };

  refreshVisibleCalendarReportReadiness = () => {
    if (!this._isMounted) return;

    // Reports can be uploaded by the patient page, Booking Monitor, or the
    // desktop validator while this calendar remains open. Recheck on focus,
    // but retain the current rows until the new response is ready so a click
    // cannot lose a green calendar result in the meantime.
    this.reportReadinessRequestId =
      (this.reportReadinessRequestId || 0) + 1;
    this.calendarReportReadinessScopeKey = "";
    this.loadVisibleCalendarReportReadiness(this.state.calendarEvents, true);
  };

  getCachedBookingReports = (hn, eventProps = {}) => {
    const normalizedHn = String(hn || eventProps.hn || "").trim();
    const calendarReports = normalizedHn
      ? (this.calendarReportsByHn || {})[normalizedHn]
      : [];

    return mergeBookingReportRows(eventProps.reports, calendarReports);
  };

  getModalBookingReports = (eventProps = {}) => {
    const hn = String(eventProps.hn || "").trim();
    const modalHn = String(this.state.modalBookingReportHn || "").trim();

    if (hn && hn === modalHn) {
      return Array.isArray(this.state.modalBookingReports)
        ? this.state.modalBookingReports
        : [];
    }

    return Array.isArray(eventProps.reports) ? eventProps.reports : [];
  };

  getModalBookingPatientNotes = (eventProps = {}) => {
    const hn = String(eventProps.hn || "").trim();
    const modalHn = String(this.state.modalBookingPatientNoteHn || "").trim();

    if (hn && hn === modalHn) {
      return Array.isArray(this.state.modalBookingPatientNotes)
        ? this.state.modalBookingPatientNotes
        : [];
    }

    return [];
  };

  fetchBookingPatientNotes = async (hn) => {
    const patientHn = String(hn || "").trim();

    if (!patientHn) return [];

    const noteSnapshot = await getDocs(
      collection(db, "patients", patientHn, "note"),
    );

    return noteSnapshot.docs.map((noteDoc) => ({
      id: noteDoc.id,
      ...noteDoc.data(),
      hn: String(noteDoc.data().hn || patientHn).trim(),
    }));
  };

  refreshBookingPatientNotes = async (hn) => {
    const patientHn = String(hn || "").trim();
    const notes = await this.fetchBookingPatientNotes(patientHn);

    if (
      this._isMounted &&
      String(this.state.modalBookingPatientNoteHn || "").trim() === patientHn
    ) {
      this.setState({
        modalBookingPatientNotes: notes,
        isBookingPatientNotesLoading: false,
        bookingPatientNoteLoadError: "",
      });
    }

    return notes;
  };

  hasCachedBookingReportSnapshot = (hn, eventProps = {}) => {
    const normalizedHn = String(hn || eventProps.hn || "").trim();

    return (
      Object.prototype.hasOwnProperty.call(eventProps, "reports") ||
      (normalizedHn &&
        Object.prototype.hasOwnProperty.call(
          this.calendarReportsByHn || {},
          normalizedHn,
        ))
    );
  };

  isBookingReportListReady = (reports = [], eventProps = {}) =>
    buildBookingReportChecklist(reports, {
      hn: eventProps.hn,
      node: eventProps.node,
      healthInsurance: eventProps.healthInsurance,
    }).isFinalReady;

  getDirectPatientReportSnapshots = async (hns = []) => {
    const snapshots = [];

    // Only visible HNs are read, with at most ten direct patient report
    // collections at one time. This matches the allowed modal data path.
    for (let index = 0; index < hns.length; index += 10) {
      const hnChunk = hns.slice(index, index + 10);
      const chunkSnapshots = await Promise.all(
        hnChunk.map((hn) =>
          getDocs(collection(db, "patients", hn, "report")),
        ),
      );
      snapshots.push(...chunkSnapshots);
    }

    return snapshots;
  };

  loadCalendarReportReadiness = async (bookings = [], forceRefresh = false) => {
    const requestId = (this.reportReadinessRequestId || 0) + 1;
    this.reportReadinessRequestId = requestId;
    const hns = Array.from(
      new Set(
        (Array.isArray(bookings) ? bookings : [])
          .map((booking) => {
            const bookingProps = (booking && booking.extendedProps) || {};
            return String(bookingProps.hn || "").trim();
          })
          .filter(Boolean),
      ),
    );

    if (hns.length === 0) {
      if (this._isMounted && this.reportReadinessRequestId === requestId) {
        this.setState({ reportReadinessByEventId: {} });
      }
      return;
    }

    const cachedReportsByHn = this.calendarReportsByHn || {};
    const hnsToLoad = hns.filter(
      (hn) =>
        forceRefresh ||
        !Object.prototype.hasOwnProperty.call(cachedReportsByHn, hn),
    );
    const firestoreReportsByHn = hns.reduce((reportMap, hn) => {
      reportMap[hn] = [];
      return reportMap;
    }, {});
    try {
      const reportSnapshots = await this.getDirectPatientReportSnapshots(
        hnsToLoad,
      );

      reportSnapshots.forEach((reportSnapshot) => {
        reportSnapshot.docs.forEach((reportDoc) => {
          const reportCollection = reportDoc.ref.parent;
          const patientDoc = reportCollection && reportCollection.parent;
          const patientCollection = patientDoc && patientDoc.parent;
          const patientHn = patientDoc
            ? String(patientDoc.id || "").trim()
            : "";
          const reportData = reportDoc.data();
          const reportHn = String(reportData.hn || patientHn || "").trim();
          const report = {
            id: reportDoc.id,
            ...reportData,
            hn: reportHn,
          };

          // Match the direct patients/{hn}/report path used by the booking
          // detail modal before including the file in its calendar status.
          if (
            !reportHn ||
            !patientDoc ||
            !patientCollection ||
            patientCollection.id !== "patients" ||
            patientDoc.id !== reportHn
          ) {
            return;
          }

          if (!firestoreReportsByHn[reportHn]) {
            firestoreReportsByHn[reportHn] = [];
          }
          firestoreReportsByHn[reportHn].push(report);
        });
      });

      if (!this._isMounted || this.reportReadinessRequestId !== requestId) {
        return;
      }

      const reportsByHn = hns.reduce((reportMap, hn) => {
        const firestoreReports = firestoreReportsByHn[hn] || [];
        const cachedReports = Array.isArray(cachedReportsByHn[hn])
          ? cachedReportsByHn[hn]
          : [];
        const matchingBookings = (Array.isArray(bookings) ? bookings : []).filter(
          (booking) => {
            const bookingProps = (booking && booking.extendedProps) || {};
            return String(bookingProps.hn || "").trim() === hn;
          },
        );
        const firestoreIsComplete =
          matchingBookings.length > 0 &&
          matchingBookings.every((booking) =>
            this.isBookingReportListReady(
              firestoreReports,
              (booking && booking.extendedProps) || {},
            ),
          );

        // Older uploads can have their files in Storage but an incomplete
        // reportFile array in Firestore. Do not replace a previously verified
        // list with that incomplete answer during a background refresh: it
        // would turn a green event red and make the modal look empty.
        reportMap[hn] = firestoreIsComplete
          ? firestoreReports
          : mergeBookingReportRows(firestoreReports, cachedReports);
        return reportMap;
      }, {});

      this.calendarReportsByHn = {
        ...(this.calendarReportsByHn || {}),
        ...reportsByHn,
      };
      const reportReadinessByEventId = getBookingReportReadinessMap(
        bookings,
        reportsByHn,
      );

      this.setState((prevState) => ({
        reportReadinessByEventId,
        // Keep the exact report rows that produced each title icon on the
        // calendar event too. The detail modal can then open from this same
        // snapshot instead of racing a second, independent lookup.
        calendarEvents: this.applyReportRowsToCalendarEvents(
          prevState.calendarEvents,
          reportsByHn,
        ),
        baseCalendarEvents: this.applyReportRowsToCalendarEvents(
          prevState.baseCalendarEvents,
          reportsByHn,
        ),
        allEvents: this.applyReportRowsToCalendarEvents(
          prevState.allEvents,
          reportsByHn,
        ),
      }));
    } catch (error) {
      console.error("Unable to load booking report readiness", error);
    }
  };

  updateCalendarReportReadiness = (
    eventData,
    reports = [],
    invalidatePendingLookup = true,
  ) => {
    const eventId = this.getCalendarEventId(eventData);
    const eventProps = (eventData && eventData.extendedProps) || {};
    const hn = String(eventProps.hn || "").trim();
    const reportSnapshot = this.cloneBookingReportRows(reports);

    if (!eventId || !hn) return;

    if (invalidatePendingLookup) {
      // A report upload/delete is newer than any in-flight calendar lookup.
      this.reportReadinessRequestId =
        (this.reportReadinessRequestId || 0) + 1;
    }
    this.calendarReportsByHn = {
      ...(this.calendarReportsByHn || {}),
      [hn]: reportSnapshot,
    };

    const nextReadiness = getBookingReportReadinessMap(
      [
        {
          id: eventData.id,
          extendedProps: eventProps,
        },
      ],
      { [hn]: reportSnapshot },
    );

    this.setState((prevState) => ({
      reportReadinessByEventId: {
        ...(prevState.reportReadinessByEventId || {}),
        ...nextReadiness,
      },
      calendarEvents: this.applyReportRowsToCalendarEvents(
        prevState.calendarEvents,
        { [hn]: reportSnapshot },
      ),
      baseCalendarEvents: this.applyReportRowsToCalendarEvents(
        prevState.baseCalendarEvents,
        { [hn]: reportSnapshot },
      ),
      allEvents: this.applyReportRowsToCalendarEvents(
        prevState.allEvents,
        { [hn]: reportSnapshot },
      ),
    }));
  };

  appendCalendarReportReadinessIcon = (container, readiness) => {
    if (!container || !readiness) return;

    const icon = document.createElement("i");
    const missingPartLabels = Array.isArray(readiness.missingPartLabels)
      ? readiness.missingPartLabels.join(", ")
      : "";
    const title = readiness.isReady
      ? "Report checklist ready"
      : `Report checklist waiting: ${missingPartLabels}`;

    icon.classList.add(
      "fa",
      readiness.isReady ? "fa-check-circle" : "fa-exclamation-circle",
    );
    icon.title = title;
    icon.setAttribute("aria-label", title);
    icon.style.color = "#ffffff";
    icon.style.backgroundColor = readiness.isReady ? "#2D9D65" : "#C77900";
    icon.style.borderRadius = "50%";
    icon.style.display = "inline-flex";
    icon.style.alignItems = "center";
    icon.style.justifyContent = "center";
    icon.style.width = "14px";
    icon.style.height = "14px";
    icon.style.fontSize = "9px";
    icon.style.flex = "0 0 auto";
    container.appendChild(icon);
  };

  isSameCalendarEvent = (eventA, eventB) => {
    if (!eventA || !eventB) return false;

    const keyA = this.getCalendarEventId(eventA);
    const keyB = this.getCalendarEventId(eventB);

    if (keyA && keyB) {
      return String(keyA) === String(keyB);
    }

    return eventA === eventB;
  };

  getCalendarEventDateString = (eventData) => {
    const startValue = eventData.startStr || eventData.start;

    if (!startValue) {
      return "";
    }

    if (typeof startValue === "string") {
      return startValue.slice(0, 10);
    }

    if (startValue.toDate) {
      return getLocalBookingDateString(startValue.toDate());
    }

    return getLocalBookingDateString(startValue);
  };

  getLocalCalendarDateString = (dateValue = new Date()) => {
    const date = new Date(dateValue);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  getColorForStatus = (status) => {
    return getBookingEventDisplayColor(
      { extendedProps: { status } },
      this.statusList,
      this.colorList,
    );
  };

  getCalendarEventColor = (eventData) => {
    return getBookingEventDisplayColor(
      eventData || {},
      this.statusList,
      this.colorList,
    );
  };

  isPrimaryCalendarStatus = (status) =>
    ["Sleep Test Scheduled", "Reserve Sleep Set", "Cancel"].includes(status);

  getBookingTypeSymbol = (type) => {
    if (type === "Split Night Sleep Study") {
      return "[SN]";
    }
    if (type === "Full Night Sleep Study") {
      return "[FN]";
    }
    if (type === "Home Full Night Sleep Study") {
      return "[HN]";
    }
    if (type === "CPAP Titration" || type === "CPAP Titration Study") {
      return "[CT]";
    }
    if (type === "Overnight Pulse Oximetry Study") {
      return "[OPO]";
    }
    if (type === "Multiple Sleep Latency Test") {
      return "[MSLT]";
    }

    return "";
  };

  compareCalendarEventsForDisplay = (a, b) => {
    const propsA = (a && a.extendedProps) || {};
    const propsB = (b && b.extendedProps) || {};
    const statusA = propsA.status;
    const statusB = propsB.status;
    const typeA = propsA.type || "";
    const typeB = propsB.type || "";
    const titleA = a.title || "";
    const titleB = b.title || "";
    const isPrimaryStatusA = this.isPrimaryCalendarStatus(statusA) ? 0 : 1;
    const isPrimaryStatusB = this.isPrimaryCalendarStatus(statusB) ? 0 : 1;

    if (isPrimaryStatusA !== isPrimaryStatusB) {
      return isPrimaryStatusA - isPrimaryStatusB;
    }

    const orderA = this.statusOrder[statusA] || 99;
    const orderB = this.statusOrder[statusB] || 99;

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    const isSplitA = [
      "Split Night Sleep Study",
      "CPAP Titration",
      "CPAP Titration Study",
    ].includes(typeA)
      ? 0
      : 1;
    const isSplitB = [
      "Split Night Sleep Study",
      "CPAP Titration",
      "CPAP Titration Study",
    ].includes(typeB)
      ? 0
      : 1;

    if (isSplitA !== isSplitB) {
      return isSplitA - isSplitB;
    }

    return titleA.localeCompare(titleB, undefined, { numeric: true });
  };

  eventApiToCalendarEvent = (eventApi, selectedDate = undefined) => {
    const bookingDate = getBookingEventDateInput(eventApi, selectedDate);
    const colorProps = getBookingEventColorProps(
      eventApi,
      this.statusList,
      this.colorList,
    );

    return {
      title: eventApi.title,
      id: eventApi.id,
      start: bookingDate.dateString,
      startStr: bookingDate.dateString,
      end: getNextLocalBookingDateString(bookingDate.dateString),
      ...colorProps,
      extendedProps: { ...(eventApi.extendedProps || {}) },
    };
  };

  getCalendarEventElementKeys = (eventApi) => {
    const eventData = ensureBookingEventDraft(eventApi);
    const eventKey = this.getCalendarEventId(eventData);
    return [eventKey, eventData.id, eventData.title]
      .filter(Boolean)
      .map((key) => String(key));
  };

  rememberCalendarEventElement = (eventApi, el) => {
    this.getCalendarEventElementKeys(eventApi).forEach((key) => {
      this.calendarEventElements[key] = el;
    });
  };

  forgetCalendarEventElement = (eventApi) => {
    this.getCalendarEventElementKeys(eventApi).forEach((key) => {
      delete this.calendarEventElements[key];
    });
  };

  applyCalendarEventElementColor = (eventApi, el) => {
    if (!el) return;

    const eventColor = this.getCalendarEventColor(eventApi);
    const nodes = [
      el,
      el.querySelector(".fc-event-main"),
      el.querySelector(".fc-event-main-frame"),
      el.querySelector("[data-booking-event-content='true']"),
    ].filter(Boolean);

    nodes.forEach((node) => {
      node.style.backgroundColor = eventColor;
      node.style.borderColor = eventColor;
    });
  };

  repaintCalendarEventElements = (eventApi) => {
    this.getCalendarEventElementKeys(eventApi).forEach((key) => {
      this.applyCalendarEventElementColor(
        eventApi,
        this.calendarEventElements[key],
      );
    });
  };

  repaintCalendarEventElementsAfterRender = (eventApi) => {
    const repaint = () => this.repaintCalendarEventElements(eventApi);

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(repaint);
    } else {
      setTimeout(repaint, 0);
    }
  };

  applyCalendarEventColor = (eventApi) => {
    const colorProps = getBookingEventColorProps(
      eventApi,
      this.statusList,
      this.colorList,
    );

    if (eventApi && eventApi.setProp) {
      eventApi.setProp("color", colorProps.color);
      eventApi.setProp("backgroundColor", colorProps.backgroundColor);
      eventApi.setProp("borderColor", colorProps.borderColor);
      this.repaintCalendarEventElements(eventApi);
      return;
    }

    if (eventApi) {
      eventApi.color = colorProps.color;
      eventApi.backgroundColor = colorProps.backgroundColor;
      eventApi.borderColor = colorProps.borderColor;
      this.repaintCalendarEventElements(eventApi);
    }
  };

  syncCalendarEventState = (eventApi, oldEvent, selectedDate = undefined) => {
    const savedEvent = this.eventApiToCalendarEvent(eventApi, selectedDate);
    const savedEventKey = this.getCalendarEventId(savedEvent);
    const oldEventKey = oldEvent
      ? this.getCalendarEventId({
          id: oldEvent.id,
          extendedProps: oldEvent.extendedProps || {},
        })
      : savedEventKey;
    const visibleSavedEvents = this.filterBookingsForRole([savedEvent]);
    const shouldKeepSavedEvent = visibleSavedEvents.length > 0;

    this.setState((prevState) => {
      const previousBaseEvents = prevState.baseCalendarEvents || [];
      const nextBaseEvents = previousBaseEvents.filter((eventData) => {
        const eventKey = this.getCalendarEventId(eventData);
        return eventKey !== savedEventKey && eventKey !== oldEventKey;
      });

      if (shouldKeepSavedEvent) {
        nextBaseEvents.push(savedEvent);
      }

      const filteredEvents = this.getFilteredCalendarEvents(
        nextBaseEvents,
        this.getSelectedNodeFilter(),
        this.getSelectedTechFilter(),
        prevState.bookingSearchText,
        prevState.bookingStatusFilter,
      );

      return {
        baseCalendarEvents: this.cloneCalendarEvents(nextBaseEvents),
        calendarEvents: this.cloneCalendarEvents(filteredEvents),
        calendarDisplayDate: savedEvent.start,
      };
    }, () => {
      this.repaintCalendarEventElementsAfterRender(savedEvent);
      this.loadVisibleCalendarReportReadiness();
    });
  };

  removeCalendarEventState = (eventApi, preserveDate = null) => {
    const eventData = ensureBookingEventDraft(eventApi);
    const eventKey = this.getCalendarEventId(eventData);
    const eventDate = this.getCalendarEventDateString(eventData);
    const eventProps = eventData.extendedProps || {};

    const isRemovedEvent = (eventData) => {
      const dataProps = (eventData && eventData.extendedProps) || {};
      const dataKey = this.getCalendarEventId(eventData);

      if (eventKey && dataKey) {
        return String(eventKey) === String(dataKey);
      }

      return (
        eventDate &&
        this.getCalendarEventDateString(eventData) === eventDate &&
        (dataProps.order || "") === (eventProps.order || "") &&
        (dataProps.hn || "") === (eventProps.hn || "") &&
        (dataProps.node || "") === (eventProps.node || "")
      );
    };

    this.setState((prevState) => {
      const nextBaseEvents = (prevState.baseCalendarEvents || []).filter(
        (eventData) => !isRemovedEvent(eventData),
      );
      const nextAllEvents = (prevState.allEvents || []).filter(
        (eventData) => !isRemovedEvent(eventData),
      );
      const filteredEvents = this.getFilteredCalendarEvents(
        nextBaseEvents,
        this.getSelectedNodeFilter(),
        this.getSelectedTechFilter(),
        prevState.bookingSearchText,
        prevState.bookingStatusFilter,
      );

      return {
        baseCalendarEvents: this.cloneCalendarEvents(nextBaseEvents),
        calendarEvents: this.cloneCalendarEvents(filteredEvents),
        allEvents: this.cloneCalendarEvents(nextAllEvents),
        calendarDisplayDate:
          preserveDate || prevState.calendarDisplayDate || new Date(),
      };
    }, () => {
      if (preserveDate && this.calendarComponentRef.current) {
        this.calendarComponentRef.current.getApi().gotoDate(preserveDate);
      }
    });
  };

  cloneBookingReportRows = (reports = []) =>
    (Array.isArray(reports) ? reports : []).map((report) => ({
      ...report,
      reportFile: Array.isArray(report && report.reportFile)
        ? [...report.reportFile]
        : report && report.reportFile,
    }));

  cloneCalendarEvents = (events = []) =>
    events.map((eventData) => ({
      ...eventData,
      extendedProps: {
        ...(eventData.extendedProps || {}),
        items: Array.isArray(eventData.extendedProps && eventData.extendedProps.items)
          ? eventData.extendedProps.items.map((item) => ({ ...item }))
          : eventData.extendedProps && eventData.extendedProps.items,
        reports: Array.isArray(
          eventData.extendedProps && eventData.extendedProps.reports,
        )
          ? this.cloneBookingReportRows(eventData.extendedProps.reports)
          : eventData.extendedProps && eventData.extendedProps.reports,
      },
    }));

  applyReportRowsToCalendarEvents = (events = [], reportsByHn = {}) =>
    this.cloneCalendarEvents(events).map((eventData) => {
      const eventProps = eventData.extendedProps || {};
      const hn = String(eventProps.hn || "").trim();

      if (
        !hn ||
        !Object.prototype.hasOwnProperty.call(reportsByHn || {}, hn)
      ) {
        return eventData;
      }

      return {
        ...eventData,
        extendedProps: {
          ...eventProps,
          reports: this.cloneBookingReportRows(reportsByHn[hn]),
        },
      };
    });

  focusCalendarOnEvent = (events) => {
    if (!events || events.length !== 1 || !this.calendarComponentRef.current) {
      return;
    }

    const eventStart = events[0].start;
    if (!eventStart) return;

    const api = this.calendarComponentRef.current.getApi();
    api.gotoDate(eventStart);
  };

  applyCalendarFilters = (
    searchText = this.state.bookingSearchText,
    nodeName = this.getSelectedNodeFilter(),
    techName = this.getSelectedTechFilter(),
    statusName = this.getSelectedStatusFilter(),
  ) => {
    nodeName = this.getSelectedNodeFilter(nodeName);
    techName = this.getSelectedTechFilter(techName);
    statusName = this.getSelectedStatusFilter(statusName);
    const normalizedSearch = (searchText || "").trim();
    const api = this.calendarComponentRef.current
      ? this.calendarComponentRef.current.getApi()
      : null;
    const shouldRememberReturnDate =
      normalizedSearch && !this.state.bookingSearchText && api;

    const calendarEvents = this.getFilteredCalendarEvents(
      this.state.baseCalendarEvents,
      nodeName,
      techName,
      normalizedSearch,
      statusName,
    );

    this.setState(
      {
        calendarEvents: this.cloneCalendarEvents(calendarEvents),
        bookingSearchText: normalizedSearch,
        bookingStatusFilter: statusName,
        bookingSearchReturnDate: shouldRememberReturnDate
          ? api.getDate()
          : this.state.bookingSearchReturnDate,
      },
      () => {
        if (normalizedSearch) {
          this.focusCalendarOnEvent(calendarEvents);
        }
        this.loadVisibleCalendarReportReadiness(calendarEvents);
      },
    );

    return calendarEvents;
  };

  setCalendarEventsFromLoadedEvents = (
    nodeName = this.getSelectedNodeFilter(),
    techName = this.getSelectedTechFilter(),
    statusName = this.getSelectedStatusFilter(),
    extraState = {},
    callback = undefined,
  ) => {
    nodeName = this.getSelectedNodeFilter(nodeName);
    techName = this.getSelectedTechFilter(techName);
    statusName = this.getSelectedStatusFilter(statusName);

    const calendarEvents = this.getFilteredCalendarEvents(
      this.state.baseCalendarEvents,
      nodeName,
      techName,
      this.state.bookingSearchText,
      statusName,
      this.state.bookingSaleFilter,
      this.state.bookingDoctorFilter,
      extraState.bookingCustomerFilter !== undefined
        ? extraState.bookingCustomerFilter
        : this.state.bookingCustomerFilter,
    );

    this.setState(
      {
        calendarEvents: this.cloneCalendarEvents(calendarEvents),
        bookingStatusFilter: statusName,
        ...extraState,
      },
      () => {
        this.loadVisibleCalendarReportReadiness(calendarEvents);
        if (callback) callback();
      },
    );

    return calendarEvents;
  };

  ensureCustomersForNode = async (nodeName) => {
    const customerRequestId = (this.customerRequestId || 0) + 1;
    this.customerRequestId = customerRequestId;

    const setCustomerListIfCurrent = (customerList) => {
      if (this.customerRequestId === customerRequestId) {
        this.setState({ customerList });
      }
    };

    if (!nodeName || nodeName === "All Node") {
      setCustomerListIfCurrent([]);
      return [];
    }

    const nodeIndex = this.state.nodeList.indexOf(nodeName);
    const nodeId = this.state.nodeIdDocs[nodeIndex];
    if (!nodeId) {
      setCustomerListIfCurrent([]);
      return [];
    }

    if (this.customerCache[nodeId]) {
      const cachedCustomers = this.customerCache[nodeId];
      setCustomerListIfCurrent(cachedCustomers);
      return cachedCustomers;
    }

    const customerDocs = await getDocs(
      collection(db, "nodes", nodeId, "customers"),
    );
    const loadedCustomers = customerDocs.docs.map((customer) => customer.id);
    const selectedNode = (this.state.allowedNodeDocs || []).find(
      (node) => node.id === nodeId,
    );
    const customersData = filterCustomersForStaffNode({
      customers: loadedCustomers,
      currentUser: this.context && this.context.currentUser,
      adminData: this.state.staffAdminProfile,
      nodeCode: selectedNode ? selectedNode.nodecode : "",
    });
    this.customerCache[nodeId] = customersData;

    if (this.customerRequestId === customerRequestId) {
      this.setState((prevState) => {
        const customerAllList = [...(prevState.customerAllList || [])];
        customerAllList[nodeIndex] = customersData;
        return {
          customerAllList,
          customerList: customersData,
        };
      });
    }

    return customersData;
  };

  getCurrentUserRoles = () => {
    const currentUser = this.context && this.context.currentUser;
    return currentUser && Array.isArray(currentUser.roles)
      ? currentUser.roles
      : [];
  };

  canCurrentUserViewCalendarMessages = () =>
    canViewBookingCalendarMessages(this.getCurrentUserRoles());

  canCurrentUserDeleteCalendarMessages = () =>
    canDeleteBookingCalendarMessages(this.getCurrentUserRoles());

  subscribeCalendarMessages = ({ start, end }) => {
    if (!this.canCurrentUserViewCalendarMessages()) {
      if (this.calendarMessageUnsubscribe) {
        this.calendarMessageUnsubscribe();
        this.calendarMessageUnsubscribe = null;
      }
      this.calendarMessageRangeKey = "";
      this.calendarMessageTarget = null;

      if (
        Object.keys(this.state.calendarMessagesByDate || {}).length > 0 ||
        this.state.isCalendarMessagesLoading ||
        this.state.calendarMessageLoadError ||
        this.state.isCalendarMessagePopoverOpen
      ) {
        this.setState({
          calendarMessagesByDate: {},
          isCalendarMessagesLoading: false,
          calendarMessageLoadError: "",
          isCalendarMessagePopoverOpen: false,
          calendarMessageDate: "",
          calendarMessageDraft: "",
        });
      }
      return;
    }

    const rangeKey = `${start}|${end}`;
    if (!start || !end || this.calendarMessageRangeKey === rangeKey) return;

    if (this.calendarMessageUnsubscribe) {
      this.calendarMessageUnsubscribe();
      this.calendarMessageUnsubscribe = null;
    }

    this.calendarMessageRangeKey = rangeKey;
    this.setState({
      calendarMessagesByDate: {},
      isCalendarMessagesLoading: true,
      calendarMessageLoadError: "",
    });

    try {
      const messagesQuery = query(
        collection(db, BOOKING_CALENDAR_MESSAGES_COLLECTION),
        where("calendarDate", ">=", start),
        where("calendarDate", "<", end),
        orderBy("calendarDate"),
      );

      this.calendarMessageUnsubscribe = onSnapshot(
        messagesQuery,
        (messagesSnapshot) => {
          if (!this._isMounted || this.calendarMessageRangeKey !== rangeKey) {
            return;
          }

          const messagesByDate = groupBookingCalendarMessagesByDate(
            messagesSnapshot.docs.map(normalizeBookingCalendarMessage),
          );

          this.setState({
            calendarMessagesByDate: messagesByDate,
            isCalendarMessagesLoading: false,
            calendarMessageLoadError: "",
          });
        },
        (error) => {
          if (!this._isMounted || this.calendarMessageRangeKey !== rangeKey) {
            return;
          }

          console.error("Unable to load booking calendar messages", error);
          this.setState({
            calendarMessagesByDate: {},
            isCalendarMessagesLoading: false,
            calendarMessageLoadError:
              "Unable to load messages. Please try again.",
          });
        },
      );
    } catch (error) {
      console.error("Unable to subscribe to booking calendar messages", error);
      this.setState({
        calendarMessagesByDate: {},
        isCalendarMessagesLoading: false,
        calendarMessageLoadError:
          "Unable to load messages. Please try again.",
      });
    }
  };

  getCalendarMessagesForDate = (calendarDate) =>
    (this.state.calendarMessagesByDate || {})[calendarDate] || [];

  handleOpenCalendarMessages = (event, calendarDate) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.canCurrentUserViewCalendarMessages()) return;

    this.calendarMessageTarget = event ? event.currentTarget : null;

    this.setState({
      isCalendarMessagePopoverOpen: true,
      calendarMessageDate: calendarDate,
      calendarMessageDraft: "",
      calendarMessageSubmitError: "",
    });
  };

  handleCalendarMessageTriggerKeyDown = (event, calendarDate) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    this.handleOpenCalendarMessages(event, calendarDate);
  };

  handleCloseCalendarMessages = () => {
    if (this.state.isCalendarMessageSaving) return;

    this.calendarMessageTarget = null;

    this.setState({
      isCalendarMessagePopoverOpen: false,
      calendarMessageDate: "",
      calendarMessageDraft: "",
      calendarMessageSubmitError: "",
    });
  };

  handleRetryCalendarMessages = () => {
    if (
      !this.canCurrentUserViewCalendarMessages() ||
      !this.calendarReportVisibleRange
    ) {
      return;
    }
    this.calendarMessageRangeKey = "";
    this.subscribeCalendarMessages(this.calendarReportVisibleRange);
  };

  handleAddCalendarMessage = async (event) => {
    if (event) event.preventDefault();

    const calendarDate = String(this.state.calendarMessageDate || "").trim();
    const message = String(this.state.calendarMessageDraft || "").trim();
    const currentUser = (this.context && this.context.currentUser) || {};

    if (!this.canCurrentUserViewCalendarMessages()) {
      this.setState({
        calendarMessageSubmitError:
          "You do not have permission to use calendar messages.",
      });
      return;
    }

    if (!/^\d{4}-\d{2}-\d{2}$/.test(calendarDate)) {
      this.setState({
        calendarMessageSubmitError: "The calendar date is invalid.",
      });
      return;
    }

    if (!message) {
      this.setState({
        calendarMessageSubmitError: "Please enter a message.",
      });
      return;
    }

    if (!currentUser.uid) {
      this.setState({
        calendarMessageSubmitError:
          "Your user account could not be identified. Please sign in again.",
      });
      return;
    }

    const roles = Array.isArray(currentUser.roles) ? currentUser.roles : [];
    const authorName = String(
      currentUser.displayName || currentUser.email || "Unknown user",
    ).trim();

    this.setState({
      isCalendarMessageSaving: true,
      calendarMessageSubmitError: "",
    });

    try {
      const messageRef = doc(
        collection(db, BOOKING_CALENDAR_MESSAGES_COLLECTION),
      );

      await setDoc(messageRef, {
        calendarDate,
        message,
        createdAt: Timestamp.now(),
        createdBy: {
          uid: String(currentUser.uid || ""),
          name: authorName,
          email: String(currentUser.email || "").trim(),
          role: String(roles[0] || "").trim(),
        },
      });

      if (this._isMounted) {
        this.setState({
          calendarMessageDraft: "",
          calendarMessageSubmitError: "",
          isCalendarMessageSaving: false,
        });
      }
      notifyTopRight("Message added");
    } catch (error) {
      console.error("Unable to add booking calendar message", error);
      if (this._isMounted) {
        this.setState({
          calendarMessageSubmitError:
            "Unable to add the message. Please try again.",
          isCalendarMessageSaving: false,
        });
      }
      notifyError("Unable to add the message.");
    }
  };

  handleDeleteCalendarMessage = async (messageEntry) => {
    if (!this.canCurrentUserDeleteCalendarMessages()) {
      notifyError("Only super_admin and admin can delete a message.");
      return;
    }

    const messageId = String((messageEntry && messageEntry.id) || "").trim();
    if (!messageId || this.state.calendarMessageDeletingId) return;

    const messageText = String(
      (messageEntry && messageEntry.message) || "",
    ).trim();
    const messagePreview =
      messageText.length > 160
        ? `${messageText.slice(0, 157)}...`
        : messageText;
    const confirmed = await swal({
      title: "Delete this message?",
      text: messagePreview || "This message will be removed from the log.",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!confirmed) return;

    this.setState({ calendarMessageDeletingId: messageId });

    try {
      await deleteDoc(
        doc(db, BOOKING_CALENDAR_MESSAGES_COLLECTION, messageId),
      );
      if (this._isMounted) {
        this.setState({ calendarMessageDeletingId: "" });
      }
      notifyTopRight("Message deleted");
    } catch (error) {
      console.error("Unable to delete booking calendar message", error);
      if (this._isMounted) {
        this.setState({ calendarMessageDeletingId: "" });
      }
      notifyError("Unable to delete the message.");
    }
  };

  formatCalendarMessageDate = (calendarDate) => {
    const dateParts = String(calendarDate || "")
      .split("-")
      .map(Number);

    if (dateParts.length !== 3 || dateParts.some(Number.isNaN)) {
      return calendarDate || "Selected day";
    }

    const [year, month, day] = dateParts;
    return new Date(year, month - 1, day).toLocaleDateString("en-GB", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  formatCalendarMessageTimestamp = (timestamp) => {
    if (!timestamp) return "Time unavailable";

    const date =
      timestamp && typeof timestamp.toDate === "function"
        ? timestamp.toDate()
        : new Date(timestamp);

    if (Number.isNaN(date.getTime())) return "Time unavailable";

    return date.toLocaleString("th-TH", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  renderCalendarMessagePopover = () => {
    if (!this.canCurrentUserViewCalendarMessages()) return null;

    const calendarDate = this.state.calendarMessageDate;
    const messages = this.getCalendarMessagesForDate(calendarDate);
    const draftLength = String(this.state.calendarMessageDraft || "").length;
    const canDeleteMessages = this.canCurrentUserDeleteCalendarMessages();

    return (
      <Overlay
        target={this.calendarMessageTarget}
        show={this.state.isCalendarMessagePopoverOpen}
        onHide={this.handleCloseCalendarMessages}
        placement="right"
        flip
        rootClose
        containerPadding={8}
        popperConfig={{
          strategy: "fixed",
          modifiers: [
            {
              name: "flip",
              options: {
                fallbackPlacements: ["left", "bottom", "top"],
                boundary: "viewport",
                rootBoundary: "viewport",
              },
            },
            {
              name: "preventOverflow",
              options: {
                boundary: "viewport",
                rootBoundary: "viewport",
                padding: 8,
              },
            },
          ],
        }}
      >
        <Popover
          id="booking-calendar-message-popover"
          className="booking-calendar-message-popover"
          role="dialog"
          aria-label={`Messages for ${calendarDate}`}
        >
          <Popover.Title
            as="div"
            className="booking-calendar-message-popover-header"
          >
            <span className="booking-calendar-message-popover-title">
              <i className="fa fa-envelope mr-2 text-warning" />
              {this.formatCalendarMessageDate(calendarDate)}
              {messages.length > 0 && (
                <span className="badge badge-danger ml-2">
                  {messages.length}
                </span>
              )}
            </span>
            <Button
              type="button"
              variant=""
              className="booking-calendar-message-popover-close"
              onClick={this.handleCloseCalendarMessages}
              disabled={this.state.isCalendarMessageSaving}
              aria-label="Close messages"
            >
              <span aria-hidden="true">&times;</span>
            </Button>
          </Popover.Title>
          <Popover.Content className="booking-calendar-message-popover-body">
          <div className="booking-calendar-message-log mb-2" aria-live="polite">
            {this.state.isCalendarMessagesLoading ? (
              <div className="booking-calendar-message-empty">
                <i className="fa fa-spinner fa-spin mr-2" />
                Loading messages...
              </div>
            ) : this.state.calendarMessageLoadError ? (
              <div
                className="alert alert-danger d-flex align-items-center justify-content-between mb-0"
                role="alert"
              >
                <span>{this.state.calendarMessageLoadError}</span>
                <Button
                  type="button"
                  variant="outline-danger"
                  size="sm"
                  className="ml-2"
                  onClick={this.handleRetryCalendarMessages}
                >
                  Retry
                </Button>
              </div>
            ) : messages.length === 0 ? (
              <div className="booking-calendar-message-empty">
                No messages for this day yet.
              </div>
            ) : (
              messages.map((messageEntry) => {
                const createdBy = messageEntry.createdBy || {};
                const authorName =
                  createdBy.name || createdBy.email || "Unknown user";

                return (
                  <div
                    className="booking-calendar-message-entry"
                    key={messageEntry.id}
                  >
                    <div className="booking-calendar-message-meta">
                      <strong>{authorName}</strong>
                      {createdBy.role && (
                        <span className="badge badge-light border ml-2">
                          {createdBy.role}
                        </span>
                      )}
                      <span className="text-muted ml-auto">
                        {this.formatCalendarMessageTimestamp(
                          messageEntry.createdAt,
                        )}
                      </span>
                      {canDeleteMessages && (
                        <Button
                          type="button"
                          variant="outline-danger"
                          size="sm"
                          className="booking-calendar-message-delete ml-2"
                          title="Delete message"
                          aria-label="Delete message"
                          disabled={Boolean(this.state.calendarMessageDeletingId)}
                          onClick={() =>
                            this.handleDeleteCalendarMessage(messageEntry)
                          }
                        >
                          <i
                            className={`fa ${
                              this.state.calendarMessageDeletingId ===
                              messageEntry.id
                                ? "fa-spinner fa-spin"
                                : "fa-trash"
                            }`}
                          />
                        </Button>
                      )}
                    </div>
                    <div className="booking-calendar-message-text">
                      {messageEntry.message}
                    </div>
                  </div>
                );
              })
            )}
          </div>

          <form onSubmit={this.handleAddCalendarMessage}>
            <label
              className="font-weight-bold mb-1"
              htmlFor="booking-calendar-new-message"
            >
              Add new message
            </label>
            <textarea
              id="booking-calendar-new-message"
              className="form-control"
              rows="2"
              maxLength={BOOKING_CALENDAR_MESSAGE_MAX_LENGTH}
              value={this.state.calendarMessageDraft}
              onChange={(event) =>
                this.setState({
                  calendarMessageDraft: event.target.value,
                  calendarMessageSubmitError: "",
                })
              }
              placeholder="Write a message for this day..."
              disabled={this.state.isCalendarMessageSaving}
            />
            <div className="d-flex align-items-start justify-content-between mt-2">
              <div>
                {this.state.calendarMessageSubmitError && (
                  <div className="text-danger small" role="alert">
                    {this.state.calendarMessageSubmitError}
                  </div>
                )}
                <div className="text-muted small">
                  {draftLength}/{BOOKING_CALENDAR_MESSAGE_MAX_LENGTH}
                </div>
              </div>
              <Button
                type="submit"
                variant="primary"
                size="sm"
                disabled={
                  this.state.isCalendarMessageSaving ||
                  !String(this.state.calendarMessageDraft || "").trim()
                }
              >
                <i
                  className={`fa ${
                    this.state.isCalendarMessageSaving
                      ? "fa-spinner fa-spin"
                      : "fa-paper-plane"
                  } mr-1`}
                />
                {this.state.isCalendarMessageSaving
                  ? "Adding..."
                  : "Add Message"}
              </Button>
            </div>
          </form>
          </Popover.Content>
        </Popover>
      </Overlay>
    );
  };

  handleDatesSet = (arg) => {
    const viewStart = arg.view.currentStart;
    const viewEnd = arg.view.currentEnd;
    const reportRangeStart =
      arg.start || arg.view.activeStart || arg.view.currentStart;
    const reportRangeEnd = arg.end || arg.view.activeEnd || arg.view.currentEnd;
    const nextReportVisibleRange = {
      start: getLocalBookingDateString(reportRangeStart),
      end: getLocalBookingDateString(reportRangeEnd),
    };
    const reportRangeChanged =
      !this.calendarReportVisibleRange ||
      this.calendarReportVisibleRange.start !== nextReportVisibleRange.start ||
      this.calendarReportVisibleRange.end !== nextReportVisibleRange.end;

    this.subscribeCalendarMessages(nextReportVisibleRange);

    this.calendarReportVisibleRange = nextReportVisibleRange;
    if (reportRangeChanged) {
      this.calendarReportReadinessScopeKey = "";
    }

    const { rangeStart, rangeEnd } = this.state;
    if (!rangeStart || !rangeEnd) return;

    if (viewStart < rangeStart || viewEnd > rangeEnd) {
      const newStart = new Date(
        viewStart.getFullYear(),
        viewStart.getMonth() - this.getBookingFetchPastMonths(),
        1,
      );
      const newEnd = new Date(
        viewEnd.getFullYear(),
        viewEnd.getMonth() + this.getBookingFetchFutureMonths(),
        0,
        23,
        59,
        59,
      );

      this.fetchData(Timestamp.fromDate(newStart), Timestamp.fromDate(newEnd));
      return;
    }

    if (reportRangeChanged) {
      this.loadVisibleCalendarReportReadiness();
    }
  };

  getBookingFetchPastMonths = () => 5;

  getBookingFetchFutureMonths = () => 2;

  getInitialDateRange = () => {
    const now = new Date();
    return {
      start: new Date(
        now.getFullYear(),
        now.getMonth() - this.getBookingFetchPastMonths(),
        1,
      ),
      end: new Date(
        now.getFullYear(),
        now.getMonth() + this.getBookingFetchFutureMonths() + 1,
        0,
        23,
        59,
        59,
      ),
    };
  };

  getCalendarRangeTimestamps = () => {
    const initialRange = this.getInitialDateRange();
    const rangeStart = this.state.rangeStart || initialRange.start;
    const rangeEnd = this.state.rangeEnd || initialRange.end;

    return {
      start: Timestamp.fromDate(rangeStart),
      end: Timestamp.fromDate(rangeEnd),
    };
  };

  getAllowedNodeNames = () => new Set(this.state.nodeList || []);

  loadBookingCustomerFilterOptions = async (nodes, adminData) => {
    const customerGroups = await Promise.all(nodes.map(async (nodeData) => {
      if (!this.bookingCustomerLookupCache.has(nodeData.id)) {
        const request = getDocs(collection(db, "nodes", nodeData.id, "customers"))
          .then((snapshot) => snapshot.docs.map((customer) => customer.id))
          .catch((error) => {
            this.bookingCustomerLookupCache.delete(nodeData.id);
            throw error;
          });
        this.bookingCustomerLookupCache.set(nodeData.id, request);
      }
      const customers = await this.bookingCustomerLookupCache.get(nodeData.id);
      return filterCustomersForStaffNode({
        customers,
        currentUser: this.context && this.context.currentUser,
        adminData,
        nodeCode: nodeData.nodecode,
      }).map((customer) => ({ node: nodeData.nodename, customer }));
    }));

    return customerGroups.flat();
  };

  loadBookingLookupData = async () => {
    if (this.bookingLookupCache) {
      return this.bookingLookupCache;
    }

    if (!this.bookingLookupCachePromise) {
      this.bookingLookupCachePromise = Promise.all([
        getDocs(collection(db, "nodes")),
        getDocs(collection(db, "items")),
        getDocs(collection(db, "sleeptechnicians")),
        getDocs(collection(db, "doctors")),
        getDocs(collection(db, "sales")),
      ])
        .then(([nodesDocs, itemsDocs, techDocs, docDocs, salesDocs]) => {
          this.bookingLookupCache = {
            nodesDocs,
            itemsDocs,
            techDocs,
            docDocs,
            salesDocs,
          };
          return this.bookingLookupCache;
        })
        .finally(() => {
          this.bookingLookupCachePromise = null;
        });
    }

    return this.bookingLookupCachePromise;
  };

  refetchBookingEventsForFilters = async (
    nodeName = this.getSelectedNodeFilter(),
    techName = this.getSelectedTechFilter(),
    searchText = this.state.bookingSearchText,
    statusName = this.getSelectedStatusFilter(),
  ) => {
    const { start, end } = this.getCalendarRangeTimestamps();
    const bookingsQ = query(
      collectionGroup(db, "bookings"),
      where("start", ">=", start),
      where("start", "<=", end),
      orderBy("start"),
    );
    const bookingsSnap = await getDocs(bookingsQ);
    const allowedNodeNames = this.getAllowedNodeNames();
    const fetchedBookings = bookingsSnap.docs.map(this.normalizeBookingEvent);
    const visibleNodeBookings = fetchedBookings.filter(
      (bookingData) =>
        bookingData.extendedProps &&
        allowedNodeNames.has(bookingData.extendedProps.node),
    );
    const roleFilteredBookings = this.filterBookingsForRole(
      visibleNodeBookings,
      this.state.allowedNodeDocs,
    );
    const customerFilteredBookings = filterRecordsByStaffCustomerAccess({
      records: roleFilteredBookings,
      currentUser: this.context && this.context.currentUser,
      adminData: this.state.staffAdminProfile,
      nodes: this.state.allowedNodeDocs,
      getNodeValue: (booking) =>
        booking.extendedProps && booking.extendedProps.node,
      getCustomerValue: (booking) =>
        booking.extendedProps && booking.extendedProps.customer,
    });
    const calendarEvents = this.getFilteredCalendarEvents(
      customerFilteredBookings,
      nodeName,
      techName,
      searchText,
      statusName,
    );

    return { roleFilteredBookings: customerFilteredBookings, calendarEvents };
  };

  fetchData = async (rangeStartTs = null, rangeEndTs = null) => {
    try {
      if (this._isMounted) {
        if (this.state.isLoading) {
          this.setState({ isLoading: true });
        } else {
          this.showCalendarLoading();
        }
      }

      const startFetchTime = Date.now();

      const { start, end } = this.getInitialDateRange();

      rangeStartTs = rangeStartTs || Timestamp.fromDate(start);
      rangeEndTs = rangeEndTs || Timestamp.fromDate(end);

      this.setState({
        rangeStart: rangeStartTs.toDate(),
        rangeEnd: rangeEndTs.toDate(),
      });

      const { nodesDocs, itemsDocs, techDocs, docDocs, salesDocs } =
        await this.loadBookingLookupData();

      if (!this._isMounted) return;

      this.logFetchTime(
        "Fetching nodes, items, techs, and docs",
        startFetchTime,
      );

      const currentUserRoles = Array.isArray(
        this.context.currentUser.roles,
      )
        ? this.context.currentUser.roles
        : [];
      const currentUserRole = currentUserRoles[0];
      const currentUserName = this.context.currentUser.displayName;
      const currentUserIsPartTimeSleepTechnician = isPartTimeSleepTechnician(
        this.context.currentUser,
        techDocs.docs.map((techDoc) => techDoc.data()),
      );
      const nodeDocs = nodesDocs.docs.map((nodeDoc) => ({
        id: nodeDoc.id,
        ...nodeDoc.data(),
      }));

      let allowedNodeDocs = nodeDocs;
      let nodeCode = [];
      let staffAdminProfile = null;

      if (
        isBookingSaleScopedUser(this.context.currentUser) ||
        !currentUserRoles.some((role) =>
          [
            "super_admin",
            "accountant",
            "sleep_physician",
            "sleep_technician",
          ].includes(role),
        )
      ) {
        const currentAdminDoc = await getDoc(
          doc(db, "admins", currentUserName),
        );
        const currentAdmin = currentAdminDoc.exists()
          ? currentAdminDoc.data()
          : {};
        staffAdminProfile = currentAdmin;
        nodeCode = currentAdmin.node || [];

        if (!Array.isArray(nodeCode)) {
          nodeCode = nodeCode ? [nodeCode] : [];
        }

        allowedNodeDocs = nodeDocs.filter((nodeDoc) =>
          nodeCode.includes(nodeDoc.nodecode),
        );
      }

      const allNodes = allowedNodeDocs.map((nodeDoc) => nodeDoc.nodename);
      const allnodeIdDocs = allowedNodeDocs.map((nodeDoc) => nodeDoc.id);
      const allowedNodeNames = new Set(allNodes);
      const allCustomers = allNodes.map(() => []);

      const allItems = itemsDocs.docs
        .map((itemDoc) => ({
          ...itemDoc.data(),
          itemcode: itemDoc.id,
        }));

      const bookingsQ = query(
        collectionGroup(db, "bookings"),
        where("start", ">=", rangeStartTs),
        where("start", "<=", rangeEndTs),
        orderBy("start"),
      );
      const [bookingsSnap, bookingCustomerOptions] = await Promise.all([
        getDocs(bookingsQ),
        this.loadBookingCustomerFilterOptions(allowedNodeDocs, staffAdminProfile)
          .catch((error) => {
            console.error("Error loading calendar customer filters:", error);
            notifyError("Unable to load customer list. Please refresh to try again.");
            return [];
          }),
      ]);
      const fetchedBookings = bookingsSnap.docs.map(this.normalizeBookingEvent);
      const visibleNodeBookings = fetchedBookings.filter(
        (bookingData) =>
          bookingData.extendedProps &&
          allowedNodeNames.has(bookingData.extendedProps.node),
      );
      const roleFilteredBookings = this.filterBookingsForRole(
        visibleNodeBookings,
        allowedNodeDocs,
      );
      const customerFilteredBookings = filterRecordsByStaffCustomerAccess({
        records: roleFilteredBookings,
        currentUser: this.context && this.context.currentUser,
        adminData: staffAdminProfile,
        nodes: allowedNodeDocs,
        getNodeValue: (booking) =>
          booking.extendedProps && booking.extendedProps.node,
        getCustomerValue: (booking) =>
          booking.extendedProps && booking.extendedProps.customer,
      });
      const selectedNode =
        this.getSelectedNodeFilter();
      const selectedTech =
        this.getSelectedTechFilter();
      const selectedStatus =
        this.getSelectedStatusFilter();
      const bookingEvent = this.getFilteredCalendarEvents(
        customerFilteredBookings,
        selectedNode,
        selectedTech,
        this.state.bookingSearchText,
        selectedStatus,
      );

      const teamOrder = [
        "TEAM A",
        "TEAM B",
        "TEAM C",
        "RHG-A",
        "RHG-B",
        "TU",
        "SCORE",
        "BDT",
      ];

      // Prepare technician and doctor lists
      const allTechs = [
        { name: "กรุณาเลือก", nickname: "กรุณาเลือก" },
        ...techDocs.docs
          .filter((doc) => doc.data().status === "Available")
          .sort((a, b) => {
            const teamA = a.data().team || "";
            const teamB = b.data().team || "";

            const indexA = teamOrder.indexOf(teamA);
            const indexB = teamOrder.indexOf(teamB);

            // Teams in teamOrder first, in defined order
            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1; // A is in teamOrder, B is not
            if (indexB !== -1) return 1; // B is in teamOrder, A is not

            // If both not in teamOrder → fallback alphabetical
            return teamA.localeCompare(teamB, "th");
          })
          .map((doc) => ({
            name: doc.data().name ? doc.data().name : "",
            nickname: doc.data().nickname ? doc.data().nickname : "",
            // id: doc.id,
          })),
      ];

      const allTechsRecord = [
        { name: "กรุณาเลือก", nickname: "กรุณาเลือก" },
        ...techDocs.docs
          .filter((doc) => doc.data().status === "Available")
          .sort((a, b) => {
            const teamA = a.data().team || "";
            const teamB = b.data().team || "";

            const indexA = teamOrder.indexOf(teamA);
            const indexB = teamOrder.indexOf(teamB);

            // Teams in teamOrder first, in defined order
            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1; // A is in teamOrder, B is not
            if (indexB !== -1) return 1; // B is in teamOrder, A is not

            // If both not in teamOrder → fallback alphabetical
            return teamA.localeCompare(teamB, "th");
          })
          .map((doc) => ({
            name: doc.data().name ? doc.data().name : "",
            nickname: doc.data().nickname ? doc.data().nickname : "",
            // id: doc.id,
          })),
      ];
      const allDocs = [
        "กรุณาเลือก",
        ...docDocs.docs.map((doc) => doc.data().name),
      ];
      const allSales = salesDocs.docs
        .map((saleDoc) => saleDoc.data().name || "")
        .filter(Boolean)
        .sort((left, right) => left.localeCompare(right, "en"));

      const docRef = doc(db, "setting", "equipment");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Data:", docSnap.data().total);
        this.setState({ totalDevice: docSnap.data().total });
      }

      if (this._isMounted) {
        console.log("Fetched all data successfully.");
        console.log("Booking Events:", bookingEvent);
        this.setState(
          {
            calendarEvents: this.cloneCalendarEvents(bookingEvent),
            baseCalendarEvents: this.cloneCalendarEvents(
              customerFilteredBookings,
            ),
            itemList: allItems,
            nodeList: allNodes,
            hasNoAssignedNode:
              currentUserRole === "staff" && allowedNodeDocs.length === 0,
            customerAllList: allCustomers,
            customerList: allCustomers[0] || [],
            technicianList: allTechs,
            techrecordList: allTechsRecord,
            doctorList: allDocs,
            saleList: allSales,
            nodeIdDocs: allnodeIdDocs,
            allowedNodeDocs,
            staffAdminProfile,
            bookingCustomerOptions,
            allEvents:
              currentUserRole === "admin"
                ? fetchedBookings
                : customerFilteredBookings,
            isPartTimeSleepTechnician: currentUserIsPartTimeSleepTechnician,
            isLoading: false,
            isCalendarRefreshing: false,
            reportReadinessByEventId: {},
          },
          () => {
            this.cacheState();
            this.reportReadinessRequestId =
              (this.reportReadinessRequestId || 0) + 1;
            this.calendarReportsByHn = {};
            this.calendarReportReadinessScopeKey = "";
            this.loadVisibleCalendarReportReadiness(bookingEvent);
          },
        );

        const draggableEl = document.getElementById("external-events");
        if (draggableEl) {
          new Draggable(draggableEl, {
            itemSelector: ".fc-event",
            eventData: buildExternalBookingEventData,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false, isCalendarRefreshing: false });
    }
  };

  onChangeNode = (nodeValue) => {
    try {
      const nodeName = this.getSelectedNodeFilter(nodeValue.target.value);
      const techName = this.getSelectedTechFilter();
      const statusName = this.getSelectedStatusFilter();
      const customerList =
        nodeName !== "All Node" ? this.CustomerList(nodeName) : [];

      this.setCalendarEventsFromLoadedEvents(nodeName, techName, statusName, {
        customerList,
        bookingCustomerFilter: this.getBookingCustomerFilterOptions(nodeName)
          .includes(this.state.bookingCustomerFilter)
          ? this.state.bookingCustomerFilter
          : "",
      });

      this.ensureCustomersForNode(nodeName).catch((error) => {
        console.error("Error loading node customers:", error);
      });
    } catch (error) {
      console.error("Error changing node:", error);
    }
  };

  onChangeTech = (techValue) => {
    try {
      const techName = this.getSelectedTechFilter(techValue.target.value);
      const nodeName = this.getSelectedNodeFilter();
      const statusName = this.getSelectedStatusFilter();

      this.setCalendarEventsFromLoadedEvents(nodeName, techName, statusName);
    } catch (error) {
      console.error("Error changing tech:", error);
    }
  };

  onChangeCustomerFilter = (event) => {
    const customer = event.target.value;
    const bookingCustomerFilter = this.getBookingCustomerFilterOptions().includes(customer)
      ? customer
      : "";
    this.setState({ bookingCustomerFilter }, () => this.applyCalendarFilters());
  };

  onChangeStatus = (statusValue) => {
    try {
      const statusName = this.getSelectedStatusFilter(statusValue.target.value);
      const nodeName = this.getSelectedNodeFilter();
      const techName = this.getSelectedTechFilter();

      this.setCalendarEventsFromLoadedEvents(nodeName, techName, statusName);
    } catch (error) {
      console.error("Error changing status:", error);
    }
  };

  onChangeSaleFilter = (saleValue) => {
    const saleName = saleValue.target.value || BOOKING_SALE_FILTER_ALL;
    const calendarEvents = this.getFilteredCalendarEvents(
      this.state.baseCalendarEvents,
      this.getSelectedNodeFilter(),
      this.getSelectedTechFilter(),
      this.state.bookingSearchText,
      this.getSelectedStatusFilter(),
      saleName,
    );

    this.setState(
      {
        bookingSaleFilter: saleName,
        calendarEvents: this.cloneCalendarEvents(calendarEvents),
      },
      () => this.loadVisibleCalendarReportReadiness(calendarEvents),
    );
  };

  onChangeDoctorFilter = (event) => {
    const doctorName = event.target.value;
    const calendarEvents = this.getFilteredCalendarEvents(
      this.state.baseCalendarEvents,
      this.getSelectedNodeFilter(),
      this.getSelectedTechFilter(),
      this.state.bookingSearchText,
      this.getSelectedStatusFilter(),
      this.state.bookingSaleFilter,
      doctorName,
    );

    this.setState(
      {
        bookingDoctorFilter: doctorName,
        calendarEvents: this.cloneCalendarEvents(calendarEvents),
      },
      () => this.loadVisibleCalendarReportReadiness(calendarEvents),
    );
  };

  onSearchBooking = (e) => {
    const nextSearchText = e.target.value;
    if (!nextSearchText) {
      this.onClearBookingSearch();
      return;
    }

    this.applyCalendarFilters(nextSearchText);
  };

  onClearBookingSearch = () => {
    this.showCalendarLoading();

    const nodeName = this.nodeSelectRef.current
      ? this.getSelectedNodeFilter()
      : "All Node";
    const techName = this.techSelectRef.current
      ? this.getSelectedTechFilter()
      : "กรุณาเลือก";
    const statusName = this.statusSelectRef.current
      ? this.getSelectedStatusFilter()
      : this.state.bookingStatusFilter;
    const calendarEvents = this.getFilteredCalendarEvents(
      this.state.baseCalendarEvents,
      nodeName,
      techName,
      "",
      statusName,
    );
    const returnDate = this.state.bookingSearchReturnDate;

    this.setState(
      {
        calendarEvents: this.cloneCalendarEvents(calendarEvents),
        bookingSearchText: "",
        bookingStatusFilter: statusName,
        bookingSearchReturnDate: null,
      },
      () => {
        this.hideCalendarLoading();

        if (returnDate && this.calendarComponentRef.current) {
          this.calendarComponentRef.current.getApi().gotoDate(returnDate);
        } else {
          this.loadVisibleCalendarReportReadiness(calendarEvents);
        }
      },
    );
  };

  onResetBookingFilters = () => {
    if (this.nodeSelectRef.current) {
      this.nodeSelectRef.current.value = "All Node";
      // Ignore an earlier node's customer lookup if it finishes after reset.
      this.customerRequestId = (this.customerRequestId || 0) + 1;
    }
    if (this.techSelectRef.current) {
      this.techSelectRef.current.value = "กรุณาเลือก";
    }

    this.setState(
      {
        bookingStatusFilter: "All Status",
        bookingSaleFilter: BOOKING_SALE_FILTER_ALL,
        bookingDoctorFilter: "",
        bookingCustomerFilter: "",
        bookingPostConsultTechFilter: "",
        bookingPostConsultDoctorFilter: "",
        bookingReportFilter: "all",
        ...(this.nodeSelectRef.current ? { customerList: [] } : {}),
      },
      this.onClearBookingSearch,
    );
  };

  onRemoveEvent = async (isExists) => {
    const calendarApi = this.calendarComponentRef.current
      ? this.calendarComponentRef.current.getApi()
      : null;
    const preserveDate = calendarApi ? calendarApi.getDate() : null;
    const rawEventTmp = this.state.eventTmp;
    const eventTmp = ensureBookingEventDraft(rawEventTmp);
    const eventProps = eventTmp.extendedProps || {};

    const removeTemporaryEvent = () => {
      this.removeCalendarEventState(eventTmp, preserveDate);
      if (rawEventTmp && rawEventTmp.remove) {
        try {
          rawEventTmp.remove();
        } catch (err) {
          console.warn("Unable to remove temporary booking event:", err);
        }
      }
    };

    if (isExists !== true) {
      removeTemporaryEvent();
      return;
    }

    if (!this.canManageBookingDeletion()) {
      notifyError("Only super_admin and admin can delete a booking.");
      return false;
    }

    const bookingId = eventProps.uuid;
    const nodeIndex = this.state.nodeList.indexOf(eventProps.node);
    const nodeId = this.state.nodeIdDocs[nodeIndex];
    if (!bookingId || !nodeId) {
      notifyError(
        "Cannot delete this booking because its exact calendar record was not found. No fallback deletion was attempted.",
      );
      return false;
    }

    try {
      const response = await this.softDeleteBooking({ nodeId, bookingId });
      removeTemporaryEvent();
      swal("Booking moved to Recovery", {
        text:
          "The booking was removed from the calendar and kept with a recovery log.",
        icon: "success",
      });
      console.log("Booking recovery record:", response.data && response.data.recoveryId);
      return true;
    } catch (error) {
      console.error("Unable to move booking to recovery", error);
      notifyError(
        `Delete booking failed: ${(error && error.message) || error}`,
      );
      return false;
    }
  };

  handleMoveBookingToRecovery = async () => {
    if (this.state.isMovingBookingToRecovery) return;

    const eventTmp = ensureBookingEventDraft(this.state.eventTmp);
    const eventProps = eventTmp.extendedProps || {};
    const order = String(eventProps.order || eventTmp.title || "").trim() || "-";
    const patientName = [eventProps.firstname, eventProps.lastname]
      .map((name) => String(name || "").trim())
      .filter(Boolean)
      .join(" ") || "-";
    const willMove = await swal({
      title: `Move ${order} to Booking Recovery?`,
      text: `It will leave the calendar, but it can be restored with its deletion log.\n ${patientName}`,
      icon: "warning",
      buttons: ["Cancel", "Move to Recovery"],
      dangerMode: true,
    });

    if (!willMove || !this._isMounted || this.state.isMovingBookingToRecovery) {
      return;
    }

    await new Promise((resolve) => {
      this.setState(
        {
          isMovingBookingToRecovery: true,
          bookingRecoveryProgressData: { order, patientName },
        },
        resolve,
      );
    });

    try {
      const moved = await this.onRemoveEvent(true);
      if (moved && this._isMounted) {
        this.onHideEditEventModal(true);
      }
    } finally {
      if (this._isMounted) {
        this.setState({
          isMovingBookingToRecovery: false,
          bookingRecoveryProgressData: {
            order: "-",
            patientName: "-",
          },
        });
      }
    }
  };

  onMovePastEmptyHnBookingsToRecovery = async () => {
    if (!this.isSuperAdmin()) {
      notifyError(
        "Only super_admin can move past empty-HN bookings to Recovery.",
      );
      return;
    }

    if (this.state.pastEmptyHnCleanupStatus) return;

    const calendarApi = this.calendarComponentRef.current
      ? this.calendarComponentRef.current.getApi()
      : null;
    const preserveDate = calendarApi ? calendarApi.getDate() : null;

    this.setState({ pastEmptyHnCleanupStatus: "checking" });
    try {
      const countResponse = await this.getPastEmptyHnBookingCount();
      const countData = (countResponse && countResponse.data) || {};
      const pastEmptyHnCount = Number(countData.pastEmptyHnCount) || 0;
      const todayStartMilliseconds = Number(countData.todayStartMilliseconds);
      const todayDate = Number.isFinite(todayStartMilliseconds)
        ? new Date(todayStartMilliseconds + 7 * 60 * 60 * 1000)
            .toISOString()
            .slice(0, 10)
        : this.getLocalCalendarDateString();

      if (!pastEmptyHnCount) {
        await swal("No past empty-HN bookings found", {
          text: `Empty-HN bookings dated today (${todayDate}) are kept in the Booking Calendar.`,
          icon: "info",
        });
        return;
      }

      const confirmed = await swal({
        title: `Move ${pastEmptyHnCount} empty-HN booking${
          pastEmptyHnCount === 1 ? "" : "s"
        } to Recovery?`,
        text:
          `Only empty-HN bookings dated before today (${todayDate}, Asia/Bangkok) will be moved. ` +
          "Today's and future bookings will stay in the Booking Calendar. Every moved booking keeps its full recovery copy and audit record.",
        icon: "warning",
        buttons: ["Cancel", "Move to Recovery"],
        dangerMode: true,
      });
      if (!confirmed) return;

      this.setState({
        pastEmptyHnCleanupStatus: "moving",
        isCalendarRefreshing: true,
      });
      const moveResponse = await this.movePastEmptyHnBookingsToRecovery();
      const moveData = (moveResponse && moveResponse.data) || {};
      const movedCount = Number(moveData.movedCount) || 0;
      const skippedCount = Number(moveData.skippedCount) || 0;
      const failedCount = Number(moveData.failedCount) || 0;
      const { start, end } = this.getCalendarRangeTimestamps();

      await this.fetchData(start, end);
      if (preserveDate && calendarApi) {
        calendarApi.gotoDate(preserveDate);
      }

      await swal(
        failedCount
          ? "Past empty-HN cleanup completed with errors"
          : "Past empty-HN bookings moved to Recovery",
        {
          text:
            `${movedCount} moved, ${skippedCount} skipped, ${failedCount} failed. ` +
            `Bookings dated today (${todayDate}) were kept.`,
          icon: failedCount ? "warning" : "success",
        },
      );
    } catch (error) {
      console.error(
        "Unable to move past empty-HN bookings to Recovery",
        error,
      );
      notifyError(
        `Past empty-HN cleanup failed: ${(error && error.message) || error}`,
      );
    } finally {
      if (this._isMounted) {
        this.setState({
          pastEmptyHnCleanupStatus: "",
          isCalendarRefreshing: false,
        });
      }
    }
  };

  onSearchPatient = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const searchedHN = normalizeBookingHn(this.getInputValue(this.hnRef));
    this.setInputValue(this.hnRef, searchedHN);
    const eventTmp = ensureBookingEventDraft(this.state.eventTmp);

    const q = query(
      collection(db, "patients"),
      where("hn", "==", searchedHN),
    );
    const querySnapshot = await getDocs(q);
    let listPatient = [];
    // console.log(querySnapshot);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      listPatient.push(doc.data());
    });

    const visiblePatients = filterRecordsByStaffCustomerAccess({
      records: listPatient,
      currentUser: this.context && this.context.currentUser,
      adminData: this.state.staffAdminProfile,
      nodes: this.state.allowedNodeDocs,
      getNodeValue: (patient) => patient.nodeRef,
      getCustomerValue: (patient) => patient.refCustomer,
    });

    if (listPatient.length > 0 && visiblePatients.length === 0) {
      notifyWarning("This patient is not available for your account");
      this.setState({ isNewPatient: false });
      return;
    }

    listPatient = visiblePatients;
    if (listPatient[0] == undefined) {
      const selectedNode = this.nodeRef.current ? this.nodeRef.current.value : "";
      const customerList = await this.ensureCustomersForNode(selectedNode);
      const defaultCustomer = this.state.isAddEventModal
        ? getDefaultBookingCustomer(selectedNode, customerList)
        : customerList[0] || "";
      eventTmp.setExtendedProp("hn", searchedHN);
      eventTmp.setExtendedProp("customer", defaultCustomer);
      this.setState(
        {
          customerList,
          eventTmp,
          isNewPatient: true,
        },
        () => {
          if (this.customerRef.current) {
            this.customerRef.current.value = defaultCustomer;
          }
        },
      );
    } else {
      console.log(listPatient[0]);
      // console.log(this.state.eventTmp.extendedProps.hn);
      const patient = listPatient[0];
      const patientInfo = {
        hn: normalizeBookingHn(patient.hn || searchedHN),
        firstname: patient.firstnameTh || patient.firstnameTH || patient.firstname || "",
        lastname: patient.lastnameTh || patient.lastnameTH || patient.lastname || "",
        nationalId: patient.nationalId || "",
        phone: patient.mobile || patient.phone || "",
        hospitalNumber: patient.refHn || patient.hospitalNumber || "",
        dateOfBirth: patient.dateOfBirth || "",
        gender: patient.gender || "",
        node: patient.nodeRef || "",
        customer: patient.refCustomer || "",
        stopBangScore: patient.stopBangScore || "",
        healthInsurance:
          !patient.healthInsurance || patient.healthInsurance === "please-select"
            ? "กรุณาเลือก"
            : patient.healthInsurance,
      };
      const bookingLocation = getPatientSearchBookingLocation(
        eventTmp,
        patientInfo,
      );
      const customerList = await this.ensureCustomersForNode(
        bookingLocation.node,
      );
      var getTmp = eventTmp;
      getTmp.setExtendedProp("hn", patientInfo.hn);
      getTmp.setExtendedProp("firstname", patientInfo.firstname);
      getTmp.setExtendedProp("lastname", patientInfo.lastname);
      getTmp.setExtendedProp("nationalId", patientInfo.nationalId);
      getTmp.setExtendedProp("phone", patientInfo.phone);
      getTmp.setExtendedProp("hospitalNumber", patientInfo.hospitalNumber);
      getTmp.setExtendedProp("dateOfBirth", patientInfo.dateOfBirth);
      getTmp.setExtendedProp("gender", patientInfo.gender);
      getTmp.setExtendedProp("node", bookingLocation.node);
      getTmp.setExtendedProp("customer", bookingLocation.customer);
      getTmp.setExtendedProp("stopBangScore", patientInfo.stopBangScore);
      getTmp.setExtendedProp("healthInsurance", patientInfo.healthInsurance);

      try {
        this.setInputValue(this.nodeRef, bookingLocation.node);
        this.setState(
          { customerList, eventTmp: getTmp, isNewPatient: false },
          () => {
            this.setInputValue(this.customerRef, bookingLocation.customer);
            this.setInputValue(this.firstnameRef, patientInfo.firstname);
            this.setInputValue(this.lastnameRef, patientInfo.lastname);
            this.setInputValue(this.nationalIdRef, patientInfo.nationalId);
            this.setInputValue(this.phoneRef, patientInfo.phone);
            this.setInputValue(
              this.hospitalNumberRef,
              patientInfo.hospitalNumber,
            );
            this.setInputValue(this.genderRef, patientInfo.gender);
            this.setInputValue(
              this.stopBangScoreRef,
              patientInfo.stopBangScore,
            );
            this.setInputValue(
              this.healthInsuranceRef,
              patientInfo.healthInsurance,
            );
          }
        );
      } catch (err) {
        // console.log(getTmp);
        this.setState({
          customerList,
          eventTmp: getTmp,
          isNewPatient: false,
        });
      }
    }
  };

  handleDate = (moment, props) => {
    let storeMoment = getLocalBookingDateString(moment);
    let evtmp = ensureBookingEventDraft(this.state.eventTmp);
    evtmp.setStart(storeMoment);
    evtmp.setEnd(getNextLocalBookingDateString(moment));
    this.setState({
      dateTmp: storeMoment,
      eventTmp: evtmp,
    });
  };

  handleTime = (moment, props) => {
    // console.log(moment.target.value);
    var evtmp = ensureBookingEventDraft(this.state.eventTmp);
    evtmp.setExtendedProp("time", moment.target.value);
    this.setState({ eventTmp: evtmp });
  };

  onHideAddEventModal = () => {
    this.setState({ items: [] }, () => {
      this.setState({ totalValue: 0 });
    });
    this.setState({ isAddEventModal: false });
    this.setState({ totalValue: 0 });
    this.onRemoveEvent(false);
  };

  onHideEditEventModal = (force = false) => {
    if (this.state.isMovingBookingToRecovery && !force) return false;

    this.editDropdownWheelSelect = null;
    this.editingEventSnapshot = null;
    this.eventClickRequestId = (this.eventClickRequestId || 0) + 1;
    this.setState({
      items: [],
      totalValue: 0,
      isEditEventModal: false,
      isNewPatient: false,
      isEditBookingDetail: false,
      isBookingPatientNotesLoading: false,
      modalBookingPatientNoteHn: "",
      modalBookingPatientNotes: [],
      bookingPatientNoteLoadError: "",
      bookingPatientNoteUploadingKey: "",
    });

    // console.log("Hide EditEvent");
    return true;
  };

  getEditModalSelect = (target) =>
    target && target.closest ? target.closest("select") : null;

  unlockEditDropdownWheel = (event) => {
    const select = this.getEditModalSelect(event.target);
    if (select) this.editDropdownWheelSelect = select;
  };

  relockEditDropdownWheel = (event) => {
    const select = this.getEditModalSelect(event.target);
    if (!select || this.editDropdownWheelSelect === select) {
      this.editDropdownWheelSelect = null;
    }
  };

  preventEditDropdownWheel = (event) => {
    const select = this.getEditModalSelect(event.target);
    if (!select) return;

    // Once the operator has deliberately clicked a dropdown, let its option
    // list use the mouse wheel normally. Choosing an option or leaving the
    // dropdown locks this again so page scrolling cannot change a value.
    if (this.editDropdownWheelSelect === select) return;

    // A focused native select can change its value on mouse wheel. Keep the
    // operator's scroll for reading the event details until they click it.
    event.preventDefault();
    if (document.activeElement === select) select.blur();

    const scrollContainer =
      event.currentTarget.closest(".modal") || event.currentTarget;
    scrollContainer.scrollTop += event.deltaY || 0;
  };

  onHideNoti = () => {
    this.setState({ items: [] }, () => {
      this.setState({ totalValue: 0 });
    });
    this.setState({ isNoti: false });
    this.setState({ isEditBookingDetail: false });
    // this.setState({ isEditBookingDetail: true });
  };

  getCurrentBookingUpdaterName = () => {
    const currentUser = this.context.currentUser || {};

    return currentUser.displayName || currentUser.email || "Unknown user";
  };

  handleDateChangeConfirm = (isConfirmed) => {
    const resolve = this._dateChangeConfirmResolve;
    this._dateChangeConfirmResolve = null;

    this.setState(
      {
        dateChangeConfirmVisible: false,
        dateChangeConfirmData: {
          order: "-",
          patientName: "-",
          oldDate: "-",
          oldStatus: "-",
          newDate: "-",
          newStatus: "-",
          updatedBy: "-",
        },
      },
      () => {
        if (resolve) resolve(isConfirmed);
      },
    );
  };

  showDateChangeConfirmModal = (confirmationData) =>
    new Promise((resolve) => {
      this._dateChangeConfirmResolve = resolve;
      this.setState({
        dateChangeConfirmVisible: true,
        dateChangeConfirmData: confirmationData,
      });
    });

  confirmBookingDateChangeWithUnchangedStatus = (
    oldEvent,
    newDate,
    newStatus,
  ) => {
    const oldEventProps = (oldEvent && oldEvent.extendedProps) || {};
    const patientName = [oldEventProps.firstname, oldEventProps.lastname]
      .map((name) => String(name || "").trim())
      .filter(Boolean)
      .join(" ");
    const confirmationData = getBookingDateChangeConfirmation({
      order: oldEventProps.order || (oldEvent && oldEvent.title),
      patientName,
      oldDate: oldEvent && (oldEvent.startStr || oldEvent.start),
      oldStatus: oldEventProps.status,
      newDate,
      newStatus,
      updatedBy: this.getCurrentBookingUpdaterName(),
    });

    if (!confirmationData) {
      return Promise.resolve(true);
    }

    return this.showDateChangeConfirmModal(confirmationData);
  };

  onAddEvent = async () => {
    // e.preventDefault();
    let errStatus = false;
    let eventAdd = this.state.eventTmp;
    // if (this.state.eventTmp.extendedProps.hn == "") {
    //   eventAdd.setExtendedProp("order", eventAdd.title);
    // } else {
    //   eventAdd.setExtendedProp("order", eventAdd.extendedProps.order);
    // }
    const currentUserName = this.getCurrentBookingUpdaterName();
    const bookingDate = getBookingEventDateInput(eventAdd, this.state.dateTmp);
    eventAdd.setStart(bookingDate.dateString);
    eventAdd.setEnd(getNextLocalBookingDateString(bookingDate.dateString));
    eventAdd.setExtendedProp("createBy", currentUserName);
    eventAdd.setExtendedProp("updatedBy", currentUserName);
    eventAdd.setExtendedProp("createdAt", new Date());
    eventAdd.setExtendedProp("updatedAt", new Date());

    const normalizedHn = normalizeBookingHn(this.hnRef.current.value);
    this.hnRef.current.value = normalizedHn;
    this.orderRef.current.value = this.orderRef.current.value.trim();

    eventAdd.setExtendedProp("order", this.orderRef.current.value);
    eventAdd.setExtendedProp("hn", normalizedHn);

    if (
      normalizedHn != "" &&
      normalizedHn !=
        normalizeBookingHn(this.state.eventTmp.extendedProps.hn)
    ) {
      eventAdd.setExtendedProp("updatedHN", new Date());
    }

    eventAdd.setExtendedProp("type", this.typeRef.current.value);
    eventAdd.setExtendedProp(
      "additionalEquipment",
      readBookingAdditionalEquipment(this.additionalEquipmentRefs, eventAdd.extendedProps.additionalEquipment),
    );
    eventAdd.setExtendedProp("node", this.nodeRef.current.value);
    eventAdd.setExtendedProp("customer", this.customerRef.current.value);
    eventAdd.setExtendedProp(
      "sale",
      this.getBookingSaleValueForSave(eventAdd.extendedProps.sale),
    );
    eventAdd.setExtendedProp("technician", this.techRef.current.value);
    eventAdd.setExtendedProp("doctor", this.docRef.current.value);
    eventAdd.setExtendedProp("referDoctor", this.referDocRef.current.value);
    eventAdd.setExtendedProp("postDoctor", this.postDoctorRef.current.value);
    eventAdd.setExtendedProp(
      "stopBangScore",
      this.stopBangScoreRef.current.value,
    );

    eventAdd.setExtendedProp("techrecord", this.techRecordRef.current.value);
    eventAdd.setExtendedProp("techConsult", this.techConsultRef.current.value);

    // set email
    eventAdd.setExtendedProp("email", false);

    eventAdd.setExtendedProp(
      "nationalId",
      this.getInputValue(this.nationalIdRef, eventAdd.extendedProps.nationalId),
    );
    eventAdd.setExtendedProp(
      "firstname",
      this.getInputValue(this.firstnameRef, eventAdd.extendedProps.firstname),
    );
    eventAdd.setExtendedProp(
      "lastname",
      this.getInputValue(this.lastnameRef, eventAdd.extendedProps.lastname),
    );
    eventAdd.setExtendedProp(
      "phone",
      this.getInputValue(this.phoneRef, eventAdd.extendedProps.phone),
    );
    eventAdd.setExtendedProp(
      "gender",
      this.getInputValue(this.genderRef, eventAdd.extendedProps.gender),
    );
    eventAdd.setExtendedProp(
      "hospitalNumber",
      this.getInputValue(
        this.hospitalNumberRef,
        eventAdd.extendedProps.hospitalNumber,
      ),
    );
    eventAdd.setProp(
      "title",
      eventAdd.extendedProps.order, // + " HN" + this.hnRef.current.value
    );
    eventAdd.setExtendedProp(
      "healthInsurance",
      this.healthInsuranceRef.current.value,
    );
    eventAdd.setExtendedProp("note", this.noteRef.current.value);
    eventAdd.setExtendedProp("items", this.state.items);
    eventAdd.setExtendedProp("totalValue", this.state.totalValue);

    eventAdd.setExtendedProp("status", this.statusRef.current.value);
    this.applyCalendarEventColor(eventAdd);

    if (this.statusRef.current.value === "Sleep Test Scheduled") {
      eventAdd.setExtendedProp("latestSleepStudyDate", bookingDate.dateString);
    }

    if (this.statusRef.current.value != "Post-Consult") {
      eventAdd.setExtendedProp("time", "");
    }

    eventAdd.setExtendedProp("ahi", this.ahiRef.current.value);
    // console.log("hn: ", eventAdd.extendedProps.hn);
    if (eventAdd.extendedProps.hn != "") {
      try {
        const refPatient = doc(db, "patients", eventAdd.extendedProps.hn);
        const docSnap = await getDoc(refPatient);
        if (docSnap.exists()) {
          const isOK = await this.setEvent(eventAdd, undefined, bookingDate.dateString);
          if (isOK) {
            this.setState({ eventTmp: eventAdd });
            this.setState({ isAddEventModal: false });
            this.setState({ isNewPatient: false });
            this.setState({ isNoti: true });
            notifyTopRight("Create success ");
          }
        } else {
          // console.log("eventAdd: ", eventAdd);
          const isOK = await this.setEvent(eventAdd, undefined, bookingDate.dateString);
          if (isOK) {
            this.setState({ eventTmp: eventAdd });
            this.setState({ isAddEventModal: false });
            this.setState({ isNewPatient: false });
            this.setState({ isNoti: true });
            notifyTopRight("Create success ");
          }
        }
      } catch (err) {
        console.log(err);
        this.setState({ isAddEventModal: false });
        this.setState({ isNewPatient: false });
        notifyError("Error, Please fill out the booking form");
        // this.onCancel(true);
        this.onRemoveEvent();
      }
    } else {
      const repeatTimes = Number(this.copyRef.current.value || 1);
      const api = this.calendarComponentRef.current.getApi();

      // เอาข้อมูลจาก eventAdd (EventApi) มาเป็น base (plain)
      const base = eventAdd.toPlainObject({ collapseExtendedProps: false });

      for (let i = 0; i < repeatTimes; i++) {
        const newId = `${Date.now()}-${i}`;

        // สร้าง event ใหม่ใน FullCalendar ก่อน (จะได้ EventApi ใหม่)
        const newEventApi = api.addEvent({
          ...base,
          id: newId,
          extendedProps: { ...(base.extendedProps || {}) },
        });

        // ✅ push “EventApi ตัวใหม่” เข้า Firebase (ให้ setEvent handle เอง)
        const isOK = await this.setEvent(newEventApi, undefined, bookingDate.dateString);

        if (!isOK) {
          newEventApi.remove(); // rollback ไม่ให้ค้างใน calendar
          break;
        }
      }

      // this.setState({ eventTmp: eventAdd });
      this.setState({ isAddEventModal: false });
      this.setState({ isNewPatient: false });
      this.setState({ isNoti: true });

      eventAdd.remove(); // ลบ event ต้นทางที่สร้างไว้ทิ้ง

      // const isOK = await this.setEvent(eventAdd);
      // if (isOK) {
      //   this.setState({ eventTmp: eventAdd });
      //   this.setState({ isAddEventModal: false });
      //   this.setState({ isNewPatient: false });
      //   this.setState({ isNoti: true });
      // }
    }
  };

  onEditEvent = async () => {
    if (this.state.isMovingBookingToRecovery || this.state.bookingPatientConflict) return;

    // console.log("onEditEvent");
    // e.preventDefault();
    let errStatus = false;
    // console.log(this.state.eventTmp.extendedProps.node);
    // console.log(this.nodeRef.current.value);
    let eventAdd = this.state.eventTmp;
    const originalEvent =
      this.editingEventSnapshot ||
      this.eventApiToCalendarEvent(eventAdd, this.state.resetDateTmp);

    if (
      this.isCurrentUserPartTimeSleepTechnician() &&
      this.state.isEditBookingDetail
    ) {
      const currentStatus =
        (originalEvent.extendedProps && originalEvent.extendedProps.status) ||
        eventAdd.extendedProps.status ||
        "";
      const selectedStatus = this.getInputValue(
        this.statusRef,
        currentStatus,
      );

      if (
        !canPartTimeTechnicianSetBookingStatus(
          selectedStatus,
          currentStatus,
        )
      ) {
        notifyError(
          "Part-time technicians can only update the permitted booking statuses.",
        );
        return;
      }

      const bookingDate = getBookingEventDateInput(
        eventAdd,
        this.state.dateTmp,
      );
      const selectedType = this.getInputValue(
        this.typeRef,
        eventAdd.extendedProps.type,
      );
      const selectedAdditionalEquipment = readBookingAdditionalEquipment(
        this.additionalEquipmentRefs,
        eventAdd.extendedProps.additionalEquipment,
      );
      const selectedRecordingTech = this.getInputValue(
        this.techRecordRef,
        eventAdd.extendedProps.techrecord,
      );
      const selectedScoringTech = this.getInputValue(
        this.techRef,
        eventAdd.extendedProps.technician,
      );
      const selectedPostConsultTech = this.getInputValue(
        this.techConsultRef,
        eventAdd.extendedProps.techConsult,
      );
      const selectedSale = this.getBookingSaleValueForSave(
        eventAdd.extendedProps.sale,
      );
      const selectedNote = this.getInputValue(
        this.noteRef,
        eventAdd.extendedProps.note,
      );
      const nodeIndex = this.state.nodeList.indexOf(eventAdd.extendedProps.node);
      const nodeId = this.state.nodeIdDocs[nodeIndex];
      const bookingId = eventAdd.extendedProps.uuid;

      if (!nodeId || !bookingId) {
        notifyError("Cannot update this booking because its calendar record was not found.");
        return;
      }

      const shouldContinue =
        await this.confirmBookingDateChangeWithUnchangedStatus(
          originalEvent,
          bookingDate.dateString,
          selectedStatus,
        );

      if (!shouldContinue) {
        return;
      }

      const oldEvent = {
        id: eventAdd.id,
        extendedProps: { ...eventAdd.extendedProps },
      };
      const statusUpdate = {
        start: bookingDate.date,
        end: getNextLocalBookingDateString(bookingDate.dateString),
        "extendedProps.status": selectedStatus,
        "extendedProps.type": selectedType,
        "extendedProps.additionalEquipment": selectedAdditionalEquipment,
        "extendedProps.techrecord": selectedRecordingTech,
        "extendedProps.technician": selectedScoringTech,
        "extendedProps.techConsult": selectedPostConsultTech,
        "extendedProps.sale": selectedSale,
        "extendedProps.note": selectedNote,
        "extendedProps.updatedBy": this.getCurrentBookingUpdaterName(),
        "extendedProps.updatedAt": new Date(),
      };

      if (selectedStatus === "Sleep Test Scheduled") {
        statusUpdate["extendedProps.latestSleepStudyDate"] =
          bookingDate.dateString;
      }

      try {
        const bookingRef = doc(db, "nodes", nodeId, "bookings", bookingId);
        await runTransaction(db, async (transaction) => {
          const latest = await transaction.get(bookingRef);
          assertScheduledBookingPatientUnchanged(originalEvent, latest.exists() ? latest.data() : null, eventAdd);
          transaction.update(bookingRef, statusUpdate);
        });

        eventAdd.setStart(bookingDate.dateString);
        eventAdd.setEnd(getNextLocalBookingDateString(bookingDate.dateString));
        eventAdd.setExtendedProp("status", selectedStatus);
        eventAdd.setExtendedProp("type", selectedType);
        eventAdd.setExtendedProp("additionalEquipment", selectedAdditionalEquipment);
        eventAdd.setExtendedProp("techrecord", selectedRecordingTech);
        eventAdd.setExtendedProp("technician", selectedScoringTech);
        eventAdd.setExtendedProp("techConsult", selectedPostConsultTech);
        eventAdd.setExtendedProp("sale", selectedSale);
        eventAdd.setExtendedProp("note", selectedNote);
        eventAdd.setExtendedProp(
          "updatedBy",
          statusUpdate["extendedProps.updatedBy"],
        );
        eventAdd.setExtendedProp(
          "updatedAt",
          statusUpdate["extendedProps.updatedAt"],
        );
        if (selectedStatus === "Sleep Test Scheduled") {
          eventAdd.setExtendedProp(
            "latestSleepStudyDate",
            bookingDate.dateString,
          );
        }
        this.applyCalendarEventColor(eventAdd);
        this.syncCalendarEventState(eventAdd, oldEvent);
        this.setState({
          eventTmp: eventAdd,
          isEditBookingDetail: false,
          isEditEventModal: false,
          isNewPatient: false,
          isNoti: true,
        });
        notifyTopRight("Booking updated");
      } catch (err) {
        if (this.showBookingPatientConflict(err, originalEvent)) return;
        console.error("Unable to update booking", err);
        notifyError("Unable to update booking.");
      }
      return;
    }

    let eventOld = JSON.parse(JSON.stringify(originalEvent));
    if (this.state.isEditBookingDetail == true) {
      const currentUserName = this.getCurrentBookingUpdaterName();
      const bookingDate = getBookingEventDateInput(eventAdd, this.state.dateTmp);
      const selectedStatus = this.getInputValue(
        this.statusRef,
        eventOld.extendedProps.status || "",
      );
      const shouldContinue =
        await this.confirmBookingDateChangeWithUnchangedStatus(
          eventOld,
          bookingDate.dateString,
          selectedStatus,
        );

      if (!shouldContinue) {
        return;
      }

      eventAdd.setStart(bookingDate.dateString);
      eventAdd.setEnd(getNextLocalBookingDateString(bookingDate.dateString));
      eventAdd.setExtendedProp(
        "createBy",
        eventAdd.extendedProps.createBy || currentUserName,
      );
      eventAdd.setExtendedProp("updatedBy", currentUserName);
      eventAdd.setExtendedProp(
        "createdAt",
        eventAdd.extendedProps.createdAt || null,
      );
      eventAdd.setExtendedProp("updatedAt", new Date());

      const normalizedHn = normalizeBookingHn(this.hnRef.current.value);
      this.hnRef.current.value = normalizedHn;
      this.orderRef.current.value = this.orderRef.current.value.trim();

      if (
        normalizedHn != "" &&
        normalizedHn != normalizeBookingHn(eventOld.extendedProps.hn)
      ) {
        eventAdd.setExtendedProp("updatedHN", new Date());
      }

      eventAdd.setExtendedProp("order", this.orderRef.current.value);
      eventAdd.setExtendedProp("hn", normalizedHn);
      eventAdd.setExtendedProp("type", this.typeRef.current.value);
      eventAdd.setExtendedProp(
        "additionalEquipment",
        readBookingAdditionalEquipment(this.additionalEquipmentRefs, eventAdd.extendedProps.additionalEquipment),
      );
      eventAdd.setExtendedProp("node", this.nodeRef.current.value);
      eventAdd.setExtendedProp("customer", this.customerRef.current.value);
      eventAdd.setExtendedProp(
        "sale",
        this.getBookingSaleValueForSave(eventOld.extendedProps.sale),
      );
      eventAdd.setExtendedProp("items", this.state.items);
      eventAdd.setExtendedProp("totalValue", this.state.totalValue);
      eventAdd.setExtendedProp("technician", this.techRef.current.value);
      eventAdd.setExtendedProp("doctor", this.docRef.current.value);
      eventAdd.setExtendedProp("referDoctor", this.referDocRef.current.value);
      eventAdd.setExtendedProp("postDoctor", this.postDoctorRef.current.value);
      eventAdd.setExtendedProp(
        "stopBangScore",
        this.stopBangScoreRef.current.value,
      );
      eventAdd.setExtendedProp("techrecord", this.techRecordRef.current.value);
      eventAdd.setExtendedProp(
        "techConsult",
        this.techConsultRef.current.value,
      );
      eventAdd.setExtendedProp(
        "nationalId",
        this.getInputValue(this.nationalIdRef, eventAdd.extendedProps.nationalId),
      );
      eventAdd.setExtendedProp(
        "firstname",
        this.getInputValue(this.firstnameRef, eventAdd.extendedProps.firstname),
      );
      eventAdd.setExtendedProp(
        "lastname",
        this.getInputValue(this.lastnameRef, eventAdd.extendedProps.lastname),
      );
      eventAdd.setExtendedProp(
        "phone",
        this.getInputValue(this.phoneRef, eventAdd.extendedProps.phone),
      );
      eventAdd.setExtendedProp(
        "gender",
        this.getInputValue(this.genderRef, eventAdd.extendedProps.gender),
      );
      eventAdd.setExtendedProp(
        "hospitalNumber",
        this.getInputValue(
          this.hospitalNumberRef,
          eventAdd.extendedProps.hospitalNumber,
        ),
      );
      eventAdd.setProp(
        "title",
        eventAdd.extendedProps.order, // + " HN" + this.hnRef.current.value
      );
      eventAdd.setExtendedProp(
        "healthInsurance",
        this.healthInsuranceRef.current.value,
      );
      eventAdd.setExtendedProp("note", this.noteRef.current.value);

      eventAdd.setExtendedProp("status", selectedStatus);
      this.applyCalendarEventColor(eventAdd);
      if (selectedStatus != "Post-Consult") {
        eventAdd.setExtendedProp("time", "");
      }

      if (selectedStatus === "Sleep Test Scheduled") {
        eventAdd.setExtendedProp("latestSleepStudyDate", bookingDate.dateString);
      }

      eventAdd.setExtendedProp("ahi", this.ahiRef.current.value);

      // add email
      eventAdd.setExtendedProp(
        "email",
        eventAdd.extendedProps.email ? eventAdd.extendedProps.email : false,
      );

      try {
        if (eventAdd.extendedProps.node != eventOld.extendedProps.node) {
          // console.log("change node");
          // change node
          const isOK = await this.setEvent(eventAdd, eventOld, bookingDate.dateString);
          if (isOK) {
            this.setState({
              eventTmp: createBookingEventDraft(
                this.eventApiToCalendarEvent(eventAdd, bookingDate.dateString),
              ),
            });
            this.setState({ isEditEventModal: false });
            this.setState({ isNewPatient: false });
            this.setState({ isNoti: true });
            notifyTopRight("Create success ");
          }
        } else {
          // console.log("same node");
          // same node
          // console.log(this.state.eventTmp.extendedProps.node);
          // console.log(eventAdd.extendedProps.node);
          // console.log(eventOld.extendedProps.node);

          const isOK = await this.setEvent(eventAdd, eventOld, bookingDate.dateString);
          if (isOK) {
            this.setState({
              eventTmp: createBookingEventDraft(
                this.eventApiToCalendarEvent(eventAdd, bookingDate.dateString),
              ),
            });
            this.setState({ isEditEventModal: false });
            this.setState({ isNewPatient: false });
            this.setState({ isNoti: true });
            notifyTopRight("Create success ");
          }
        }
      } catch (err) {
        console.log(err);
        this.setState({ isEditEventModal: false });
        this.setState({ isNewPatient: false });
        // this.setDefaultEvent(eventAdd);
        notifyError("Error, Please fill out the booking form !");
        this.onCancel(true);
      }
    } else {
      const isOK = await this.setState({ eventTmp: eventAdd });
      if (isOK) {
        this.setState({ isEditEventModal: false });
        this.setState({ isNewPatient: false });
        this.setState({ isNoti: true });
      }
    }
  };

  showBookingPatientConflict = (error, original) => {
    if (error.code !== "booking-patient-changed") return false;
    this.setState({ bookingPatientConflict: {
      comparison: error.comparison,
      original: { ...original, extendedProps: { ...original.extendedProps } },
    } });
    return true;
  };

  reloadBookingPatient = async () => {
    const conflict = this.state.bookingPatientConflict;
    if (!conflict || this.state.isReloadingBookingPatient) return;
    const original = conflict.original;
    const originalProps = original.extendedProps || {};
    const nodeId = this.state.nodeIdDocs[this.state.nodeList.indexOf(originalProps.node)];
    if (!nodeId || !originalProps.uuid) {
      notifyError("Cannot reload this booking because its original record was not found.");
      return;
    }
    this.setState({ isReloadingBookingPatient: true });
    try {
      const snapshot = await getDocFromServer(doc(db, "nodes", nodeId, "bookings", originalProps.uuid));
      if (!snapshot.exists()) {
        this.removeCalendarEventState(original);
        this.setState({ bookingPatientConflict: null });
        this.onHideEditEventModal();
        notifyWarning("This booking no longer exists. The calendar has been updated.");
        return;
      }
      const latest = this.normalizeBookingEvent(snapshot);
      const event = createBookingEventDraft(latest);
      this.syncCalendarEventState(event, original);
      // Remount only the editor to replace its uncontrolled input defaults.
      // Search, calendar filters and the current view remain in place.
      this.setState((state) => ({
        bookingPatientConflict: null,
        bookingEditorVersion: state.bookingEditorVersion + 1,
      }), () => this.eventClick({ event }));
    } catch (error) {
      notifyError("Unable to reload the latest booking. Your edits have not been saved. Please try again.");
    } finally {
      this.setState({ isReloadingBookingPatient: false });
    }
  };

  checkNewBookingNode = async (nodeName) => {
    const nodeIndex = this.state.nodeList.indexOf(nodeName);
    try {
      await assertNodeAcceptsNewBooking(this.state.nodeIdDocs[nodeIndex]);
      return true;
    } catch (error) {
      notifyError(error.code === "node-unavailable" ? error.message : "Unable to verify this node. Please try again.");
      return false;
    }
  };

  setEvent = async (eventAdd, oldEvent = undefined, selectedDate = undefined) => {
    if (oldEvent == undefined) {
      oldEvent = eventAdd;
    } else {
      console.log("oldEvent not undefined");
    }
    try {
      const bookingDate = getBookingEventDateInput(eventAdd, selectedDate);
      const singleDayEnd = getNextLocalBookingDateString(bookingDate.dateString);
      const isNodeMove =
        oldEvent &&
        oldEvent.extendedProps &&
        eventAdd.extendedProps &&
        eventAdd.extendedProps.uuid &&
        eventAdd.extendedProps.node !== oldEvent.extendedProps.node;

      if (isNodeMove && !this.canManageBookingDeletion()) {
        notifyError(
          "Only super_admin and admin can move a booking to another node.",
        );
        return false;
      }

      if ((!eventAdd.extendedProps.uuid || isNodeMove) &&
          !(await this.checkNewBookingNode(eventAdd.extendedProps.node))) {
        return false;
      }

      if (eventAdd.setEnd) {
        eventAdd.setEnd(singleDayEnd);
      } else {
        eventAdd.end = singleDayEnd;
      }

      // The activity trigger has no browser auth context. Preserve the
      // booking creator and save the actual operator separately for the
      // activity record it creates.
      if (eventAdd.extendedProps && eventAdd.extendedProps.uuid) {
        const updateActor = this.getCurrentBookingUpdaterName();
        const updatedAt = new Date();

        if (eventAdd.setExtendedProp) {
          eventAdd.setExtendedProp("updatedBy", updateActor);
          eventAdd.setExtendedProp("updatedAt", updatedAt);
        } else {
          eventAdd.extendedProps.updatedBy = updateActor;
          eventAdd.extendedProps.updatedAt = updatedAt;
        }
      }

      const isAssigned = ["Assigned", "Assigned to Doctor"].includes(
        eventAdd.extendedProps.status,
      );

      if (isAssigned) {
        const q = query(
          collectionGroup(db, "bookings"),
          where("extendedProps.order", "==", eventAdd.extendedProps.order),
          orderBy("start", "desc"),
          limit(1),
        );

        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const docData = querySnapshot.docs[0].data();
          const foundStatus = docData.extendedProps.status;

          if (["Assigned", "Assigned to Doctor"].includes(foundStatus)) {
            const sameAssignee =
              (foundStatus === "Assigned" &&
                docData.extendedProps.technician ===
                  eventAdd.extendedProps.technician) ||
              (foundStatus === "Assigned to Doctor" &&
                docData.extendedProps.doctor === eventAdd.extendedProps.doctor);

            if (!sameAssignee) {
              const proceed = await this.showConfirmModal(docData, eventAdd);
              if (!proceed) {
                this.setState({ eventTmp: docData });
                return false; // user clicked "No"
              }
            }
          }
        }
      }
      if (
        eventAdd.extendedProps.uuid == undefined ||
        eventAdd.extendedProps.uuid == null ||
        eventAdd.extendedProps.node != oldEvent.extendedProps.node
      ) {
        const nodeIndex = this.state.nodeList.indexOf(
          eventAdd.extendedProps.node,
        );
        const nodeId = this.state.nodeIdDocs[nodeIndex];
        const ref = doc(collection(db, "nodes", nodeId, "bookings"));
        const nextEventId = ref.id;
        // console.log("nodeId: ", nodeId);
        var updateData = {
          title: eventAdd.title,
          id: nextEventId,
          start: bookingDate.date,
          end: singleDayEnd,
          color: this.getCalendarEventColor(eventAdd),
          extendedProps: {
            ...getBookingExtendedPropsForSave(oldEvent.extendedProps),
            order: eventAdd.extendedProps.order
              ? eventAdd.extendedProps.order
              : "",
            hn: eventAdd.extendedProps.hn ? eventAdd.extendedProps.hn : "",
            type: eventAdd.extendedProps.type
              ? eventAdd.extendedProps.type
              : "",
            status: eventAdd.extendedProps.status,
            firstname: eventAdd.extendedProps.firstname
              ? eventAdd.extendedProps.firstname
              : "",
            lastname: eventAdd.extendedProps.lastname
              ? eventAdd.extendedProps.lastname
              : "",
            nationalId: eventAdd.extendedProps.nationalId
              ? eventAdd.extendedProps.nationalId
              : "",
            healthInsurance: eventAdd.extendedProps.healthInsurance,
            phone: eventAdd.extendedProps.phone
              ? eventAdd.extendedProps.phone
              : "",
            node: eventAdd.extendedProps.node,
            customer: eventAdd.extendedProps.customer,
            sale: eventAdd.extendedProps.sale || "",
            note: eventAdd.extendedProps.note
              ? eventAdd.extendedProps.note
              : "",
            items: eventAdd.extendedProps.items,
            totalValue: eventAdd.extendedProps.totalValue,
            time: eventAdd.extendedProps.time,
            doctor: eventAdd.extendedProps.doctor,
            referDoctor: eventAdd.extendedProps.referDoctor
              ? eventAdd.extendedProps.referDoctor
              : "",
            postDoctor: eventAdd.extendedProps.postDoctor
              ? eventAdd.extendedProps.postDoctor
              : "",
            stopBangScore: eventAdd.extendedProps.stopBangScore
              ? eventAdd.extendedProps.stopBangScore
              : "",
            technician: eventAdd.extendedProps.technician,
            techrecord: eventAdd.extendedProps.techrecord,
            techConsult: eventAdd.extendedProps.techConsult,

            latestSleepStudyDate: eventAdd.extendedProps.latestSleepStudyDate
              ? eventAdd.extendedProps.latestSleepStudyDate
              : bookingDate.dateString,
            ahi: eventAdd.extendedProps.ahi,
            additionalEquipment: normalizeBookingAdditionalEquipment(eventAdd.extendedProps.additionalEquipment),
            hospitalNumber: eventAdd.extendedProps.hospitalNumber
              ? eventAdd.extendedProps.hospitalNumber
              : "",
            createBy: eventAdd.extendedProps.createBy,
            updatedBy:
              eventAdd.extendedProps.updatedBy ||
              oldEvent.extendedProps.updatedBy ||
              "",
            createdAt: eventAdd.extendedProps.createdAt
              ? eventAdd.extendedProps.createdAt
              : null,
            updatedAt: eventAdd.extendedProps.updatedAt
              ? eventAdd.extendedProps.updatedAt
              : null,
            updatedHN: eventAdd.extendedProps.updatedHN
              ? eventAdd.extendedProps.updatedHN
              : null,
            gender: eventAdd.extendedProps.gender
              ? eventAdd.extendedProps.gender
              : "",
            email: eventAdd.extendedProps.email
              ? eventAdd.extendedProps.email
              : false,
            uuid: nextEventId,
          },
        };
        if (isNodeMove) {
          const sourceNodeId = this.state.nodeIdDocs[this.state.nodeList.indexOf(oldEvent.extendedProps.node)];
          if (!sourceNodeId) throw new Error("The original booking node could not be resolved.");
          const sourceRef = doc(db, "nodes", sourceNodeId, "bookings", oldEvent.extendedProps.uuid);
          await runTransaction(db, async (transaction) => {
            const latest = await transaction.get(sourceRef);
            assertScheduledBookingPatientUnchanged(oldEvent, latest.exists() ? latest.data() : null, eventAdd);
            transaction.set(ref, updateData);
          });
        } else {
          await setDoc(ref, updateData);
        }
        eventAdd.setProp("id", nextEventId);
        eventAdd.setExtendedProp("uuid", nextEventId);

        const refUpdate = doc(
          db,
          "nodes",
          nodeId,
          "bookings",
          nextEventId,
        );
        await updateDoc(refUpdate, {
          ...updateData,
          title: eventAdd.title,
          id: nextEventId,
          start: bookingDate.date,
          end: singleDayEnd,
          color: this.getCalendarEventColor(eventAdd),
          extendedProps: {
            ...updateData.extendedProps,
            order: eventAdd.extendedProps.order
              ? eventAdd.extendedProps.order
              : "",
            hn: eventAdd.extendedProps.hn ? eventAdd.extendedProps.hn : "",
            type: eventAdd.extendedProps.type,
            status: eventAdd.extendedProps.status,
            uuid: eventAdd.extendedProps.uuid,
            firstname: eventAdd.extendedProps.firstname
              ? eventAdd.extendedProps.firstname
              : "",
            lastname: eventAdd.extendedProps.lastname
              ? eventAdd.extendedProps.lastname
              : "",
            nationalId: eventAdd.extendedProps.nationalId
              ? eventAdd.extendedProps.nationalId
              : "",
            healthInsurance: eventAdd.extendedProps.healthInsurance,
            phone: eventAdd.extendedProps.phone
              ? eventAdd.extendedProps.phone
              : "",
            node: eventAdd.extendedProps.node,
            customer: eventAdd.extendedProps.customer,
            sale: eventAdd.extendedProps.sale || "",
            note: eventAdd.extendedProps.note
              ? eventAdd.extendedProps.note
              : "",
            items: eventAdd.extendedProps.items,
            totalValue: eventAdd.extendedProps.totalValue,
            time: eventAdd.extendedProps.time,
            doctor: eventAdd.extendedProps.doctor,
            referDoctor: eventAdd.extendedProps.referDoctor
              ? eventAdd.extendedProps.referDoctor
              : "",
            postDoctor: eventAdd.extendedProps.postDoctor
              ? eventAdd.extendedProps.postDoctor
              : "",
            stopBangScore: eventAdd.extendedProps.stopBangScore
              ? eventAdd.extendedProps.stopBangScore
              : "",
            technician: eventAdd.extendedProps.technician,
            techrecord: eventAdd.extendedProps.techrecord,
            techConsult: eventAdd.extendedProps.techConsult,
            latestSleepStudyDate: eventAdd.extendedProps.latestSleepStudyDate
              ? eventAdd.extendedProps.latestSleepStudyDate
              : bookingDate.dateString,
            ahi: eventAdd.extendedProps.ahi ? eventAdd.extendedProps.ahi : "",
            additionalEquipment: normalizeBookingAdditionalEquipment(eventAdd.extendedProps.additionalEquipment),
            hospitalNumber: eventAdd.extendedProps.hospitalNumber
              ? eventAdd.extendedProps.hospitalNumber
              : "",
            createBy: eventAdd.extendedProps.createBy,
            updatedBy:
              eventAdd.extendedProps.updatedBy ||
              oldEvent.extendedProps.updatedBy ||
              "",
            createdAt: eventAdd.extendedProps.createdAt
              ? eventAdd.extendedProps.createdAt
              : null,
            updatedAt: eventAdd.extendedProps.updatedAt
              ? eventAdd.extendedProps.updatedAt
              : null,
            updatedHN: eventAdd.extendedProps.updatedHN
              ? eventAdd.extendedProps.updatedHN
              : null,

            gender: eventAdd.extendedProps.gender
              ? eventAdd.extendedProps.gender
              : "",
            email: eventAdd.extendedProps.email
              ? eventAdd.extendedProps.email
              : false,
          },
        });

        if (eventAdd.extendedProps.node != oldEvent.extendedProps.node) {
          const nodeIndexOld = this.state.nodeList.indexOf(
            oldEvent.extendedProps.node,
          );
          const nodeIdOld = this.state.nodeIdDocs[nodeIndexOld];

          if (!nodeIdOld || !oldEvent.extendedProps.uuid) {
            throw new Error(
              "Cannot complete booking node move because the original booking record is missing.",
            );
          }

          await this.completeBookingNodeMove({
            sourceNodeId: nodeIdOld,
            sourceBookingId: oldEvent.extendedProps.uuid,
            destinationNodeId: nodeId,
            destinationBookingId: nextEventId,
          });
          console.log("booking moved from old node through protected workflow");
          //notify technician
          // if (
          //   eventAdd.extendedProps.status == "Sleep Test Scheduled" ||
          //   eventAdd.extendedProps.status == "Cancel" ||
          //   eventAdd.extendedProps.status == "Technician Scored"
          // ) {
          //   // this.setNotifyTech(eventAdd);
          // }
          // notify doctor
          if (
            eventAdd.extendedProps.status == "Assigned to Doctor" ||
            eventAdd.extendedProps.status == "Doctor Scored"
          ) {
            this.setNotifyDoctor(eventAdd);
          }
        }
      } else {
        const nodeIndex = this.state.nodeList.indexOf(
          eventAdd.extendedProps.node,
        );
        const nodeId = this.state.nodeIdDocs[nodeIndex];
        const refUpdate = doc(
          db,
          "nodes",
          nodeId,
          "bookings",
          eventAdd.extendedProps.uuid,
        );
        const savedExtendedProps = await runTransaction(db, async (transaction) => {
          const docSnap = await transaction.get(refUpdate);
          assertScheduledBookingPatientUnchanged(oldEvent, docSnap.exists() ? docSnap.data() : null, eventAdd);
          const latestExtendedProps = docSnap.exists()
            ? docSnap.data().extendedProps || {}
            : {};

          const updateData = {
          title: eventAdd.title,
          id: eventAdd.id,
          start: bookingDate.date,
          end: singleDayEnd,
          color: this.getCalendarEventColor(eventAdd),
          extendedProps: {
            ...getBookingExtendedPropsForSave(mergeBookingExtendedPropsWithAutomationState(
              oldEvent.extendedProps,
              latestExtendedProps,
              eventAdd.extendedProps.doctor,
              eventAdd.extendedProps.hn,
            )),
            order: eventAdd.extendedProps.order
              ? eventAdd.extendedProps.order
              : "",
            hn: eventAdd.extendedProps.hn ? eventAdd.extendedProps.hn : "",
            type: eventAdd.extendedProps.type,
            status: eventAdd.extendedProps.status,
            uuid: eventAdd.extendedProps.uuid,
            firstname: eventAdd.extendedProps.firstname
              ? eventAdd.extendedProps.firstname
              : "",
            lastname: eventAdd.extendedProps.lastname
              ? eventAdd.extendedProps.lastname
              : "",
            nationalId: eventAdd.extendedProps.nationalId
              ? eventAdd.extendedProps.nationalId
              : "",
            healthInsurance: eventAdd.extendedProps.healthInsurance,
            phone: eventAdd.extendedProps.phone
              ? eventAdd.extendedProps.phone
              : "",
            node: eventAdd.extendedProps.node,
            customer: eventAdd.extendedProps.customer,
            sale: eventAdd.extendedProps.sale || "",
            note: eventAdd.extendedProps.note
              ? eventAdd.extendedProps.note
              : "",
            items: eventAdd.extendedProps.items,
            totalValue: eventAdd.extendedProps.totalValue,
            time: eventAdd.extendedProps.time,
            doctor: eventAdd.extendedProps.doctor,
            referDoctor: eventAdd.extendedProps.referDoctor
              ? eventAdd.extendedProps.referDoctor
              : "",
            postDoctor: eventAdd.extendedProps.postDoctor
              ? eventAdd.extendedProps.postDoctor
              : "",
            stopBangScore: eventAdd.extendedProps.stopBangScore
              ? eventAdd.extendedProps.stopBangScore
              : "",
            technician: eventAdd.extendedProps.technician,
            techrecord: eventAdd.extendedProps.techrecord,
            techConsult: eventAdd.extendedProps.techConsult,
            latestSleepStudyDate:
              eventAdd.extendedProps.latestSleepStudyDate !== undefined
                ? eventAdd.extendedProps.latestSleepStudyDate
                : latestExtendedProps.latestSleepStudyDate,
            ahi: eventAdd.extendedProps.ahi ? eventAdd.extendedProps.ahi : "",
            additionalEquipment: normalizeBookingAdditionalEquipment(eventAdd.extendedProps.additionalEquipment),
            hospitalNumber: eventAdd.extendedProps.hospitalNumber
              ? eventAdd.extendedProps.hospitalNumber
              : "",
            createBy: eventAdd.extendedProps.createBy,
            updatedBy:
              eventAdd.extendedProps.updatedBy ||
              oldEvent.extendedProps.updatedBy ||
              "",
            createdAt: eventAdd.extendedProps.createdAt
              ? eventAdd.extendedProps.createdAt
              : null,
            updatedAt: eventAdd.extendedProps.updatedAt
              ? eventAdd.extendedProps.updatedAt
              : null,
            updatedHN: eventAdd.extendedProps.updatedHN
              ? eventAdd.extendedProps.updatedHN
              : null,

            gender: eventAdd.extendedProps.gender
              ? eventAdd.extendedProps.gender
              : "",
            email: eventAdd.extendedProps.email
              ? eventAdd.extendedProps.email
              : false,
          },
          };

          if (eventAdd.extendedProps.hn !== latestExtendedProps.hn) {
            updateData.extendedProps.dateOfBirth = eventAdd.extendedProps.dateOfBirth || "";
            if (Object.prototype.hasOwnProperty.call(updateData.extendedProps, "dob")) updateData.extendedProps.dob = updateData.extendedProps.dateOfBirth;
          }
          transaction.update(refUpdate, updateData);
          return updateData.extendedProps;
        });
        ["dateOfBirth", "dob"].forEach(field => {
          if (savedExtendedProps && Object.prototype.hasOwnProperty.call(savedExtendedProps, field)) eventAdd.setExtendedProp(field, savedExtendedProps[field]);
        });
        //notify technician
        // if (
        //   eventAdd.extendedProps.status == "Sleep Test Scheduled" ||
        //   eventAdd.extendedProps.status == "Cancel" ||
        //   eventAdd.extendedProps.status == "Technician Scored"
        // ) {
        //   // this.setNotifyTech(eventAdd);
        // }
        // notify doctor
        if (
          eventAdd.extendedProps.status == "Assigned to Doctor" ||
          eventAdd.extendedProps.status == "Doctor Scored"
        ) {
          this.setNotifyDoctor(eventAdd);
        }
      }
      this.syncCalendarEventState(eventAdd, oldEvent, bookingDate.dateString);
      return true;
    } catch (err) {
      if (this.showBookingPatientConflict(err, oldEvent)) return false;
      console.error("Unable to save booking event:", err);
      notifyError(err.code === "technician-check-doctor-copy" ? err.message : "Unable to save booking. Please try again.");

      // A rejected create must not add an unsaved event back to the calendar.
      if (!oldEvent.extendedProps.uuid) return false;

      if (!this.calendarComponentRef.current) {
        this.setState({ eventTmp: createBookingEventDraft(oldEvent) });
        return false;
      }

      let api = this.calendarComponentRef.current.getApi();
      api.addEvent({
        title: oldEvent.title,
        start: oldEvent.startStr,
        id: oldEvent.id,
        allDay: true,
        color: this.getCalendarEventColor(oldEvent),
        extendedProps: {
          ...oldEvent.extendedProps,
          order: oldEvent.extendedProps.order,
          hn: oldEvent.extendedProps.hn,
          type: oldEvent.extendedProps.type,
          status: oldEvent.extendedProps.status,
          firstname: oldEvent.extendedProps.firstname,
          lastname: oldEvent.extendedProps.lastname,
          nationalId: oldEvent.extendedProps.nationalId,
          healthInsurance: oldEvent.extendedProps.healthInsurance,
          phone: oldEvent.extendedProps.phone,
          note: oldEvent.extendedProps.note,
          node: oldEvent.extendedProps.node,
          customer: oldEvent.extendedProps.customer,
          sale: oldEvent.extendedProps.sale || "",
          items: oldEvent.extendedProps.items,
          totalValue: oldEvent.extendedProps.totalValue,
          time: oldEvent.extendedProps.time,
          doctor: oldEvent.extendedProps.doctor,
          referDoctor: oldEvent.extendedProps.referDoctor,
          postDoctor: oldEvent.extendedProps.postDoctor,
          stopBangScore: oldEvent.extendedProps.stopBangScore,
          technician: oldEvent.extendedProps.technician,
          techrecord: oldEvent.extendedProps.techrecord,
          techConsult: oldEvent.extendedProps.techConsult,
          ahi: oldEvent.extendedProps.ahi,
          hospitalNumber: oldEvent.extendedProps.hospitalNumber,
          gender: oldEvent.extendedProps.gender
            ? oldEvent.extendedProps.gender
            : "",

          createBy: oldEvent.extendedProps.createBy
            ? oldEvent.extendedProps.createBy
            : "",
          createdAt: oldEvent.extendedProps.createdAt
            ? oldEvent.extendedProps.createdAt
            : null,
          updatedAt: oldEvent.extendedProps.updatedAt
            ? oldEvent.extendedProps.updatedAt
            : null,
          updatedHN: oldEvent.extendedProps.updatedHN
            ? oldEvent.extendedProps.updatedHN
            : null,

          gender: oldEvent.extendedProps.gender
            ? oldEvent.extendedProps.gender
            : "",
          email: oldEvent.extendedProps.email
            ? oldEvent.extendedProps.email
            : false,
        },
      });
      eventAdd.remove();
      return false;
    }
  };
  setDefaultEvent = (eventInput) => {
    let api = this.calendarComponentRef.current.getApi();
    api.addEvent({
      title: eventInput.title,
      start: eventInput.startStr,
      id: eventInput.id,
      allDay: true,
      color: this.getCalendarEventColor(eventInput),
      extendedProps: {
        ...eventInput.extendedProps,
        order: eventInput.extendedProps.order,
        hn: eventInput.extendedProps.hn,
        type: eventInput.extendedProps.type,
        status: eventInput.extendedProps.status,
        firstname: eventInput.extendedProps.firstname,
        lastname: eventInput.extendedProps.lastname,
        nationalId: eventInput.extendedProps.nationalId,
        healthInsurance: eventInput.extendedProps.healthInsurance,
        phone: eventInput.extendedProps.phone,
        note: eventInput.extendedProps.note,
        node: eventInput.extendedProps.node,
        customer: eventInput.extendedProps.customer,
        sale: eventInput.extendedProps.sale || "",
        items: eventInput.extendedProps.items,
        totalValue: eventInput.extendedProps.totalValue,
        time: eventInput.extendedProps.time,
        doctor: eventInput.extendedProps.doctor,
        referDoctor: eventInput.extendedProps.referDoctor,
        postDoctor: eventInput.extendedProps.postDoctor,
        stopBangScore: eventInput.extendedProps.stopBangScore,
        technician: eventInput.extendedProps.technician,
        techrecord: eventInput.extendedProps.techrecord,
        techConsult: eventInput.extendedProps.techConsult,
        ahi: eventInput.extendedProps.ahi,
        hospitalNumber: eventInput.extendedProps.hospitalNumber,
        createBy: eventInput.extendedProps.createBy
          ? eventInput.extendedProps.createBy
          : "",
        createdAt: eventInput.extendedProps.createdAt
          ? eventInput.extendedProps.createdAt
          : null,
        updatedAt: eventInput.extendedProps.updatedAt
          ? eventInput.extendedProps.updatedAt
          : null,
        updatedHN: eventInput.extendedProps.updatedHN
          ? eventInput.extendedProps.updatedHN
          : null,
        gender: eventInput.extendedProps.gender
          ? eventInput.extendedProps.gender
          : "",
        email: eventInput.extendedProps.email
          ? eventInput.extendedProps.email
          : false,
      },
    });
    eventInput.remove();
  };
  setNotifyDoctor = async (event) => {
    console.log("setNotifyDoctor called");
    const sleepstudyInfo = {
      title: event.title,
      date: event.startStr,
      status: event.extendedProps.status,
      type: event.extendedProps.type,
      firstname: event.extendedProps.firstname,
      lastname: event.extendedProps.lastname,
      doctor: event.extendedProps.doctor,
      note: event.extendedProps.note,
      node: event.extendedProps.node,
      latestSleepStudyDate: event.extendedProps.latestSleepStudyDate,
      createBy:
        event.extendedProps.updatedBy || event.extendedProps.createBy || "",
    };
    const statusToCheck = sleepstudyInfo.status;
    const titleToCheck = sleepstudyInfo.title;
    const currentDoctorId = sleepstudyInfo.doctor; // Assuming this contains the current doctor's ID
    console.log("sleepstudyInfo: ", sleepstudyInfo);
    // Create a collection group query to find sleep study cases with the same title
    const matchingTitlesQuery = query(
      collectionGroup(db, "sleepStudyCases"),
      where("title", "==", titleToCheck),
    );
    const querySnapshot = await getDocs(matchingTitlesQuery);
    if (statusToCheck == "Doctor Scored") {
      if (querySnapshot.empty) {
        console.log("no matching documents found !");
      } else {
        for (const doc of querySnapshot.docs) {
          // Delete the document
          await deleteDoc(doc.ref);
          console.log(`Deleted sleep study case with title "${titleToCheck}" `);
        }
      }
    } else if (statusToCheck == "Assigned to Doctor") {
      if (querySnapshot.empty) {
        console.log("no matching documents found !");
      } else {
        for (const doc of querySnapshot.docs) {
          // Check if the document is under a different doctor
          const docDoctorId = doc.ref.path.split("/")[1]; // Extracting doctor ID from the document reference path
          console.log("currentId: ", currentDoctorId);
          console.log("docDoctorId: ", docDoctorId);
          if (docDoctorId !== currentDoctorId) {
            // Delete the document
            await deleteDoc(doc.ref);
            console.log(
              `Deleted sleep study case with title "${titleToCheck}" under a different doctor (ID: ${docDoctorId}).`,
            );
          }
        }
      }
      const DoctorsQuery = query(
        collection(db, "doctors"),
        where("name", "==", sleepstudyInfo.doctor),
      );
      const DoctorDocuments = await getDocs(DoctorsQuery);
      var DoctorList = [];
      DoctorDocuments.forEach(async (document) => {
        const doctorId = document.id;
        const doctorInfo = document.data();
        const doctorEmail = doctorInfo.email || "";
        // console.log(doctorId)
        // console.log(doctorInfo);

        const sleepStudyCasesCollectionRef = doc(
          collection(db, `doctors/${doctorId}/sleepStudyCases`),
        );
        await setDoc(sleepStudyCasesCollectionRef, sleepstudyInfo);
        const message = `\n${sleepstudyInfo.title} : ${sleepstudyInfo.firstname} ${sleepstudyInfo.lastname} \nStudy Date : ${sleepstudyInfo.latestSleepStudyDate} \n${sleepstudyInfo.type} \n${sleepstudyInfo.status} \nBy: ${sleepstudyInfo.createBy}`;
        const accessToken = doctorInfo.accessToken;
        // console.log("querySnapshot: ", querySnapshot);
        // const formattedMessage = message.replace(/\n/g, "<br>");
        // const subject = sleepstudyInfo.title;

        if (querySnapshot.empty) {
          try {
            await this.sendNotification({ accessToken, message });
          } catch (err) {
            console.error("Failed to send notification:", err);
            // Optionally show UI message or retry logic here
          }

          try {
            await this.handleSendSubmitDoctor(doctorEmail, sleepstudyInfo);
          } catch (err) {
            console.error("Failed to send to doctor:", err);
            // Optional fallback logic
          }
        } else {
          console.log("Sleep study case already exists for this title.");
        }
      });
    }
  };

  handleConfirm = (isConfirmed) => {
    const resolve = this._confirmResolve;
    this._confirmResolve = null;

    this.setState(
      {
        confirmVisible: false,
        confirmData: {
          order: "-",
          patientName: "-",
          oldStatus: "-",
          newStatus: "-",
          oldTechnician: "Not selected",
          newTechnician: "Not selected",
          oldDoctor: "Not selected",
          newDoctor: "Not selected",
          statusChanged: false,
          technicianChanged: false,
          doctorChanged: false,
          previousUpdatedBy: "Unknown user",
          updatedBy: "Unknown user",
        },
      },
      () => {
        if (resolve) resolve(isConfirmed);
      },
    );
  };

  showConfirmModal = (existingData, currentData) =>
    new Promise((resolve) => {
      this._confirmResolve = resolve;
      this.setState({
        confirmVisible: true,
        confirmData: getBookingAssignmentConfirmationData(
          existingData,
          currentData,
          this.getCurrentBookingUpdaterName(),
        ),
      });
    });

  showConfirmUploadModal = (message) => {
    return new Promise((resolve) => {
      this.setState({
        confirmUploadModal: {
          show: true,
          message,
          resolver: resolve,
        },
      });
    });
  };

  handleConfirmYes = () => {
    const resolver = this.state.confirmUploadModal.resolver;
    if (resolver) resolver(true);

    this.setState({
      confirmUploadModal: { show: false, message: "", resolver: null },
    });
  };

  handleConfirmNo = () => {
    const resolver = this.state.confirmUploadModal.resolver;
    if (resolver) resolver(false);

    this.setState({
      confirmUploadModal: { show: false, message: "", resolver: null },
    });
  };

  handleSendSubmitDoctor = async (email, sleepstudyInfo) => {
    const text = {
      to: `${email}`,
      message: {
        subject: `${sleepstudyInfo.title} : ${sleepstudyInfo.firstname} ${sleepstudyInfo.lastname}`,
        html: `
        <div style="border:1px solid gray; padding:1rem; background-color:#eeeeee;">
          <table cellpadding="2" cellspacing="0" style="border-collapse: collapse;">
            <tr>
              <td><strong>SleepStudy No</strong></td>
              <td>${sleepstudyInfo.title}</td>
            </tr>
            <tr>
              <td><strong>Full Name</strong></td>
              <td>${sleepstudyInfo.firstname} ${sleepstudyInfo.lastname}</td>
            </tr>
            <tr>
              <td><strong>Date </br>(YYYY-MM-DD)</strong></td>
              <td>${sleepstudyInfo.latestSleepStudyDate}</td>
            </tr>
            <tr>
              <td><strong>Type</strong></td>
              <td>${sleepstudyInfo.type}</td>
            </tr>
            <tr>
              <td><strong>Status</strong></td>
              <td>${sleepstudyInfo.status}</td>
            </tr>
            <tr>
              <td><strong>By</strong></td>
              <td>${sleepstudyInfo.createBy}</td>
            </tr>
          </table>
          <hr style="border: 0; height: 1px; background: #555; margin-top: 1rem;" />
          <p style="margin-top: 1rem;">
            Best regards,<br/>
            sleepcare@braindynamics.co.th
          </p>
        </div>
      `,
      },
    };

    const mail = await setDoc(doc(collection(db, "mail")), text);
    console.log("mail: ", mail);
  };

  setNotifyTech = async (event) => {
    const sleepstudyInfo = {
      title: event.title,
      date: getLocalBookingDateString(event.start),
      status: event.extendedProps.status,
      type: event.extendedProps.type,
      firstname: event.extendedProps.firstname,
      lastname: event.extendedProps.lastname,
      techrecord: event.extendedProps.techrecord,
      techConsult: event.extendedProps.techConsult,

      note: event.extendedProps.note,
      node: event.extendedProps.node,
      customer: event.extendedProps.customer,
      healthInsurance: event.extendedProps.healthInsurance,
      phone: event.extendedProps.phone,
    };
    const statusToCheck = sleepstudyInfo.status;
    const titleToCheck = sleepstudyInfo.title;
    const currentTechId = sleepstudyInfo.techrecord; // Assuming this contains the current doctor's ID
    //Create a collection group query to find sleep study cases with the same title
    const matchingTitlesQuery = query(
      collectionGroup(db, "sleepStudyCases"),
      where("title", "==", titleToCheck),
    );
    const querySnapshot = await getDocs(matchingTitlesQuery);
    if (statusToCheck == "Assigned to Doctor") {
      if (querySnapshot.empty) {
        console.log("no matching documents found !");
      } else {
        for (const doc of querySnapshot.docs) {
          // Delete the document
          await deleteDoc(doc.ref);
          console.log(`Deleted sleep study case with title "${titleToCheck}" `);
        }
      }
    } else if (statusToCheck == "Sleep Test Scheduled") {
      if (querySnapshot.empty) {
        console.log("no matching documents found !");
      } else {
        for (const doc of querySnapshot.docs) {
          // Check if the document is under a different doctor
          const docTechId = doc.ref.path.split("/")[1]; // Extracting doctor ID from the document reference path
          if (docTechId !== currentTechId) {
            // Delete the document
            await deleteDoc(doc.ref);
            console.log(
              `Deleted sleep study case with title "${titleToCheck}" under a different doctor (ID: ${docTechId}).`,
            );
          }
        }
      }
      const TechQuery = query(
        collection(db, "sleeptechnicians"),
        where("name", "==", sleepstudyInfo.techrecord),
      );
      const TechDocuments = await getDocs(TechQuery);
      var TechList = [];
      TechDocuments.forEach(async (document) => {
        const techId = document.id;
        const techInfo = document.data();

        const sleepStudyCasesCollectionRef = doc(
          collection(db, `sleeptechnicians/${techId}/sleepStudyCases`),
        );
        await setDoc(sleepStudyCasesCollectionRef, sleepstudyInfo);
        const message = `\nเคสตรวจการนอนหลับที่ ${sleepstudyInfo.customer} \nStudy Date: ${sleepstudyInfo.date}\nSleep Technician: ${sleepstudyInfo.techrecord}
         \n${sleepstudyInfo.title}: ${sleepstudyInfo.firstname} ${sleepstudyInfo.lastname} \nTel: ${sleepstudyInfo.phone} \nHealth Insurance: ${sleepstudyInfo.healthInsurance} \n${sleepstudyInfo.type} \n${sleepstudyInfo.status}`;
        const accessToken = techInfo.accessToken;
        if (querySnapshot.empty) {
          this.sendNotification({ accessToken, message });
        }
      });
    } else if (statusToCheck == "Cancel") {
      for (const doc of querySnapshot.docs) {
        // Delete the document
        await deleteDoc(doc.ref);
        console.log(`Deleted sleep study case with title "${titleToCheck}" `);
      }
      const TechQuery = query(
        collection(db, "sleeptechnicians"),
        where("name", "==", sleepstudyInfo.techrecord),
      );
      const TechDocuments = await getDocs(TechQuery);
      TechDocuments.forEach(async (document) => {
        const techInfo = document.data();
        const accessToken = techInfo.accessToken;
        const message =
          "Cancel เคสตรวจการนอนหลับที่ " +
          sleepstudyInfo.customer +
          "\nวันที่ " +
          sleepstudyInfo.date +
          "\n" +
          sleepstudyInfo.title +
          ": " +
          sleepstudyInfo.firstname +
          " " +
          sleepstudyInfo.lastname;
        this.sendNotification({ accessToken, message });
      });
    }
  };

  eventDrop = async (eventDrop) => {
    console.log("eventDrop: ", eventDrop);
    const eventApi = eventDrop.event;
    const getEventApiValue = (key, fallback = "") => {
      try {
        return eventApi ? eventApi[key] || fallback : fallback;
      } catch (err) {
        return fallback;
      }
    };
    const draggedEventData = eventDrop.draggedEl
      ? buildExternalBookingEventData(eventDrop.draggedEl)
      : {};
    let eventProps = {};
    let startValue = "";
    let endValue = null;
    try {
      eventProps = { ...(eventApi.extendedProps || {}) };
      startValue = eventApi.startStr || eventApi.start || "";
      endValue = eventApi.end || null;
    } catch (err) {
      console.warn("Unable to read received booking event props:", err);
    }
    const startDateString = startValue
      ? getLocalBookingDateString(startValue)
      : "";

    const eventDraft = createBookingEventDraft({
      ...draggedEventData,
      title: draggedEventData.title || getEventApiValue("title"),
      id: draggedEventData.id || getEventApiValue("id"),
      start: startDateString,
      startStr: startDateString,
      end: endValue,
      color: draggedEventData.color || "green",
      extendedProps: {
        ...(draggedEventData.extendedProps || {}),
        ...eventProps,
      },
    });

    try {
      if (eventApi && eventApi.remove) {
        eventApi.remove();
      }
    } catch (err) {
      console.warn("Unable to remove temporary received booking event:", err);
    }

    let nodeName = eventDraft.extendedProps.node || this.getSelectedNodeFilter();

    if (!nodeName || nodeName === "All Node") {
      nodeName = this.state.nodeList[0] || "";
    }

    if (nodeName) {
      eventDraft.setExtendedProp("node", nodeName);
    }
    if (!(await this.checkNewBookingNode(nodeName))) return;
    eventDraft.setExtendedProp("customer", "");

    const customerList = await this.ensureCustomersForNode(nodeName);
    const defaultCustomer = getDefaultBookingCustomer(nodeName, customerList);

    eventDraft.setExtendedProp("customer", defaultCustomer);

    this.setState(
      {
        eventTmp: eventDraft,
        customerList,
        dateTmp: startDateString,
        resetDateTmp: startDateString,
        isEditBookingDetail: !eventDraft.extendedProps.hn,
        isAddEventModal: true,
        isNewPatient: false,
      },
      () => {
        if (this.nodeRef.current) {
          this.nodeRef.current.value = nodeName;
        }
        if (this.customerRef.current) {
          this.customerRef.current.value = defaultCustomer;
        }
      },
    );
  };

  onCreateEventToday = async () => {
    const calendarApi =
      this.calendarComponentRef.current &&
      this.calendarComponentRef.current.getApi();

    if (!calendarApi) {
      notifyWarning("Calendar is not ready");
      return;
    }

    const today = this.getLocalCalendarDateString();
    let nodeName = this.getSelectedNodeFilter();

    if (!nodeName || nodeName === "All Node") {
      nodeName = this.state.nodeList[0] || "";
    }

    if (!nodeName) {
      notifyWarning("Please add node before creating booking");
      return;
    }

    if (!(await this.checkNewBookingNode(nodeName))) return;

    const customerList = await this.ensureCustomersForNode(nodeName);
    const defaultCustomer = getDefaultBookingCustomer(nodeName, customerList);
    const status = "Sleep Test Scheduled";
    const eventApi = calendarApi.addEvent({
      id: `new-booking-${Date.now()}`,
      title: "",
      start: today,
      allDay: true,
      color: this.getColorForStatus(status),
      extendedProps: {
        order: "",
        hn: "",
        type: "",
        status,
        firstname: "",
        lastname: "",
        nationalId: "",
        healthInsurance: "กรุณาเลือก",
        phone: "",
        note: "",
        node: nodeName,
        customer: defaultCustomer,
        sale: "",
        items: [],
        totalValue: 0,
        time: "",
        technician: "",
        doctor: "",
        referDoctor: "",
        postDoctor: "",
        techrecord: "",
        sleepDate: "",
        stopBangScore: "",
        techConsult: "",
        ahi: "",
        additionalEquipment: [],
        hospitalNumber: "",
        gender: "",
      },
    });

    this.setState(
      {
        eventTmp: eventApi,
        customerList,
        items: [],
        totalValue: 0,
        dateTmp: today,
        resetDateTmp: today,
        isEditBookingDetail: true,
        isAddEventModal: true,
        isNewPatient: false,
      },
      () => {
        if (this.nodeRef.current) {
          this.nodeRef.current.value = nodeName;
        }
        if (this.customerRef.current) {
          this.customerRef.current.value = defaultCustomer;
        }
      },
    );
  };

  eventDrag = (eventDrag) => {
    let api = this.calendarComponentRef.current.getApi();
    var allEvents = api.getEvents().filter((obj) => {
      return (
        obj.startStr === eventDrag.event.startStr && obj.extendedProps.hn !== ""
      );
    });
    let listHNEvent = allEvents.filter((element) => {
      return element.extendedProps.hn === eventDrag.event.extendedProps.hn;
    });
    // let isExists = false;
    // if (listHNEvent.length > 1) {
    //   isExists = true;
    // }
    if (listHNEvent.length > 1) {
      swal({
        title: `HN${eventDrag.event.extendedProps.hn} is already booking on this day !`,
        text: `Please recheck booking on ${eventDrag.event.startStr}`,
        icon: "warning",
        buttons: ["Cancel", "Confirm"],
        dangerMode: true,
      }).then((willBooking) => {
        if (willBooking) {
          this.setState({ eventTmp: eventDrag.event });
          this.setEvent(this.state.eventTmp, eventDrag.oldEvent);
        } else {
          var colorEvent = "";
          var indexOfStatusList = this.statusList.findIndex(
            (obj) => obj === eventDrag.oldEvent.extendedProps.status,
          );
          colorEvent = this.colorList[indexOfStatusList];
          api.addEvent({
            title: eventDrag.oldEvent.title,
            start: eventDrag.oldEvent.startStr,
            id: eventDrag.oldEvent.id,
            allDay: true,
            color: colorEvent,
            extendedProps: {
              order: eventDrag.oldEvent.extendedProps.order,
              hn: eventDrag.oldEvent.extendedProps.hn,
              type: eventDrag.oldEvent.extendedProps.type,
              status: eventDrag.oldEvent.extendedProps.status,
              firstname: eventDrag.oldEvent.extendedProps.firstname,
              lastname: eventDrag.oldEvent.extendedProps.lastname,
              nationalId: eventDrag.oldEvent.extendedProps.nationalId,
              healthInsurance: eventDrag.oldEvent.extendedProps.healthInsurance,
              phone: eventDrag.oldEvent.extendedProps.phone,
              note: eventDrag.oldEvent.extendedProps.note,
              node: eventDrag.oldEvent.extendedProps.node,
              customer: eventDrag.oldEvent.extendedProps.customer,
              sale: eventDrag.oldEvent.extendedProps.sale || "",
              items: eventDrag.oldEvent.extendedProps.items,
              totalValue: eventDrag.oldEvent.extendedProps.totalValue,
              time: eventDrag.oldEvent.extendedProps.time,
              doctor: eventDrag.oldEvent.extendedProps.doctor,
              referDoctor: eventDrag.oldEvent.extendedProps.referDoctor,
              postDoctor: eventDrag.oldEvent.extendedProps.postDoctor,
              stopBangScore: eventDrag.oldEvent.extendedProps.stopBangScore,
              technician: eventDrag.oldEvent.extendedProps.technician,
              techrecord: eventDrag.oldEvent.extendedProps.techrecord,
              techConsult: eventDrag.oldEvent.extendedProps.techConsult,
              ahi: eventDrag.oldEvent.extendedProps.ahi,
              additionalEquipment: normalizeBookingAdditionalEquipment(
                eventDrag.oldEvent.extendedProps.additionalEquipment,
              ),
              hospitalNumber: eventDrag.oldEvent.extendedProps.hospitalNumber,
              createBy: eventDrag.oldEvent.extendedProps.createBy
                ? eventDrag.oldEvent.extendedProps.createBy
                : "",
              gender: eventDrag.oldEvent.extendedProps.gender
                ? eventDrag.oldEvent.extendedProps.gender
                : "",
              email: eventDrag.oldEvent.extendedProps.email
                ? eventDrag.oldEvent.extendedProps.email
                : false,
            },
          });
          eventDrag.event.remove();
        }
      });
    } else {
      this.setState({ eventTmp: eventDrag.event });
      this.setEvent(this.state.eventTmp, eventDrag.oldEvent);
    }
  };

  CustomerList = (nodename) => {
    const index = this.state.nodeList.indexOf(nodename);
    return this.state.customerAllList[index] || [];
  };

  openBookingEventModal = (eventApi, eventProps, eventDateString) => {
    const cachedCustomerList = this.CustomerList(eventProps.node);
    const hn = String(eventProps.hn || "").trim();
    const hasHn = Boolean(hn);
    const cachedReports = this.getCachedBookingReports(hn, eventProps);
    const hasCachedReportSnapshot = this.hasCachedBookingReportSnapshot(
      hn,
      eventProps,
    );

    this.editingEventSnapshot = this.eventApiToCalendarEvent(
      eventApi,
      eventDateString,
    );

    if (hasCachedReportSnapshot) {
      // The calendar readiness check already fetched this HN, including the
      // "no report files" result. Render that snapshot immediately instead
      // of making the operator wait for a second Storage lookup.
      eventApi.setExtendedProp(
        "reports",
        cachedReports.length ? cachedReports : null,
      );
    }

    this.setState({
      eventTmp: eventApi,
      dateTmp: eventDateString,
      resetDateTmp: eventDateString,
      isEditBookingDetail: eventProps.hn === "",
      isDatetime: eventProps.status === "Post-Consult",
      isEditEventModal: true,
      isNewPatient: false,
      items: JSON.parse(JSON.stringify(eventProps.items || [])),
      totalValue: eventProps.totalValue || 0,
      customerList: cachedCustomerList,
      isBookingReportLoading: hasHn && !hasCachedReportSnapshot,
      modalBookingReportHn: hn,
      modalBookingReports: this.cloneBookingReportRows(cachedReports),
      isBookingPatientNotesLoading: hasHn,
      modalBookingPatientNoteHn: hn,
      modalBookingPatientNotes: [],
      bookingPatientNoteLoadError: "",
      bookingPatientNoteUploadingKey: "",
    });
  };

  getStorageOnlyBookingReports = async (
    hn,
    reportIds = [],
    includeAllFolders = false,
  ) => {
    const normalizedHn = String(hn || "").trim();
    const knownReportIds = Array.from(
      new Set(
        (Array.isArray(reportIds) ? reportIds : [])
          .map((reportId) => String(reportId || "").trim())
          .filter(Boolean),
      ),
    );
    let reportFolders = knownReportIds.map((reportId) =>
      ref(storage, `reports/${normalizedHn}/${reportId}`),
    );

    // Normal uploads always have a Firestore document ID, so checking those
    // folders avoids listing every historic report folder for this patient.
    // The caller can request a root scan afterward for legacy files whose
    // original report document no longer exists.
    if (reportFolders.length === 0 || includeAllFolders) {
      const reportRoot = await listAll(ref(storage, `reports/${normalizedHn}`));
      reportFolders = reportRoot.prefixes;
    }

    const reportRows = await Promise.all(
      reportFolders.map(async (reportFolder) => {
        const folderFiles = await listAll(reportFolder);
        const reportFile = folderFiles.items
          .map((fileRef) => fileRef.name)
          .filter(Boolean);

        if (reportFile.length === 0) return null;

        return {
          id: reportFolder.name,
          hn,
          reportFile,
          storageOnly: true,
        };
      }),
    );

    return reportRows.filter(Boolean);
  };

  loadBookingEventDetails = async (eventApi, eventProps, requestId) => {
    try {
      // Match the normalized patient document ID used by the calendar
      // readiness query. Booking records can contain accidental whitespace.
      const hn = String(eventProps.hn || "").trim();

      if (hn) {
        const reportRef = collection(db, "patients", hn, "report");
        const patientNoteRef = collection(db, "patients", hn, "note");
        const loadReports = async () => {
          try {
            const reportSnap = await getDocs(reportRef);

            if (this.eventClickRequestId !== requestId) return;

            const firestoreReports = reportSnap.docs.map((d) => ({
              id: d.id,
              ...d.data(),
            }));
            const cachedReports = this.getCachedBookingReports(hn, eventProps);
            const reports = mergeBookingReportRows(
              firestoreReports,
              cachedReports,
            );
            const applyReports = (nextReports) => {
              if (this.eventClickRequestId !== requestId) return false;

              const reportSnapshot = this.cloneBookingReportRows(nextReports);

              eventApi.setExtendedProp(
                "reports",
                reportSnapshot.length ? reportSnapshot : null,
              );
              this.updateCalendarReportReadiness(
                eventApi,
                reportSnapshot,
                false,
              );
              this.setState({
                eventTmp: eventApi,
                isBookingReportLoading: false,
                modalBookingReportHn: hn,
                modalBookingReports: reportSnapshot,
              });

              return true;
            };

            // Firestore is the normal, fast path. A complete response can be
            // shown immediately. If it is incomplete, Storage is the source
            // of truth for legacy uploads; keep the modal in a checking state
            // until that read finishes instead of falsely showing "not pass".
            if (this.isBookingReportListReady(reports, eventProps)) {
              applyReports(reports);
              return;
            }

            eventApi.setExtendedProp(
              "reports",
              reports.length ? reports : null,
            );
            this.setState({
              eventTmp: eventApi,
              isBookingReportLoading: true,
              modalBookingReportHn: hn,
              modalBookingReports: this.cloneBookingReportRows(reports),
            });

            const recoverStorageReports = async () => {
              const reportIds = reports.map((report) => report.id);
              const knownFolderReports = await this.getStorageOnlyBookingReports(
                hn,
                reportIds,
              );
              let recoveredReports = mergeBookingReportRows(
                reports,
                knownFolderReports,
              );

              // Some older uploads were left in a Storage folder whose
              // Firestore report document was later removed or recreated.
              // If the known document folders do not complete the checklist,
              // search the patient's other report folders before marking the
              // event as failed.
              if (
                reportIds.length > 0 &&
                !this.isBookingReportListReady(recoveredReports, eventProps)
              ) {
                const legacyFolderReports = await this.getStorageOnlyBookingReports(
                  hn,
                  [],
                  true,
                );
                recoveredReports = mergeBookingReportRows(
                  recoveredReports,
                  legacyFolderReports,
                );
              }

              return recoveredReports;
            };

            recoverStorageReports()
              .then((recoveredReports) => {
                applyReports(recoveredReports);
              })
              .catch((storageError) => {
                console.warn(
                  "Unable to recover booking report files from Storage:",
                  storageError,
                );
                applyReports(reports);
              });
          } catch (error) {
            if (this.eventClickRequestId === requestId) {
              this.setState({ isBookingReportLoading: false });
            }
            console.error("Error loading booking report files:", error);
          }
        };

        const loadSleepStudy = async () => {
          try {
            const sleepstudy = await loadPatientSleepStudyFiles(hn);

            if (this.eventClickRequestId !== requestId) return;

            eventApi.setExtendedProp(
              "sleepstudy",
              sleepstudy.length ? sleepstudy : null,
            );
            this.setState({ eventTmp: eventApi });
          } catch (error) {
            // Sleep Study Data is optional to the report view. Keep a failed
            // lookup from hiding report files that loaded successfully.
            console.error("Error loading booking sleep study files:", error);
          }
        };

        const loadPatientNotes = async () => {
          try {
            const noteSnapshot = await getDocs(patientNoteRef);

            if (this.eventClickRequestId !== requestId) return;

            const notes = noteSnapshot.docs.map((noteDoc) => ({
              id: noteDoc.id,
              ...noteDoc.data(),
              hn: String(noteDoc.data().hn || hn).trim(),
            }));

            this.setState({
              isBookingPatientNotesLoading: false,
              modalBookingPatientNoteHn: hn,
              modalBookingPatientNotes: notes,
              bookingPatientNoteLoadError: "",
            });
          } catch (error) {
            if (this.eventClickRequestId !== requestId) return;

            console.error("Error loading booking patient notes:", error);
            this.setState({
              isBookingPatientNotesLoading: false,
              modalBookingPatientNoteHn: hn,
              modalBookingPatientNotes: [],
              bookingPatientNoteLoadError:
                "Unable to check patient notes. Please try again.",
            });
          }
        };

        await Promise.all([
          loadReports(),
          loadSleepStudy(),
          loadPatientNotes(),
        ]);
      }

      if (this.eventClickRequestId !== requestId) return;

      const customerList = await this.ensureCustomersForNode(eventProps.node);

      if (this.eventClickRequestId !== requestId) return;

      this.setState({
        eventTmp: eventApi,
        customerList,
      });

      if (!eventProps.order || !hn) return;

      const mailRef = collection(db, "mail");
      const querySnapshot = query(
        mailRef,
        where("order", "==", eventProps.order),
        where("hn", "==", hn),
        orderBy("delivery.endTime", "desc"),
      );
      const mailSnapshot = await getDocs(querySnapshot);

      if (this.eventClickRequestId !== requestId || mailSnapshot.empty) {
        return;
      }

      const firstMail = mailSnapshot.docs[0];
      const mailData = firstMail.data();
      const endTimeDate = mailData.delivery.endTime.toDate();
      const day = String(endTimeDate.getDate()).padStart(2, "0");
      const month = String(endTimeDate.getMonth() + 1).padStart(2, "0");
      const year = endTimeDate.getFullYear();
      const formattedDate = `${year}-${month}-${day}`;

      eventApi.setExtendedProp("email", true);
      eventApi.setExtendedProp("lastestMail", formattedDate);
      this.setState({ eventTmp: eventApi });
    } catch (error) {
      if (this.eventClickRequestId === requestId) {
        this.setState({
          isBookingReportLoading: false,
          isBookingPatientNotesLoading: false,
        });
      }
      console.error("Error loading booking event details:", error);
    }
  };

  eventClick = (eventClick) => {
    const eventApi = eventClick.event;
    const eventProps = eventApi.extendedProps || {};
    const eventDateString = this.getCalendarEventDateString(eventApi);
    const requestId = (this.eventClickRequestId || 0) + 1;
    this.eventClickRequestId = requestId;

    this.openBookingEventModal(eventApi, eventProps, eventDateString);
    this.loadBookingEventDetails(eventApi, eventProps, requestId);
  };

  onCancel = (isClear = false) => {
    this.setState({ isEditBookingDetail: false });
    // this.setState({ isEditBookingDetail: true });
    let evtmp = this.state.eventTmp;
    if (isClear) {
      evtmp.setProp("title", this.state.eventTmp.extendedProps.order);
      evtmp.setProp("id", this.state.eventTmp.id);
      evtmp.setExtendedProp("order", this.state.eventTmp.extendedProps.order);
      evtmp.setExtendedProp("hn", "");
      evtmp.setExtendedProp("firstname", "");
      evtmp.setExtendedProp("lastname", "");
      evtmp.setExtendedProp("nationalId", "");
      evtmp.setExtendedProp("healthInsurance", "กรุณาเลือก");
      evtmp.setExtendedProp("phone", "");
      evtmp.setProp("color", "green");
      evtmp.setProp("backgroundColor", "green");
      evtmp.setProp("borderColor", "green");
    }

    evtmp.setStart(this.state.resetDateTmp);
    evtmp.setEnd(getNextLocalBookingDateString(this.state.resetDateTmp));
    this.setState({ eventTmp: evtmp });
  };
  onUpdateItemValue = (key, index, value) => {
    var tmpItems = this.state.items;
    tmpItems[index][key] = value.target.value;
    tmpItems[index].total =
      tmpItems[index].unitcost * tmpItems[index].qty - tmpItems[index].discount;

    this.setState({ items: tmpItems }, () => {
      this.getTotalValue();
    });
  };
  getTotalValue = () => {
    var totalValueTmp = 0;
    var tmpItems = this.state.items;
    for (let i = 0; i < tmpItems.length; i++) {
      totalValueTmp = parseInt(totalValueTmp) + parseInt(tmpItems[i].total);
    }
    this.setState({ totalValue: totalValueTmp });
  };
  checkStatus = (e) => {
    if (e.target.value == "Post-Consult") {
      this.setState({ isDatetime: true });
    } else {
      this.setState({ isDatetime: false });
    }
  };

  handleOnClick = async (hn, id, file) => {
    const reportHn = String(hn || "").trim();
    const reportId = String(id || "").trim();
    const fileName = String(file || "").trim();

    if (!reportHn || !reportId || !fileName) {
      notifyError("Cannot open report file: missing file information");
      return;
    }

    this.setState({
      fileUrl: null,
      createModal: false,
      filePreviewTitle: "Report",
      filePreviewType: "document",
    });

    try {
      const result = await this.getSignedUrl({
        folder: "reports",
        hn: reportHn,
        id: reportId,
        filename: fileName,
      });
      const fileUrl = result && result.data;

      if (!fileUrl) {
        throw new Error("The report file URL was empty.");
      }

      this.setState({
        fileUrl,
        createModal: true,
        filePreviewTitle: "Report",
        filePreviewType: "document",
      });
    } catch (error) {
      console.error("Unable to open booking report file", error);
      notifyError("Cannot open report file. Please try again.");
    }
  };

  getBookingFilePreviewType = (fileName) => {
    const extension = String(fileName || "")
      .split(".")
      .pop()
      .toLowerCase();

    return ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(
      extension,
    )
      ? "image"
      : "document";
  };

  handlePatientNoteFileClick = async (file) => {
    const patientHn = String(file.hn || "").trim();
    const noteId = String(file.id || "").trim();
    const fileName = String(file.fileName || "").trim();

    if (!patientHn || !noteId || !fileName) {
      notifyError("Cannot open patient note file: missing file information");
      return;
    }

    this.setState({
      fileUrl: null,
      createModal: false,
      filePreviewTitle: file.title || "Patient Note",
      filePreviewType: this.getBookingFilePreviewType(fileName),
    });

    try {
      const result = await this.getSignedUrl({
        folder: "files",
        hn: patientHn,
        id: noteId,
        filename: fileName,
      });
      const fileUrl = result && result.data;

      if (!fileUrl) {
        throw new Error("The patient note file URL was empty.");
      }

      this.setState({ fileUrl, createModal: true });
    } catch (error) {
      console.error("Unable to open booking patient note file", error);
      notifyError("Cannot open patient note file. Please try again.");
    }
  };

  canUploadBookingPatientNotes = () => {
    const currentUser = (this.context && this.context.currentUser) || {};
    const currentRoles = Array.isArray(currentUser.roles)
      ? currentUser.roles
      : [];

    return currentRoles.some((role) =>
      [
        "super_admin",
        "admin",
        "sale",
        "accountant",
        "staff",
        "sleep_technician",
      ].includes(role),
    );
  };

  handlePatientNoteUploadButtonClick = (partKey) => {
    const inputRef = this.patientNoteFileInputRefs[partKey];

    if (inputRef && inputRef.current) {
      inputRef.current.click();
    }
  };

  handlePatientNoteFileChange = async (event, partKey) => {
    const input = event.target;
    const files = Array.from((input && input.files) || []).filter(Boolean);

    if (input) input.value = "";
    if (files.length === 0) return;

    if (!this.canUploadBookingPatientNotes()) {
      notifyError("You do not have permission to upload patient note files");
      return;
    }

    const part = BOOKING_PATIENT_NOTE_PARTS.find(
      (candidate) => candidate.key === partKey,
    );
    const eventProps =
      (this.state.eventTmp && this.state.eventTmp.extendedProps) || {};
    const hn = String(eventProps.hn || "").trim();

    if (!part || !hn) {
      notifyError("Cannot upload patient note file: patient HN is missing");
      return;
    }

    let noteDocRef = null;
    let createdNote = false;
    let metadataSaved = false;
    const uploadedFileRefs = [];

    this.setState({ bookingPatientNoteUploadingKey: part.key });

    try {
      Alert.fire({
        title: `Uploading ${part.label}...`,
        text: `${files.length} file${files.length === 1 ? "" : "s"}`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Alert.showLoading(),
      });

      // Re-read before writing so an operator does not create a duplicate
      // title when another page added the note after this modal opened.
      const latestNotes = await this.fetchBookingPatientNotes(hn);
      const matchingNotes = latestNotes.filter(
        (note) =>
          normalizeBookingPatientNoteTitle(note.title) ===
          part.normalizedTitle,
      );
      const targetNote =
        matchingNotes.find(
          (note) => getBookingPatientNoteFileNames(note).length === 0,
        ) || matchingNotes[0];
      const existingFileNames = targetNote
        ? getBookingPatientNoteFileNames(targetNote)
        : [];
      const uploadEntries = buildUniqueNoteFileEntries(
        files,
        existingFileNames,
      );
      const now = new Date();

      if (targetNote) {
        noteDocRef = doc(db, "patients", hn, "note", targetNote.id);
      } else {
        noteDocRef = doc(collection(db, "patients", hn, "note"));
        createdNote = true;
        await setDoc(noteDocRef, {
          title: part.label,
          detail: "",
          filename: [],
          hn,
          createBy:
            (this.context.currentUser &&
              this.context.currentUser.displayName) ||
            "",
          updateAt: null,
          createAt: now,
        });
      }

      for (const { file, fileName } of uploadEntries) {
        const fileRef = ref(storage, `files/${hn}/${noteDocRef.id}/${fileName}`);
        await uploadBytes(fileRef, file);
        uploadedFileRefs.push(fileRef);
      }

      await updateDoc(noteDocRef, {
        filename: [
          ...existingFileNames,
          ...uploadEntries.map((entry) => entry.fileName),
        ],
        updateAt: now,
      });
      metadataSaved = true;

      await this.refreshBookingPatientNotes(hn);
      Alert.close();
      notifyTopRight(`${part.label} uploaded`);
    } catch (error) {
      console.error(`Unable to upload ${part.label}`, error);

      if (!metadataSaved) {
        for (const uploadedFileRef of uploadedFileRefs) {
          try {
            await deleteObject(uploadedFileRef);
          } catch (cleanupError) {
            console.warn("Unable to clean up patient note upload", cleanupError);
          }
        }

        if (createdNote && noteDocRef) {
          try {
            await deleteDoc(noteDocRef);
          } catch (cleanupError) {
            console.warn("Unable to clean up empty patient note", cleanupError);
          }
        }
      }

      Alert.close();
      if (metadataSaved) {
        notifyWarning(
          `${part.label} was uploaded, but the checklist could not refresh. Reopen this booking to check it.`,
        );
      } else {
        notifyError(`Cannot upload ${part.label}. Please try again.`);
      }
    } finally {
      if (this._isMounted) {
        this.setState({ bookingPatientNoteUploadingKey: "" });
      }
    }
  };

  handleButtonClick = () => {
    this.fileInputRef.current.click();
  };

  handleStudyButtonClick = (uploadType = UNSCORED_SLEEP_STUDY_UPLOAD_TYPE) => {
    const inputRef = uploadType === SCORED_SLEEP_STUDY_UPLOAD_TYPE
      ? this.fileInputScoredStudyRef
      : this.fileInputStudyRef;
    if (inputRef.current) inputRef.current.click();
  };

  getBookingUploadPath = (event = this.state.eventTmp) => {
    const eventProps = (event && event.extendedProps) || {};
    const bookingId = eventProps.uuid;
    const nodeIndex = this.state.nodeList.indexOf(eventProps.node);
    const nodeId = this.state.nodeIdDocs[nodeIndex];

    return nodeId && bookingId
      ? `nodes/${nodeId}/bookings/${bookingId}`
      : "";
  };

  // Function to handle file selection
  // handleFileChange = (e) => {
  //   console.log("file change");
  //   console.log(
  //     "current eventTmp order:",
  //     this.state.eventTmp.extendedProps.order
  //   );
  //   // const file = event.target.files[0];
  //   // console.log('Selected file:', file.name);  // Process the file as needed
  //   let files = [];

  //   for (let i = 0; i < e.target.files.length; i++) {
  //     const f = e.target.files[i];
  //     files.push(f);
  //     // setSelectedFiles((prevState) => [...prevState, f]);
  //     // setFilenames((prevState) => [...prevState, f.name]);
  //   }
  //   const report = {
  //     hn: this.state.eventTmp.extendedProps.hn,
  //     createBy: this.context.currentUser.displayName,
  //     createAt: new Date(),
  //   };
  //   this.startAddReport(report, files);
  // };

  // handleFileChange = async (e, type) => {
  //   console.log("file change");

  //   const rawOrder = this.state.eventTmp.extendedProps.order || "";
  //   let order = rawOrder.toUpperCase();

  //   // --- Remove trailing _1 _2 _3 ...
  //   // Example: ABC_1 → ABC
  //   const cleanedOrder = order.replace(/_\d+$/, "");
  //   order = cleanedOrder;

  //   console.log("final order:", order);

  //   // collect files
  //   const files = [];
  //   for (let i = 0; i < e.target.files.length; i++) {
  //     files.push(e.target.files[i]);
  //   }

  //   // --- Check filenames for order ---
  //   const missingOrder = files.some(
  //     (f) => !f.name.toUpperCase().includes(order),
  //   );

  //   console.log("missingOrder:", missingOrder);

  //   if (missingOrder) {
  //     // Show modal → wait for user response
  //     const proceed = await this.showConfirmUploadModal(
  //       `Some files do NOT contain order "${order}". Continue?`,
  //     );

  //     if (!proceed) return;

  //     if (proceed) {
  //       // --- Build report ---
  //       const report = {
  //         hn: this.state.eventTmp.extendedProps.hn,
  //         createBy: this.context.currentUser.displayName,
  //         createAt: new Date(),
  //       };
  //       console.log("type: ", type);

  //       // Continue upload

  //       this.startAddReport(report, files, type);
  //     }
  //   } else {
  //     // --- Build report ---
  //     const report = {
  //       hn: this.state.eventTmp.extendedProps.hn,
  //       createBy: this.context.currentUser.displayName,
  //       createAt: new Date(),
  //     };
  //     console.log("type: ", type);

  //     // Continue upload
  //     this.startAddReport(report, files, type);
  //   }
  // };

  handleFileChange = async (e, type, uploadType = UNSCORED_SLEEP_STUDY_UPLOAD_TYPE) => {
    try {
      console.log("file change");

      const eventProps = this.state.eventTmp.extendedProps || {};
      const rawOrder = eventProps.order || "";
      let order = rawOrder.toUpperCase();

      // Remove trailing _1 _2 _3 ...
      const cleanedOrder = order.replace(/_\d+$/, "");
      order = cleanedOrder;

      console.log("final order:", order);

      // collect files
      const files = [];
      for (let i = 0; i < e.target.files.length; i++) {
        files.push(e.target.files[i]);
      }

      // Check filenames for order
      const missingOrder = files.some(
        (f) => !f.name.toUpperCase().includes(order),
      );

      console.log("missingOrder:", missingOrder);

      const report = {
        hn: eventProps.hn,
        ...buildSleepstudyUploadMetadata(
          type === "sleepstudy" ? eventProps : {},
          this.context.currentUser,
          type === "sleepstudy" ? this.getBookingUploadPath() : "",
          "booking_calendar",
          type === "sleepstudy" ? uploadType : "",
        ),
      };

      if (missingOrder) {
        const proceed = await this.showConfirmUploadModal(
          `Some files do NOT contain order "${order}". Continue?`,
        );

        if (!proceed) return;

        console.log("type: ", type);
        await this.startAddReport(report, files, type);
      } else {
        console.log("type: ", type);
        await this.startAddReport(report, files, type);
      }
    } finally {
      if (this.fileInputRef.current) this.fileInputRef.current.value = "";
      if (this.fileInputStudyRef.current) this.fileInputStudyRef.current.value = "";
      if (this.fileInputScoredStudyRef.current) this.fileInputScoredStudyRef.current.value = "";
    }
  };

  // handleSendEmail = async (eventClick) => {
  //   // console.log(event);
  //       const customersRef = collectionGroup(
  //     db,
  //     "customers",
  //     // eventClick.event.extendedProps.customer
  //   );
  //   // console.log("eventClick", eventClick);
  //   const customerSnap = await getDocs(customersRef);
  //   // console.log(customerSnap)
  //   console.log("Searching for customer ID: ", eventClick.extendedProps.customer);
  //   if (!customerSnap.empty) {
  //     let found = false;
  //     customerSnap.forEach((customer) => {
  //       // console.log("Checking customer ID: ", customer.id);
  //       // console.log("customer data", customer.data());
  //       if (customer.id.trim() === eventClick.extendedProps.customer.trim()) {
  //         // console.log("customer data", customer.data());

  //         const customerData = customer.data();
  //         const customerEmail = customerData.emailList;
  //         // console.log("customerEmail: ", customerEmail);

  //         if (customerEmail) {
  //           console.log("Found customer email list: ", customerEmail);
  //           this.setState({ emailList: customerEmail });
  //         } else {
  //           this.setState({ emailList: [] });
  //         }

  //         found = true;
  //         return; // Exit the forEach loop once the matching customer is found
  //       }
  //     });

  //     if (!found) {
  //       this.setState({ emailList: [] });
  //     }
  //   } else {
  //     this.setState({ emailList: [] });
  //   }
  //   this.setState({ modalEmail: true });
  // };

  handleBookingReportEmailClick = async (eventClick) => {
    if (this.state.isBookingReportLoading) {
      notifyWarning("Please wait until the report check is finished.");
      return;
    }

    const eventProps =
      eventClick && eventClick.extendedProps
        ? eventClick.extendedProps
        : {};
    const checklist = this.getBookingReportChecklist(eventProps);

    if (!checklist.isFinalReady) {
      const missingPartLabels = checklist.finalMissingParts
        .map((part) => part.label)
        .join(", ");
      const confirmed = await swal({
        title: "Report checklist is not complete",
        text:
          `Missing required files: ${missingPartLabels || "Unknown"}.\n\n` +
          "Do you want to continue to the Send Email to Hospital form?",
        icon: "warning",
        buttons: ["Cancel", "Continue"],
        dangerMode: true,
      });

      if (!confirmed) return;
    }

    await this.handleSendEmail(eventClick);
  };

  handleSendEmail = async (eventClick) => {
    const customersRef = collectionGroup(db, "customers");
    const customerSnap = await getDocs(customersRef);

    const targetId = (eventClick.extendedProps.customer || "").trim();
    // or: (eventClick?.event?.extendedProps?.customer || "").trim();

    let emailList = [];

    for (const docSnap of customerSnap.docs) {
      if (docSnap.id.trim() === targetId) {
        emailList = docSnap.data().emailList || [];
        break;
      }
    }

    this.setState({ emailList, modalEmail: true });
  };

  // startAddReport = async (reportData = {}, files, type = "report") => {
  //   console.log("start add report");
  //   const { hn, createBy, createAt } = reportData;
  //   const report = { hn, createBy, createAt };
  //   console.log("report: ", report);

  //   const docRef = doc(collection(db, "patients", report.hn, type));
  //   const docId = docRef.id;
  //   console.log("docRef: ", docRef);

  //   await setDoc(docRef, report)
  //     .then(async () => {
  //       console.log("docRef inside: ", docRef);

  //       const promises = [];
  //       const f = [];
  //       files.map((file) => {
  //         const storageRef = ref(
  //           storage,
  //           `${type}s/${report.hn}/${docId}/${file.name}`,
  //         );
  //         f.push(file.name);
  //         const uploadTask = uploadBytes(storageRef, file);
  //         promises.push(uploadTask);
  //       });
  //       await Promise.all(promises);
  //       await updateDoc(doc(db, "patients", report.hn, type, docId), {
  //         reportFile: f,
  //       });

  //       var eventTmp = this.state.eventTmp;
  //       const collectionRef = collection(
  //         db,
  //         "patients",
  //         eventTmp.extendedProps.hn,
  //         type,
  //       );
  //       const docSnap = await getDocs(collectionRef).then((snapshot) => {
  //         const reports = [];
  //         snapshot.forEach(async (childSnapshot) => {
  //           reports.push({
  //             id: childSnapshot.id,
  //             ...childSnapshot.data(),
  //           });
  //         });
  //         if (reports.length > 0) {
  //           if (type === "report") {
  //             eventTmp.setExtendedProp("reports", reports);
  //           } else if (type === "sleepstudy") {
  //             eventTmp.setExtendedProp("sleepstudy", reports);
  //           }
  //         } else {
  //           if (type === "report") {
  //             eventTmp.setExtendedProp("reports", null);
  //           } else if (type === "sleepstudy") {
  //             eventTmp.setExtendedProp("sleepstudy", null);
  //           }
  //         }
  //         this.setState({ eventTmp: eventTmp });
  //       });

  //       console.log(`UPLOAD ${type} SUCCESSFULLY !`);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  startAddReport = async (reportData = {}, files = [], type = "report") => {
    try {
      console.log("start add report");
      console.log("reportData: ", reportData);
      console.log("type: ", type);
      console.log("files: ", files);
      const {
        hn,
        createBy,
        createAt,
        bookingUploadBookingPath,
        scoreUploadType,
        scoreUploadSource,
      } = reportData;

      // if (!hn) throw new Error("HN is empty");
      // if (!Array.isArray(files) || files.length === 0)
      //   throw new Error("No files");
      // user cancelled / no files selected
      if (files.length === 0) {
        Alert.fire({
          icon: "info",
          title: "No files selected",
          text: "Upload was cancelled.",
        });
        return;
      }

      if (!hn) {
        Alert.fire({ icon: "error", title: "HN is empty" });
        return;
      }

      const report = { hn, createBy, createAt };
      if (isSleepStudyCollection(type)) {
        if (bookingUploadBookingPath) {
          report.bookingUploadBookingPath = bookingUploadBookingPath;
        }
        if (scoreUploadType) report.scoreUploadType = scoreUploadType;
        if (scoreUploadSource) report.scoreUploadSource = scoreUploadSource;
      }

      // 1) Create doc
      const fileCollection = type === "sleepstudy"
        ? getSleepStudyUploadCollection(scoreUploadType)
        : type;
      const docRef = doc(collection(db, "patients", hn, fileCollection));
      const docId = docRef.id;
      await setDoc(docRef, report);

      // 2) Show progress modal (one time)
      Alert.fire({
        title: `Uploading ${type}...`,
        html: `0% (0 / ${files.length} files)`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Alert.showLoading(),
      });

      // 3) Overall progress tracking
      const totalBytes = files.reduce((sum, f) => sum + (f.size || 0), 0);
      const transferredByIndex = new Array(files.length).fill(0);

      const updateUI = (fileName = "") => {
        const transferred = transferredByIndex.reduce((a, b) => a + b, 0);
        const overallPct =
          totalBytes > 0 ? (transferred / totalBytes) * 100 : 0;

        const doneFiles = transferredByIndex.filter(
          (bytes, idx) => bytes >= (files[idx].size || 0),
        ).length;

        Alert.update({
          html: `
          <div style="text-align:left">
            <div><b>Overall:</b> ${Math.round(overallPct)}% (${doneFiles} / ${files.length} files)</div>
            ${fileName ? `<div style="margin-top:6px"><b>Now:</b> ${fileName}</div>` : ""}
          </div>
        `,
        });
      };

      // 4) Upload each file with resumable task
      const uploadedNames = [];
      const uploadPromises = files.map((file, index) => {
        return new Promise((resolve, reject) => {
          const storageRef = ref(
            storage,
            `${fileCollection}s/${hn}/${docId}/${file.name}`,
          );
          const task = uploadBytesResumable(storageRef, file);

          task.on(
            "state_changed",
            (snapshot) => {
              transferredByIndex[index] = snapshot.bytesTransferred;
              updateUI(file.name);
            },
            (error) => reject(error),
            () => {
              // mark done
              transferredByIndex[index] =
                file.size || transferredByIndex[index];
              updateUI(file.name);

              uploadedNames.push(file.name); // keep same as your current behavior
              resolve(task.snapshot.ref.fullPath); // optional return value
            },
          );
        });
      });

      await Promise.all(uploadPromises);

      // 5) Save reportFile list to Firestore
      await updateDoc(doc(db, "patients", hn, fileCollection, docId), {
        reportFile: uploadedNames,
      });

      // 6) Refresh list and set extendedProps
      await this.refreshBookingFileList(hn, fileCollection);

      Alert.close();
      swal(`UPLOAD ${type} SUCCESSFULLY !`, { icon: "success" });

      return { docId, files: uploadedNames };
    } catch (error) {
      console.log(error);
      try {
        Alert.close();
      } catch {}
      swal(String(error), { icon: "error" });
      throw error;
    }
  };

  refreshBookingFileList = async (hn, type) => {
    const rows = isSleepStudyCollection(type)
      ? await loadPatientSleepStudyFiles(hn)
      : (await getDocs(collection(db, "patients", hn, type))).docs.map((d) => ({ id: d.id, ...d.data() }));
    const eventTmp = this.state.eventTmp;
    const propKey = isSleepStudyCollection(type) ? "sleepstudy" : "reports";

    eventTmp.setExtendedProp(propKey, rows.length ? rows : null);
    if (type === "report") {
      this.updateCalendarReportReadiness(eventTmp, rows);
      this.setState({
        eventTmp,
        modalBookingReportHn: String(hn || "").trim(),
        modalBookingReports: this.cloneBookingReportRows(rows),
      });
    } else {
      this.setState({ eventTmp });
    }

    return rows;
  };

  handleDeleteBookingFile = async (hn, id, fileName, type) => {
    if (!canDeleteBookingFile(this.context.currentUser.roles[0], type)) {
      notifyError("You do not have permission to delete this file");
      return;
    }

    const eventTmp = this.state.eventTmp;
    const patientHn =
      hn ||
      (eventTmp && eventTmp.extendedProps
        ? eventTmp.extendedProps.hn
        : "");
    const supportedTypes = ["report", "sleepstudy", "scoredsleepstudy"];
    const sectionTitle =
      isSleepStudyCollection(type) ? "Sleep Study Data" : "Report";

    if (!patientHn || !id || !fileName || !supportedTypes.includes(type)) {
      notifyError("Delete file error: missing file information");
      return;
    }

    const confirmation = await Alert.fire({
      title: "Delete this file?",
      text: `This will permanently delete ${fileName} from ${sectionTitle}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) return;

    try {
      Alert.fire({
        title: "Deleting file...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Alert.showLoading(),
      });

      const fileDocRef = doc(
        db,
        "patients",
        patientHn,
        type,
        id,
      );
      const fileSnapshot = await getDoc(fileDocRef);

      if (!fileSnapshot.exists()) {
        throw new Error(`${sectionTitle} file record was not found.`);
      }

      const currentFiles = Array.isArray(fileSnapshot.data().reportFile)
        ? fileSnapshot.data().reportFile
        : [];
      const remainingFiles = currentFiles.filter((name) => name !== fileName);

      if (remainingFiles.length === currentFiles.length) {
        throw new Error(
          `${sectionTitle} file was not found in the file record.`,
        );
      }

      const storageRef = ref(
        storage,
        `${type}s/${patientHn}/${id}/${fileName}`,
      );

      try {
        await deleteObject(storageRef);
      } catch (error) {
        if (error.code !== "storage/object-not-found") throw error;
      }

      if (remainingFiles.length > 0) {
        await updateDoc(fileDocRef, { reportFile: remainingFiles });
      } else {
        await deleteDoc(fileDocRef);
      }

      await this.refreshBookingFileList(patientHn, type);

      await Alert.fire({
        icon: "success",
        title: "File deleted",
        timer: 1400,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(`Delete ${type} file error`, error);
      await Alert.fire({
        icon: "error",
        title: "Delete file error",
        text: error.message || "Unable to delete this file.",
      });
    }
  };

  onDownLoad = (hn, id, file, type) => {
    // console.log("hn,id,file ", hn,id,file);
    this.SetDownLoadSleepStudy(hn, id, type, file);
  };
  canDownloadSleepStudyFiles = () =>
    !["sale", "accountant", "staff"].includes(
      this.context.currentUser.roles[0],
    );

  SetDownLoadSleepStudy = async (hn, id, type, fileName) => {
    if (isSleepStudyCollection(type) && !this.canDownloadSleepStudyFiles()) {
      notifyError("You do not have permission to download Sleep Study Data.");
      return;
    }

    const storageRef = ref(storage, `${type}s/${hn}/${id}/${fileName}`);
    try {
      const url = await getDownloadURL(storageRef);
      await this.downloadFile(url, fileName); // <-- await now
    } catch (error) {
      console.error("Error getting file download URL", error);
    }
  };
  // downloadFile = async (url, fileName) => {
  //   try {
  //     const res = await fetch(url);
  //     if (!res.ok) throw new Error(`Download failed: ${res.status}`);
  //     const blob = await res.blob();

  //     const blobUrl = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = blobUrl;
  //     a.download = fileName || "download";
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();

  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (err) {
  //     console.error(err);
  //     // fallback: open in new tab if blob download fails
  //     window.open(url, "_blank");
  //   }
  // };

  downloadFile = async (url, fileName = "") => {
    const name = (fileName || "").toLowerCase();

    // file types that browsers often open inline
    const inlineTypes = [".pdf", ".png", ".jpg", ".jpeg", ".webp", ".gif"];

    // file types that should download fast via direct link
    const directTypes = [
      ".zip",
      ".7z",
      ".rar",
      ".h5",
      ".edf",
      ".mkv",
      ".avi",
      ".mp4",
      ".txt",
      ".csv",
    ];

    const isInline = inlineTypes.some((ext) => name.endsWith(ext));
    const isDirect = directTypes.some((ext) => name.endsWith(ext));

    // 1) Fast path for zip / big files
    if (isDirect && !isInline) {
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "download";
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
      return;
    }

    // 2) Force-download path for pdf/images (prevents opening a new tab)
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Download failed: ${res.status}`);
      const blob = await res.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName || "download";
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error(err);
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  countEventsPerDay = (events) => {
    return countBookingEventsByDate(events, [
      "Sleep Test Scheduled",
      "Reserve Sleep Set",
    ]);
  };

  allCountEventsPerDay = (events) => {
    return countBookingEventsByDate(events, ["Sleep Test Scheduled"]);
  };

  countReserveEventsPerDay = (events) => {
    return countBookingEventsByDate(events, ["Reserve Sleep Set"]);
  };

  formatDate(timestamp) {
    if (!timestamp) return "-";

    let date;

    // Check if it's a Firebase Timestamp
    if (timestamp.toDate && typeof timestamp.toDate === "function") {
      date = timestamp.toDate(); // Convert to JS Date
    } else {
      date = new Date(timestamp); // Handles JS Date or string
    }

    return date.toLocaleString("th-TH", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  formatBookingGender = (gender) => {
    const rawGender = String(gender || "").trim();
    const normalizedGender = rawGender.toLowerCase();

    if (
      ["ชาย", "เพศชาย", "ผู้ชาย", "male", "m", "(m)"].includes(
        normalizedGender,
      )
    ) {
      return "(ช)";
    }

    if (
      [
        "หญิง",
        "เพศหญิง",
        "ผู้หญิง",
        "female",
        "f",
        "fm",
        "(f)",
        "(fm)",
      ].includes(normalizedGender)
    ) {
      return "(ญ)";
    }

    return rawGender;
  };

  formatBookingGenderFull = (gender) => {
    const rawGender = String(gender || "").trim();
    const normalizedGender = rawGender.toLowerCase();

    if (
      ["ชาย", "เพศชาย", "ผู้ชาย", "male", "m", "(m)"].includes(
        normalizedGender,
      )
    ) {
      return "ชาย";
    }

    if (
      [
        "หญิง",
        "เพศหญิง",
        "ผู้หญิง",
        "female",
        "f",
        "fm",
        "(f)",
        "(fm)",
      ].includes(normalizedGender)
    ) {
      return "หญิง";
    }

    return rawGender;
  };

  getBookingReportChecklist = (eventProps = {}) =>
    buildBookingReportChecklist(this.getModalBookingReports(eventProps), {
      hn: eventProps.hn,
      node: eventProps.node,
      healthInsurance: eventProps.healthInsurance,
    });

  getBookingPatientNoteChecklist = (eventProps = {}) =>
    buildBookingPatientNoteChecklist(
      this.getModalBookingPatientNotes(eventProps),
      { hn: eventProps.hn },
    );

  renderBookingPatientNoteFile = (file, fileIndex) => (
    <div
      key={`${file.id || "note"}-${file.fileName}-${fileIndex}`}
      style={{
        display: "flex",
        alignItems: "center",
        minWidth: 0,
        gap: 6,
        marginBottom: 4,
      }}
    >
      <i
        className="flaticon-381-file-2"
        style={{ color: "#2d573f", flex: "0 0 auto" }}
      />
      <Link
        to="#"
        onClick={(event) => {
          event.preventDefault();
          this.handlePatientNoteFileClick(file);
        }}
        style={{ minWidth: 0, maxWidth: "100%", flex: "1 1 0%" }}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
            maxWidth: "100%",
          }}
          title={file.fileName}
        >
          {file.fileName}
        </span>
      </Link>
    </div>
  );

  renderBookingPatientNoteRows = (eventProps = {}) => {
    const checklist = this.getBookingPatientNoteChecklist(eventProps);
    const isLoading = this.state.isBookingPatientNotesLoading;
    const loadError = this.state.bookingPatientNoteLoadError;
    const uploadingKey = this.state.bookingPatientNoteUploadingKey;
    const canUpload = this.canUploadBookingPatientNotes();
    const hasHn = Boolean(String(eventProps.hn || "").trim());

    return checklist.parts.map((part) => {
      const isPassed = part.hasFile;
      const isUploading = uploadingKey === part.key;

      return (
        <tr key={`patient-note-${part.key}`}>
          <td>
            <b>{part.label}</b>
          </td>
          <td>
            <div className="d-flex align-items-center justify-content-between">
              <div style={{ flex: "1 1 auto", minWidth: 0 }}>
                {isPassed ? (
                  part.files.map((file, fileIndex) =>
                    this.renderBookingPatientNoteFile(file, fileIndex),
                  )
                ) : isLoading ? (
                  <span className="text-info">
                    <i className="fa fa-spinner fa-spin mr-1" />
                    Checking patient notes...
                  </span>
                ) : loadError ? (
                  <span className="text-danger">{loadError}</span>
                ) : (
                  <span className="text-muted">
                    {!hasHn
                      ? "Patient HN is required"
                      : part.hasNote
                        ? "Note exists, but no file"
                        : "No note or file"}
                  </span>
                )}
              </div>
              {canUpload && hasHn && !isLoading && !loadError && (
                <div className="ml-2 flex-shrink-0">
                  <Button
                    type="button"
                    className="btn-xxs btn-primary"
                    disabled={Boolean(uploadingKey)}
                    onClick={() => this.handlePatientNoteUploadButtonClick(part.key)}
                  >
                    <i className={`fa ${isUploading ? "fa-spinner fa-spin" : "fa-upload"} mr-1`} />
                    {isUploading ? "Uploading..." : "Upload file"}
                  </Button>
                  <input
                    type="file"
                    multiple
                    aria-label={`Upload ${part.label}`}
                    ref={this.patientNoteFileInputRefs[part.key]}
                    style={{ display: "none" }}
                    onChange={(event) => this.handlePatientNoteFileChange(event, part.key)}
                  />
                </div>
              )}
            </div>
          </td>
          <td className="text-center">
            {isPassed ? (
              <span className="badge badge-success">
                <i className="fa fa-check-circle mr-1" /> Uploaded
              </span>
            ) : isLoading || isUploading ? (
              <span className="badge badge-info">
                <i className="fa fa-spinner fa-spin mr-1" /> Checking
              </span>
            ) : loadError ? (
              <span className="badge badge-danger">Unavailable</span>
            ) : (
              <span className="badge badge-secondary">
                <i className="fa fa-minus-circle mr-1" /> Optional
              </span>
            )}
          </td>
        </tr>
      );
    });
  };

  renderBookingPatientNoteChecklist = (eventProps = {}) => (
    <div style={{ maxWidth: 900 }}>
      <div className="table-responsive">
        <table
          className="table table-sm table-bordered mb-1"
          style={{ fontSize: "0.82rem", tableLayout: "fixed", minWidth: 420 }}
        >
          <thead>
            <tr>
              <th style={{ width: 145 }}>Form</th>
              <th>Uploaded file</th>
              <th className="text-center" style={{ width: 100 }}>
                Status
              </th>
            </tr>
          </thead>
          <tbody>{this.renderBookingPatientNoteRows(eventProps)}</tbody>
        </table>
      </div>
      <div className="small text-muted">
        Optional files stored under the patient Notes section.
      </div>
      {this.renderBookingHospitalEmail(eventProps)}
    </div>
  );

  renderBookingReportFile = (
    file,
    fileIndex,
    eventProps,
    canDeleteReportFiles,
  ) => {
    const fileHn =
      String(file.hn || "").trim() || String(eventProps.hn || "").trim();
    const currentUser = this.context.currentUser || {};
    const currentRole = Array.isArray(currentUser.roles)
      ? currentUser.roles[0]
      : "";
    const canDownloadReportFile = ![
      "sale",
      "accountant",
      "sleep_technician",
    ].includes(currentRole);

    return (
      <div
        key={`${file.id || "report"}-${file.fileName}-${fileIndex}`}
        style={{
          display: "flex",
          alignItems: "center",
          minWidth: 0,
          gap: 6,
          marginBottom: 4,
        }}
      >
        <i
          className="flaticon-381-file-2"
          style={{ color: "#dd0102", flex: "0 0 auto" }}
        />
        <Link
          to="#"
          onClick={(event) => {
            event.preventDefault();
            this.handleOnClick(fileHn, file.id, file.fileName);
          }}
          style={{ minWidth: 0, maxWidth: "100%", flex: "1 1 0%" }}
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
              maxWidth: "100%",
            }}
            title={file.fileName}
          >
            {file.fileName}
          </span>
        </Link>
        {canDownloadReportFile && (
          <Link
            to="#"
            className="btn btn-info shadow btn-xs sharp"
            style={{ flex: "0 0 auto" }}
            onClick={() =>
              this.onDownLoad(
                fileHn,
                file.id,
                file.fileName,
                "report",
              )
            }
            title="Download item"
          >
            <i className="fa fa-download" />
          </Link>
        )}
        {canDeleteReportFiles && !file.storageOnly && (
          <Button
            type="button"
            variant=""
            className="btn btn-danger shadow btn-xs sharp"
            style={{ flex: "0 0 auto" }}
            onClick={() =>
              this.handleDeleteBookingFile(
                fileHn,
                file.id,
                file.fileName,
                "report",
              )
            }
            title="Delete report file"
          >
            <i className="fa fa-trash" />
          </Button>
        )}
      </div>
    );
  };

  renderBookingReportReadiness = (eventProps = {}, isLoading = false) => {
    if (isLoading) {
      return (
        <span className="badge badge-info" title="Checking report files">
          <i className="fa fa-spinner fa-spin mr-1" /> Checking report status...
        </span>
      );
    }

    const checklist = this.getBookingReportChecklist(eventProps);
    const missingPartLabels = checklist.finalMissingParts
      .map((part) => part.label)
      .join(", ");

    return (
      <span
        className={`badge ${
          checklist.isFinalReady ? "badge-success" : "badge-warning"
        }`}
        title={
          checklist.isFinalReady
            ? "All required report files are uploaded."
            : `Waiting for: ${missingPartLabels}`
        }
      >
        <i
          className={`fa ${
            checklist.isFinalReady ? "fa-check-circle" : "fa-clock-o"
          } mr-1`}
        />
        {checklist.isFinalReady
          ? "Report files ready"
          : `Waiting: ${missingPartLabels}`}
      </span>
    );
  };

  canSendBookingReportEmail = (eventProps = {}) => {
    const currentUser = this.context.currentUser || {};
    const currentRole = Array.isArray(currentUser.roles)
      ? currentUser.roles[0]
      : "";
    const bookingStatus = String(eventProps.status || "").trim();
    const checklist = this.getBookingReportChecklist(eventProps);
    const hasReportFiles =
      checklist.parts.some((part) => part.files.length > 0) ||
      checklist.unclassifiedFiles.length > 0;

    return (
      hasReportFiles &&
      !["sale", "accountant", "staff", "sleep_technician"].includes(
        currentRole,
      ) &&
      CALENDAR_REPORT_READINESS_ICON_STATUSES.includes(bookingStatus)
    );
  };

  renderBookingSleepStudyFiles = ({
    eventProps,
    canUploadSleepStudyFiles,
    canDownloadSleepStudyFiles,
    canDeleteSleepStudyFiles,
  }) => {
    const { unscored, scored } = splitSleepStudyUploads(eventProps.sleepstudy);
    const sections = [
      { title: "Unscored Sleep Study", uploadType: UNSCORED_SLEEP_STUDY_UPLOAD_TYPE, rows: unscored, inputRef: this.fileInputStudyRef },
      { title: "Scored Sleep Study", uploadType: SCORED_SLEEP_STUDY_UPLOAD_TYPE, rows: scored, inputRef: this.fileInputScoredStudyRef },
    ];

    return sections.map(({ title, uploadType, rows, inputRef }) => {
      const files = rows.flatMap((row) =>
        (Array.isArray(row.reportFile) ? row.reportFile : []).map((fileName) => ({ row, fileName })),
      );
      return (
        <div key={uploadType} data-sleep-study-type={uploadType} className="border rounded p-2 mb-2">
          <div className="d-flex justify-content-between align-items-center mb-1" style={{ gap: 8 }}>
            <b>{title}</b>
            {canUploadSleepStudyFiles && (
              <>
                <Button onClick={() => this.handleStudyButtonClick(uploadType)} className="btn-xxs btn-primary">
                  + Upload {uploadType === SCORED_SLEEP_STUDY_UPLOAD_TYPE ? "Scored" : "Unscored"}
                </Button>
                <input type="file" multiple ref={inputRef} aria-label={`Upload ${title}`} style={{ display: "none" }}
                  onChange={(e) => this.handleFileChange(e, "sleepstudy", uploadType)} />
              </>
            )}
          </div>
          {files.length === 0 ? <div className="text-muted small">No {title} files</div> : files.map(({ row, fileName }, index) => (
            <div key={`${row.id}-${fileName}-${index}`} className="d-flex align-items-center" style={{ gap: 8, padding: "2px 0" }}>
              <i className="flaticon-381-file-2" style={{ color: "#dd0102", flex: "0 0 auto" }} />
              <span className="text-truncate flex-grow-1" title={fileName}>{fileName}</span>
              {canDownloadSleepStudyFiles && (
                <Link to="#" className="btn btn-info shadow btn-xs sharp" title="Download item"
                  onClick={(e) => { e.preventDefault(); this.onDownLoad(eventProps.hn || row.hn, row.id, fileName, getSleepStudyFileCollection(row)); }}>
                  <i className="fa fa-download" />
                </Link>
              )}
              {canDeleteSleepStudyFiles && (
                <Button type="button" variant="" className="btn btn-danger shadow btn-xs sharp" title="Delete sleep study file"
                  onClick={() => this.handleDeleteBookingFile(eventProps.hn || row.hn, row.id, fileName, getSleepStudyFileCollection(row))}>
                  <i className="fa fa-trash" />
                </Button>
              )}
            </div>
          ))}
        </div>
      );
    });
  };

  renderBookingReportChecklist = ({
    eventProps = {},
    canUploadReportFiles,
    canDeleteReportFiles,
  }) => {
    const checklist = this.getBookingReportChecklist(eventProps);
    const requiredPartLabels = checklist.parts
      .filter((part) => part.required || part.requiredAfterDoctor)
      .map((part) => part.label)
      .join(", ");
    const missingPartLabels = checklist.finalMissingParts
      .map((part) => part.label)
      .join(", ");
    const isCheckingReportFiles = this.state.isBookingReportLoading;

    return (
      <div style={{ maxWidth: 900 }}>
        <div
          className="d-flex align-items-center flex-wrap mb-2"
          style={{ gap: 8 }}
        >
          <span className="font-weight-bold small">Report Status:</span>
          {this.renderBookingReportReadiness(
            eventProps,
            isCheckingReportFiles,
          )}
          <span className="text-muted small">
            Required: {requiredPartLabels}
          </span>
        </div>
        <div className="table-responsive">
          <table
            className="table table-sm table-bordered mb-2"
            style={{ fontSize: "0.82rem", tableLayout: "fixed", minWidth: 520 }}
          >
            <thead>
              <tr>
                <th style={{ width: 145 }}>Part</th>
                <th>Uploaded file</th>
                <th className="text-center" style={{ width: 80 }}>
                  Required
                </th>
                <th className="text-center" style={{ width: 90 }}>
                  Check
                </th>
              </tr>
            </thead>
            <tbody>
              {checklist.parts.map((part) => {
                const isPassed = part.files.length > 0;

                return (
                  <tr key={part.key}>
                    <td>
                      <b>{part.label}</b>
                    </td>
                    <td>
                      {isPassed ? (
                        part.files.map((file, fileIndex) =>
                          this.renderBookingReportFile(
                            file,
                            fileIndex,
                            eventProps,
                            canDeleteReportFiles,
                          ),
                        )
                      ) : isCheckingReportFiles ? (
                        <span className="text-info">
                          <i className="fa fa-spinner fa-spin mr-1" />
                          Checking remaining files...
                        </span>
                      ) : (
                        <span className="text-muted">No matching file</span>
                      )}
                    </td>
                    <td className="text-center">
                      {part.required ? "Yes" : part.requiredAfterDoctor ? "After doctor review" : "No"}
                    </td>
                    <td className="text-center">
                      {isPassed ? (
                        <span className="badge badge-success">
                          <i className="fa fa-check-circle mr-1" /> Passed
                        </span>
                      ) : isCheckingReportFiles ? (
                        <span className="badge badge-info">
                          <i className="fa fa-spinner fa-spin mr-1" />
                          Checking
                        </span>
                      ) : part.required || part.requiredAfterDoctor ? (
                        <span className="badge badge-warning">
                          <i className="fa fa-clock-o mr-1" /> {part.requiredAfterDoctor ? "Awaiting doctor" : "Waiting"}
                        </span>
                      ) : (
                        <span className="text-muted">Not required</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {checklist.unclassifiedFiles.length > 0 && (
          <div className="mb-2">
            <div className="small text-muted mb-1">
              Other uploaded files (not used in this checklist)
            </div>
            {checklist.unclassifiedFiles.map((file, fileIndex) =>
              this.renderBookingReportFile(
                file,
                fileIndex,
                eventProps,
                canDeleteReportFiles,
              ),
            )}
          </div>
        )}
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: 8 }}
        >
          {canUploadReportFiles && (
            <>
              <Button
                onClick={this.handleButtonClick}
                className="btn-xxs btn-primary"
              >
                + Upload Report
              </Button>
              <input
                type="file"
                multiple
                ref={this.fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => this.handleFileChange(e, "report")}
              />
            </>
          )}
          <span className="text-muted small">
            Filename tags: report, medical, ใบรับรองแพทย์, or trial.
          </span>
        </div>
        {!isCheckingReportFiles && (
          <BookingDoctorReviewSection
            key={eventProps.uuid || "booking"}
            booking={this.state.eventTmp}
            nodeId={this.state.nodeIdDocs[this.state.nodeList.indexOf(eventProps.node)]}
            reports={this.getModalBookingReports(eventProps)}
            onReportsChange={(rows) => {
              this.setState({ modalBookingReports: rows, modalBookingReportHn: String(eventProps.hn || "").trim() });
              this.updateCalendarReportReadiness(this.state.eventTmp, rows);
            }}
          />
        )}
        {isCheckingReportFiles ? (
          <div className="small text-info mt-2">
            <i className="fa fa-spinner fa-spin mr-1" /> Checking Storage for
            remaining report files. Files already found are shown above.
          </div>
        ) : !checklist.isFinalReady && (
          <div className="small text-warning mt-2">
            This case is not ready yet. Waiting for: {missingPartLabels}
          </div>
        )}
      </div>
    );
  };

  renderBookingHospitalEmail = (eventProps = {}) => {
    const canSendReportEmail = this.canSendBookingReportEmail(eventProps);
    const isCheckingReportFiles = this.state.isBookingReportLoading;
    const hasSentReportEmail = Boolean(eventProps.email);
    const lastSentDate = String(eventProps.lastestMail || "").trim();

    return (
      <div
        className="d-flex align-items-center justify-content-between flex-wrap mt-3"
        style={{
          gap: 12,
          padding: "10px 12px",
          border: "1px solid #e1e5ea",
          borderRadius: 8,
          backgroundColor: "#f8f9fa",
        }}
      >
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: 8 }}
        >
          <span className="font-weight-bold small">Hospital Email Status:</span>
          <span
            className={`badge ${
              hasSentReportEmail ? "badge-success" : "badge-secondary"
            }`}
          >
            <i
              className={`fa ${
                hasSentReportEmail ? "fa-check-circle" : "fa-clock-o"
              } mr-1`}
            />
            {hasSentReportEmail ? "Sent" : "Not sent"}
          </span>
          <span className="text-muted small">
            {hasSentReportEmail
              ? `Last sent: ${lastSentDate || "Date unavailable"}`
              : "No hospital email sent yet"}
          </span>
        </div>
        {canSendReportEmail && (
          <Button
            type="button"
            className="btn-xxs btn-danger"
            disabled={isCheckingReportFiles}
            title={
              isCheckingReportFiles
                ? "Wait until the report check is finished"
                : "Send sleep study report email to hospital"
            }
            onClick={() =>
              this.handleBookingReportEmailClick(this.state.eventTmp)
            }
          >
            <i
              className={`fa ${
                isCheckingReportFiles
                  ? "fa-spinner fa-spin"
                  : "fa-envelope"
              } mr-1`}
            />
            {isCheckingReportFiles
              ? "Checking Reports..."
              : hasSentReportEmail
                ? "Send to Hospital Again"
                : "Send to Hospital"}
          </Button>
        )}
      </div>
    );
  };

  render() {
    const eventTmp = ensureBookingEventDraft(this.state.eventTmp);
    const eventProps = eventTmp.extendedProps || {};
    const isCurrentUserPartTimeSleepTechnician =
      this.isCurrentUserPartTimeSleepTechnician();
    const partTimeTechnicianStatusOptions =
      getPartTimeTechnicianBookingStatusOptions(eventProps.status);
    const canDeleteReportFiles = canDeleteBookingFile(
      this.context.currentUser.roles[0],
      "report",
    );
    const canDeleteSleepStudyFiles = canDeleteBookingFile(
      this.context.currentUser.roles[0],
      "sleepstudy",
    );
    const canDownloadSleepStudyFiles = this.canDownloadSleepStudyFiles();
    const canUploadReportFiles = !["sale", "accountant"].includes(
      this.context.currentUser.roles[0],
    );
    const canUploadSleepStudyFiles = ![
      "sale",
      "accountant",
      "staff",
    ].includes(this.context.currentUser.roles[0]);
    const visibleEventCounts = this.countEventsPerDay(
      this.state.calendarEvents,
    );
    const allSleepStudyCounts = this.allCountEventsPerDay(
      this.state.allEvents,
    );
    const allReserveCounts = this.countReserveEventsPerDay(
      this.state.allEvents,
    );
    const activePostConsultFilterCount = [
      this.state.bookingPostConsultTechFilter,
      this.state.bookingPostConsultDoctorFilter,
    ].filter(Boolean).length;
    const activeBookingFilterCount = activePostConsultFilterCount + [
      this.getSelectedNodeFilter() !== "All Node",
      this.getSelectedTechFilter() !== "กรุณาเลือก",
      this.state.bookingStatusFilter !== "All Status",
      this.state.bookingSaleFilter !== BOOKING_SALE_FILTER_ALL,
      Boolean(this.state.bookingDoctorFilter),
      Boolean(this.state.bookingCustomerFilter),
      this.state.bookingReportFilter !== "all",
    ].filter(Boolean).length;
    const matchingBookingCount = this.state.bookingReportFilter === "all"
      ? this.state.calendarEvents.length
      : this.state.calendarEvents.filter((booking) =>
          matchesBookingReportFilter(
            this.getCalendarReportReadiness(booking),
            this.state.bookingReportFilter,
          ),
        ).length;
    const hasBookingTeamFilters = ["super_admin", "sale", "accountant", "admin"].includes(
      this.context.currentUser.roles[0],
    );
    const bookingAssignmentFilters = (
      <>
        {["super_admin", "sale", "accountant", "admin"].includes(
          this.context.currentUser.roles[0],
        ) && (
          <>
            <div className="booking-calendar-filter-field" data-active={this.getSelectedTechFilter() !== "กรุณาเลือก" || undefined}>
              <label htmlFor="node2">Technician</label>
              <select
                className="form-control"
                id="node2"
                name="node2"
                ref={this.techSelectRef}
                onChange={this.onChangeTech}
                disabled={this.state.isCalendarRefreshing}
              >
                {this.state.technicianList.map((value) => (
                  <option key={value.name} value={value.name}>
                    {value.name} ({value.nickname})
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
        <div className="booking-calendar-filter-field" data-active={Boolean(this.state.bookingDoctorFilter) || undefined}>
          <label htmlFor="bookingDoctorFilter">Doctor</label>
          <select
            className="form-control"
            id="bookingDoctorFilter"
            name="bookingDoctorFilter"
            value={this.state.bookingDoctorFilter}
            onChange={this.onChangeDoctorFilter}
            disabled={this.state.isCalendarRefreshing}
          >
            <option value="">All Doctors</option>
            {Array.from(new Set([
              this.state.bookingDoctorFilter,
              ...this.state.baseCalendarEvents.map((booking) =>
                ((booking.extendedProps || {}).doctor || "").trim(),
              ),
            ]))
              .filter((name) => name && name !== "กรุณาเลือก")
              .sort((left, right) => left.localeCompare(right, "th"))
              .map((name) => (
                <option key={name} value={name}>{name}</option>
              ))}
          </select>
        </div>
        {this.canFilterBookingsBySale() && (
          <div className="booking-calendar-filter-field" data-active={this.state.bookingSaleFilter !== BOOKING_SALE_FILTER_ALL || undefined}>
            <label htmlFor="bookingSaleFilter">Sale</label>
            <select
              className="form-control"
              id="bookingSaleFilter"
              name="bookingSaleFilter"
              value={this.state.bookingSaleFilter}
              onChange={this.onChangeSaleFilter}
              disabled={this.state.isCalendarRefreshing}
            >
              <option value={BOOKING_SALE_FILTER_ALL}>
                {BOOKING_SALE_FILTER_ALL}
              </option>
              <option value={BOOKING_SALE_FILTER_UNASSIGNED}>
                {BOOKING_SALE_FILTER_UNASSIGNED}
              </option>
              {Array.from(new Set(this.state.saleList)).map(
                (saleName) => (
                  <option key={saleName} value={saleName}>
                    {saleName}
                  </option>
                ),
              )}
            </select>
          </div>
        )}
      </>
    );
    const canViewCalendarMessages =
      this.canCurrentUserViewCalendarMessages();

    return (
      <Fragment>
        {!this.props.modalOnly && <Toast />}
        {!this.props.modalOnly && this.renderCalendarMessagePopover()}
        <Modal
          className="fade bd-example-modal-sm"
          show={this.state.modalEmail}
          onHide={() => this.setState({ modalEmail: false, emailList: [] })}
          size="xl"
        >
          <Modal.Header>
            <Modal.Title>Send Email to Hospital</Modal.Title>
          </Modal.Header>
          <Modal.Body className="m-0 p-5">
            <this.PatientTextInfo
              title="Order"
              value={eventProps.order}
              bold={true}
            />
            <this.PatientTextInfo
              title="Full Name"
              value={
                eventProps.firstname +
                " " +
                eventProps.lastname
              }
              bold={true}
            />
            <this.PatientDropDownForm
              title="Email"
              id="type"
              refvalue={this.currentEmailRef}
              // selected={eventProps.type}
              options={this.state.emailList}
            ></this.PatientDropDownForm>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <Button
              variant=""
              type="button"
              className="btn btn-info"
              onClick={() => {
                swal({
                  title: `Are you sure to send email to ${this.currentEmailRef.current.value} ?`,
                  text: `${eventProps.order} ${eventProps.firstname} ${eventProps.lastname}`,
                  icon: "warning",
                  buttons: ["Cancel", "Confirm"],
                  dangerMode: true,
                }).then(async (willSendEmail) => {
                  if (willSendEmail) {
                    console.log("SENT EMAIL HERE!");
                    // ***********************
                    // this.sleepStudyReportMail({
                    //   to: "pisanu@braindynamics.co.th",
                    //   subject: "test123",
                    //   text: "test567",
                    // });
                    // console.log("eventTmp: ",eventProps)
                    const fullName = `${eventProps.firstname} ${eventProps.lastname}`;
                    const order = eventProps.order;
                    const customer = eventProps.customer;
                    const hn = eventProps.hn;
                    const refHn = eventProps.refHn
                      ? eventProps.refHn
                      : "";
                    const latestSS = eventProps
                      .latestSleepStudyDate
                      ? eventProps.latestSleepStudyDate
                      : "";
                    const mailTest = {
                      to: this.state.emailList,
                      message: {
                        subject: `Sleep Study Report ${order}`,
                        html: `<p>เรียน ${customer},</p>
                        <p>${order}<br>
                        ${fullName}<br>
                        ${refHn}<br>
                        ตรวจเมื่อวันที่ ${latestSS}</p>
                        <p>ดูผลได้ที่ https://study2.bdsleep.tech${getPatientPagePath(hn)}<p>
                        <p>ขอแสดงความนับถือ,<br>
                        BDSleep</p>`,
                      },
                      order: order,
                      fullName: fullName,
                      refHn: refHn,
                      sleepStudyDate: latestSS,
                      hn: hn,
                    };
                    const endTimeDate = new Date();

                    // Extract day, month, and year
                    const day = String(endTimeDate.getDate()).padStart(2, "0");
                    const month = String(endTimeDate.getMonth() + 1).padStart(
                      2,
                      "0",
                    ); // Months are zero-based, so add 1
                    const year = endTimeDate.getFullYear();

                    const formattedDate = `${year}-${month}-${day}`;

                    const mailRef = doc(collection(db, "mail"));
                    const mail = await setDoc(mailRef, mailTest);
                    // ***********************
                    var eventTmpData = eventTmp;
                    eventTmpData.setExtendedProp("email", true);
                    eventTmpData.setExtendedProp("lastestMail", formattedDate);
                    // console.log(eventTmpData)

                    this.setEvent(eventTmpData);

                    this.setState({ eventTmp: eventTmpData });
                    this.setState({ modalEmail: false, emailList: [] });
                  }
                });
              }}
            >
              Send All Email
            </Button>
            <div>
              <Button
                variant="light"
                onClick={() =>
                  this.setState({ modalEmail: false, emailList: [] })
                }
              >
                Cancel
              </Button>
              <Button
                variant=""
                type="button"
                className="btn btn-danger ml-3"
                onClick={() => {
                  swal({
                    title: `Are you sure to send email to ${this.currentEmailRef.current.value} ?`,
                    text: `${eventProps.order} ${eventProps.firstname} ${eventProps.lastname}`,
                    icon: "warning",
                    buttons: ["Cancel", "Confirm"],
                    dangerMode: true,
                  }).then(async (willSendEmail) => {
                    if (willSendEmail) {
                      console.log("SENT EMAIL HERE!");
                      // ***********************
                      // this.sleepStudyReportMail({
                      //   to: "pisanu@braindynamics.co.th",
                      //   subject: "test123",
                      //   text: "test567",
                      // });
                      // console.log("eventTmp: ",eventProps)
                      const fullName = `${eventProps.firstname} ${eventProps.lastname}`;
                      const order = eventProps.order;
                      const customer =
                        eventProps.customer;
                      const hn = eventProps.hn;
                      const refHn = eventProps.refHn
                        ? eventProps.refHn
                        : "";
                      const latestSS = eventProps
                        .latestSleepStudyDate
                        ? eventProps.latestSleepStudyDate
                        : "";
                      const mailTest = {
                        to: this.currentEmailRef.current.value,
                        message: {
                          subject: `Sleep Study Report ${order}`,
                          html: `<p>เรียน ${customer},</p>
                        <p>${order}<br>
                        ${fullName}<br>
                        ${refHn}<br>
                        ตรวจเมื่อวันที่ ${latestSS}</p>
                        <p>ดูผลได้ที่ https://study.bdsleep.tech${getPatientPagePath(hn)}<p>
                        <p>ขอแสดงความนับถือ,<br>
                        BDSleep</p>`,
                        },
                        order: order,
                        fullName: fullName,
                        refHn: refHn,
                        sleepStudyDate: latestSS,
                        hn: hn,
                      };
                      const endTimeDate = new Date();

                      // Extract day, month, and year
                      const day = String(endTimeDate.getDate()).padStart(
                        2,
                        "0",
                      );
                      const month = String(endTimeDate.getMonth() + 1).padStart(
                        2,
                        "0",
                      ); // Months are zero-based, so add 1
                      const year = endTimeDate.getFullYear();

                      const formattedDate = `${year}-${month}-${day}`;

                      const mailRef = doc(collection(db, "mail"));
                      const mail = await setDoc(mailRef, mailTest);
                      // ***********************
                      var eventTmpData = eventTmp;
                      eventTmpData.setExtendedProp("email", true);
                      eventTmpData.setExtendedProp(
                        "lastestMail",
                        formattedDate,
                      );
                      // console.log(eventTmpData)

                      this.setEvent(eventTmpData);

                      this.setState({ eventTmp: eventTmpData });
                      this.setState({ modalEmail: false, emailList: [] });
                    }
                  });
                }}
              >
                Send to Hospital
              </Button>
            </div>
          </Modal.Footer>{" "}
        </Modal>
        <Modal
          className="fade bd-example-modal-lg"
          show={this.state.createModal}
          onHide={() =>
            this.setState({
              createModal: false,
              fileUrl: null,
              filePreviewTitle: "Report",
              filePreviewType: "document",
            })
          }
          size="xl"
        >
          <Modal.Header>
            <Modal.Title>{this.state.filePreviewTitle}</Modal.Title>
            <Button
              variant=""
              className="close"
              onClick={() =>
                this.setState({
                  createModal: false,
                  fileUrl: null,
                  filePreviewTitle: "Report",
                  filePreviewType: "document",
                })
              }
            >
              {" "}
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body className="m-0 p-0">
            <div
              className="card-body mx-0 p-0 col-lg-12"
              style={{ height: "85vh" }}
            >
              {this.state.filePreviewType === "image" ? (
                <img
                  src={this.state.fileUrl}
                  alt={`${this.state.filePreviewTitle} preview`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <iframe
                  className="col-lg-12 m-0 p-0"
                  src={this.state.fileUrl + "#toolbar=0"}
                  title={
                    this.state.filePreviewTitle === "Report"
                      ? "Booking report file preview"
                      : "Patient note file preview"
                  }
                  width="100%"
                  height="100%"
                ></iframe>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        <div className="animated fadeIn demo-app ">
          {!this.props.modalOnly && (
          <>
          <Row>
            {!this.state.isLoading ? (
              <Col>
                <Card>
                  {this.state.hasNoAssignedNode && (
                    <div className="alert alert-warning m-3" role="alert">
                      Please contact an administrator to assign a node to your
                      account.
                    </div>
                  )}
                  <section className="booking-calendar-filters" aria-label="Booking calendar search and filters">
                    <div className="booking-calendar-filter-toolbar">
                      <div className="booking-calendar-filter-search">
                        <label htmlFor="bookingCalendarSearch">Search bookings</label>
                        <div className="booking-calendar-filter-search-input">
                          <i className="flaticon-381-search-2" aria-hidden="true" />
                          <input
                            id="bookingCalendarSearch"
                            type="search"
                            className="form-control"
                            placeholder="Search order, HN, or patient name..."
                            value={this.state.bookingSearchText}
                            onChange={this.onSearchBooking}
                          />
                          {this.state.bookingSearchText && (
                            <Button
                              type="button"
                              variant="light"
                              aria-label="Clear search"
                              title="Clear search"
                              onClick={this.onClearBookingSearch}
                              disabled={this.state.isCalendarRefreshing}
                            >
                              Clear
                            </Button>
                          )}
                        </div>
                      </div>
                      <div className="booking-calendar-filter-summary">
                        <span className="booking-calendar-filter-count" role="status" aria-live="polite" aria-atomic="true">
                          <strong>{matchingBookingCount}</strong> matching bookings
                        </span>
                        <Button
                          type="button"
                          variant="outline-secondary"
                          className="booking-calendar-filter-reset"
                          title="Clear search and reset all filters"
                          onClick={this.onResetBookingFilters}
                          disabled={this.state.isCalendarRefreshing || (!this.state.bookingSearchText && !activeBookingFilterCount)}
                        >
                          <i className="fa fa-undo" aria-hidden="true" /> Reset all
                        </Button>
                      </div>
                    </div>
                    <fieldset className="booking-calendar-filter-group">
                      <legend>Booking filters</legend>
                      <div className="booking-calendar-filter-grid">
                        {["super_admin", "sale", "accountant", "admin"].includes(
                          this.context.currentUser.roles[0],
                        ) && (
                          <>
                            <div className="booking-calendar-filter-field" data-active={this.getSelectedNodeFilter() !== "All Node" || undefined}>
                              <label htmlFor="node1">Node</label>
                              <select
                                className="form-control"
                                id="node1"
                                name="node1"
                                ref={this.nodeSelectRef}
                                onChange={this.onChangeNode}
                                disabled={this.state.isCalendarRefreshing}
                              >
                                {[
                                  "super_admin",
                                  "sale",
                                  "accountant",
                                  "sleep_technician",
                                  "sleep_physician",
                                  "admin",
                                ].includes(this.context.currentUser.roles[0]) && (
                                  <option value={"All Node"}>{"All Node"}</option>
                                )}
                                {this.state.nodeList.map((value) => (
                                  <option key={value} value={value}>
                                    {value}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </>
                        )}
                        <div className="booking-calendar-filter-field" data-active={Boolean(this.state.bookingCustomerFilter) || undefined}>
                          <label htmlFor="bookingCustomerFilter">Customer</label>
                          <select
                            id="bookingCustomerFilter"
                            name="bookingCustomerFilter"
                            className="form-control"
                            value={this.state.bookingCustomerFilter}
                            onChange={this.onChangeCustomerFilter}
                            disabled={this.state.isCalendarRefreshing}
                          >
                            <option value="">All Customers</option>
                            {this.getBookingCustomerFilterOptions().map((customer) => (
                              <option key={customer} value={customer}>{customer}</option>
                            ))}
                          </select>
                        </div>
                        {["super_admin", "sale", "accountant", "admin", "staff"].includes(
                          this.context.currentUser.roles[0],
                        ) && (
                          <div className="booking-calendar-filter-field" data-active={this.state.bookingStatusFilter !== "All Status" || undefined}>
                            <label htmlFor="bookingStatusFilter">Status</label>
                            <select
                              className="form-control"
                              id="bookingStatusFilter"
                              name="bookingStatusFilter"
                              ref={this.statusSelectRef}
                              value={this.state.bookingStatusFilter}
                              onChange={this.onChangeStatus}
                              disabled={this.state.isCalendarRefreshing}
                            >
                              <option value="All Status">All Status</option>
                              {this.statusList.map((status) => (
                                <option key={status} value={status}>
                                  {status}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                        {["super_admin", "sale", "accountant", "admin", "staff"].includes(
                          this.context.currentUser.roles[0],
                        ) && (
                          <div className="booking-calendar-filter-field" data-active={this.state.bookingReportFilter !== "all" || undefined}>
                            <label htmlFor="bookingReportFilter">Report</label>
                            <select
                              id="bookingReportFilter"
                              className="form-control"
                              disabled={this.state.isCalendarRefreshing}
                              value={this.state.bookingReportFilter}
                              title="Filters reports checked for the dates shown. Complete means all required reports are uploaded; incomplete means at least one required report is missing."
                              onChange={(event) => this.setState({
                                bookingReportFilter: event.target.value,
                              })}
                            >
                              <option value="all">All report statuses</option>
                              <option value="ready">Complete: all required reports</option>
                              <option value="not_ready">Incomplete: missing required reports</option>
                              <option value="sleep_study_ready">Sleep study report uploaded</option>
                              <option value="trial_ready">Trial report uploaded</option>
                              <option value="medical_cert_ready">Medical certificate uploaded</option>
                            </select>
                          </div>
                        )}
                        {!hasBookingTeamFilters && bookingAssignmentFilters}
                      </div>
                    </fieldset>
                    {hasBookingTeamFilters && (
                      <fieldset className="booking-calendar-filter-group booking-calendar-filter-group--team">
                        <legend>Team filters</legend>
                        <div className="booking-calendar-filter-grid">
                          {bookingAssignmentFilters}
                        </div>
                      </fieldset>
                    )}
                    {this.context.currentUser.roles[0] !== "staff" && (
                      <details className="booking-calendar-filter-more">
                        <summary>
                          Post-consult filters
                          {activePostConsultFilterCount > 0 && (
                            <span className="booking-calendar-filter-badge">{activePostConsultFilterCount} active</span>
                          )}
                        </summary>
                        <div className="booking-calendar-filter-grid booking-calendar-filter-grid--post-consult">
                          {[
                            { key: "bookingPostConsultTechFilter", field: "techConsult", label: "Post Consult Tech", all: "All Post Consult Techs" },
                            { key: "bookingPostConsultDoctorFilter", field: "postDoctor", label: "Post Consult Doctor", all: "All Post Consult Doctors" },
                          ].map(({ key, field, label, all }) => (
                            <div className="booking-calendar-filter-field" data-active={Boolean(this.state[key]) || undefined} key={key}>
                              <label htmlFor={key}>{label}</label>
                              <select
                                className="form-control"
                                id={key}
                                name={key}
                                value={this.state[key]}
                                onChange={(event) => this.setState(
                                  { [key]: event.target.value },
                                  () => this.applyCalendarFilters(),
                                )}
                                disabled={this.state.isCalendarRefreshing}
                              >
                                <option value="">{all}</option>
                                <option value="__not_assigned__">Not assigned</option>
                                {Array.from(new Set([
                                  this.state[key],
                                  ...this.state.baseCalendarEvents.map((booking) =>
                                    String((booking.extendedProps || {})[field] || "").trim(),
                                  ),
                                ]))
                                  .filter((name) => name && name !== "กรุณาเลือก" && name !== "__not_assigned__")
                                  .sort((left, right) => left.localeCompare(right, "th"))
                                  .map((name) => (
                                    <option key={name} value={name}>{name}</option>
                                  ))}
                              </select>
                            </div>
                          ))}
                        </div>
                      </details>
                    )}
                    {(["super_admin", "sale", "accountant", "admin"].includes(
                      this.context.currentUser.roles[0],
                    ) || (this.context.currentUser.roles[0] !== "staff" && this.isSuperAdmin())) && (
                      <div className="booking-calendar-filter-footer">
                        {["super_admin", "sale", "accountant", "admin"].includes(
                          this.context.currentUser.roles[0],
                        ) && (
                          <div className="booking-calendar-filter-legend" aria-label="Calendar key">
                            <span className="booking-calendar-filter-legend-title">Calendar key</span>
                            <span><img src={moneyBag} alt="" /> Pay with Cash</span>
                            <span><img src={house} alt="" /> Home Sleep Study</span>
                            <span><i className="flaticon-381-add-2" aria-hidden="true" /> Premium add on</span>
                            <span aria-label="Report checklist ready">
                              <i className="fa fa-check-circle booking-calendar-filter-report-ready" aria-hidden="true" />
                              Report checklist ready
                            </span>
                            <span aria-label="Report checklist waiting">
                              <i className="fa fa-exclamation-circle booking-calendar-filter-report-waiting" aria-hidden="true" />
                              Report checklist waiting
                            </span>
                          </div>
                        )}
                        {this.context.currentUser.roles[0] !== "staff" && this.isSuperAdmin() && (
                          <Button
                            type="button"
                            variant="outline-danger"
                            size="sm"
                            className="booking-calendar-filter-recovery"
                            title="Move past empty-HN cases to Recovery"
                            onClick={this.onMovePastEmptyHnBookingsToRecovery}
                            disabled={
                              this.state.isCalendarRefreshing ||
                              Boolean(this.state.pastEmptyHnCleanupStatus)
                            }
                          >
                            {this.state.pastEmptyHnCleanupStatus === "checking"
                              ? "Checking…"
                              : this.state.pastEmptyHnCleanupStatus === "moving"
                                ? "Moving to Recovery…"
                                : "Move past no-HN"}
                          </Button>
                        )}
                      </div>
                    )}
                  </section>
                  <Card.Body
                    className="booking-calendar-body border p-2 my-0"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    {this.state.isCalendarRefreshing && (
                      <div
                        className="booking-calendar-loading-overlay"
                        role="status"
                        aria-live="polite"
                      >
                        <div className="booking-calendar-loading-panel">
                          <div
                            className="spinner-border text-primary"
                            aria-hidden="true"
                          />
                          <span>Loading calendar...</span>
                        </div>
                      </div>
                    )}
                    <div className="demo-app-calendar" id="mycalendartest">
		                      <FullCalendar
                        // height="auto"
                        // stickyHeaderDates={true}
                        // stickyFooterScrollbar={true}
                        plugins={[
                          dayGridPlugin,
                          interactionPlugin,
                          // listPlugin,
                          multiMonthPlugin,
                        ]}
                        initialView="dayGridMonth"
                        headerToolbar={{
                          center: "title",
                          left: "dayGridWeek,dayGridMonth,multiMonthYear",
                          right: "prev,next today",
	                        }}
                        initialDate={this.state.calendarDisplayDate}
	                        // ,listMonth
                        rerenderDelay={10}
                        eventDurationEditable={false}
                        editable={false}
                        droppable={false}
                        ref={this.calendarComponentRef}
                        weekends={this.state.calendarWeekends}
                        eventDrop={this.eventDrag}
                        eventReceive={this.eventDrop}
                        eventClick={this.eventClick}
                        events={this.state.bookingReportFilter === "all"
                          ? this.state.calendarEvents
                          : this.state.calendarEvents.filter((booking) =>
                              matchesBookingReportFilter(
                                this.getCalendarReportReadiness(booking),
                                this.state.bookingReportFilter,
                              ),
                            )}
                        datesSet={this.handleDatesSet}
                        eventDidMount={(info) => {
                          this.rememberCalendarEventElement(info.event, info.el);
                          this.applyCalendarEventElementColor(info.event, info.el);
                        }}
                        eventWillUnmount={(info) => {
                          this.forgetCalendarEventElement(info.event);
                        }}
                        dayMaxEvents={false}
                        fixedWeekCount={false}
                        displayEventTime={false}
                        // eventOrder={(a, b) => {
                        //   const statusA = a.extendedProps.status;
                        //   const statusB = b.extendedProps.status;

                        //   return (
                        //     (this.statusOrder[statusA] || 99) -
                        //     (this.statusOrder[statusB] || 99)
                        //   );
                        // }}
                        eventOrder={this.compareCalendarEventsForDisplay}
                        dayCellContent={(arg) => {
                          const today = new Date();
                          const currentMonth = today.getMonth(); // 0-indexed
                          const currentYear = today.getFullYear();

                          // ✅ current month -> next 3 months
                          const start = currentYear * 12 + currentMonth;
                          const end = start + 5;

                          const cellMonth = arg.date.getMonth();
                          const cellYear = arg.date.getFullYear();

                          const cell = cellYear * 12 + cellMonth;
                          const isInRange = cell >= start && cell <= end;

                          // if (isInRange) {
                          //   const allEventCounts = this.allCountEventsPerDay(
                          //     this.state.allEvents,
                          //   ); // Pass events as input
                          // }

                          const dateStr = getLocalBookingDateString(arg.date);
                          const eventCount = visibleEventCounts[dateStr] || 0;
                          const allEventCount = allSleepStudyCounts[dateStr] || 0;
                          const allReserveEventCount = allReserveCounts[dateStr] || 0;
                          const messageCount = this.getCalendarMessagesForDate(
                            dateStr,
                          ).length;

                          return (
                            <div className="booking-calendar-day-heading">
                              <span className="booking-calendar-day-summary">
                                {eventCount >= 0 && (
                                  <>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ( {eventCount} ){" "}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "9px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {["admin"].includes(
                                        this.context.currentUser.roles[0],
                                      ) &&
                                        isInRange &&
                                        ` {AVL
                                  ${this.state.totalDevice - allEventCount - allReserveEventCount}}`}
                                    </span>
                                  </>
                                )}
                              </span>

                              <span className="booking-calendar-day-actions">
                                {canViewCalendarMessages && (
                                  <span
                                    className={`booking-calendar-message-trigger${
                                      messageCount > 0
                                        ? " booking-calendar-message-trigger--has-messages"
                                        : ""
                                    }`}
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`Open ${messageCount} message${
                                      messageCount === 1 ? "" : "s"
                                    } for ${dateStr}`}
                                    title={`${messageCount} message${
                                      messageCount === 1 ? "" : "s"
                                    } for ${dateStr}`}
                                    onClick={(event) =>
                                      this.handleOpenCalendarMessages(
                                        event,
                                        dateStr,
                                      )
                                    }
                                    onKeyDown={(event) =>
                                      this.handleCalendarMessageTriggerKeyDown(
                                        event,
                                        dateStr,
                                      )
                                    }
                                  >
                                    <i
                                      className="fa fa-envelope"
                                      aria-hidden="true"
                                    />
                                    {messageCount > 0 && (
                                      <span
                                        className="booking-calendar-message-count"
                                        aria-hidden="true"
                                      >
                                        {messageCount}
                                      </span>
                                    )}
                                  </span>
                                )}

                                {/* Date Number (Right) */}
                                <span className="booking-calendar-day-number">
                                  {arg.dayNumberText}
                                </span>
                              </span>
                            </div>
                          );
                        }}
                        eventContent={(info) => {
                          var firstname =
                            info.event.extendedProps.firstname || "";
                          var lastname =
                            info.event.extendedProps.lastname || "";
                          var gender = this.formatBookingGender(
                            info.event.extendedProps.gender,
                          );
                          var patientName = `${firstname} ${lastname}`.trim();
                          var fullname = patientName
                            ? `${patientName}${gender ? ` ${gender}` : ""}`
                            : "(จองห้อง)";
                          var type = info.event.extendedProps.type;
                          var status = info.event.extendedProps.status;
                          var total = info.event.extendedProps.totalValue;
                          var time = info.event.extendedProps.time;
                          var note = info.event.extendedProps.note;
                          var order = info.event.extendedProps.order;
                          var stech = info.event.extendedProps.technician;
                          var rtech = info.event.extendedProps.techrecord;
                          var doctor = info.event.extendedProps.doctor;
                          var referDoctor =
                            info.event.extendedProps.referDoctor;
                          var postDoctor = info.event.extendedProps.postDoctor;
                          var email = info.event.extendedProps.email; // New email variable
                          var healthInsurance =
                            info.event.extendedProps.healthInsurance;
                          var stopBangScore =
                            info.event.extendedProps.stopBangScore;
                          const reportReadiness =
                            this.getCalendarReportReadiness(info.event);
                          const eventColor =
                            this.getCalendarEventColor(info.event);
                          const additionalEquipment = normalizeBookingAdditionalEquipment(
                            info.event.extendedProps.additionalEquipment,
                          );

                          var typeSymbol = this.getBookingTypeSymbol(type);

                          var txt = `${fullname}`;

                          var description = "";
                          if (type !== "" || type !== "กรุณาเลือก") {
                            description = description + `${type}`;
                          }
                          description = description + `\nStatus: ${status}`;
                          if (additionalEquipment.length) {
                            description += `\nAdditional equipment: ${additionalEquipment.join(", ")}`;
                          }
                          if (
                            rtech !== "" ||
                            rtech !== "กรุณาเลือก" ||
                            rtech !== "undefined" ||
                            !rtech
                          ) {
                            description = description + "\nRT: " + `${rtech}`;
                          }
                          if (
                            stech !== "" ||
                            stech !== "กรุณาเลือก" ||
                            stech !== "undefined"
                          ) {
                            description = description + "\nST: " + `${stech}`;
                          }
                          if (doctor !== "" || doctor !== "กรุณาเลือก") {
                            description = description + "\nD: " + `${doctor}`;
                          }
                          if (referDoctor !== "") {
                            description =
                              description + "\nR: " + `${referDoctor}`;
                          }
                          if (postDoctor !== "") {
                            description =
                              description + "\nP: " + `${postDoctor}`;
                          }
                          if (note !== "") {
                            description = description + `\nN: ${note}`;
                          }
                          if (total == 0) {
                            description = description + "\n฿ -";
                          } else {
                            description = description + `\n฿${total}`;
                          }

                          if (status == "Post-Consult" && time !== "") {
                            description = description + `\nTime: ${time}`;
                            txt = `${fullname}`;
                          }
                          if (reportReadiness) {
                            description = reportReadiness.isReady
                              ? `${description}\nReport files: Ready`
                              : `${description}\nReport files waiting: ${
                                  reportReadiness.missingPartLabels.join(", ")
                                }`;
                          }
                          const orderElement = document.createElement("div");
                          if (status === "Assigned to Doctor") {
                            orderElement.classList.add(
                              "border-bottom",
                              "border-dark",
                              "text-black",
                            );
                          } else {
                            orderElement.classList.add(
                              "border-bottom",
                              "border-white",
                              "text-white",
                            );
                          }

                          orderElement.title = description;

                          // Make it a horizontal flexbox
                          orderElement.style.display = "flex";
                          orderElement.style.alignItems = "center";
                          orderElement.style.justifyContent = "space-between";

                          // Make sure it stretches full width
                          orderElement.style.width = "100%";

                          // 🟩 Left: money / premium / home icons
                          const moneyContainer = document.createElement("div");
                          moneyContainer.style.flex = "0 0 auto";
                          moneyContainer.style.paddingRight = "4px";
                          moneyContainer.style.display = "flex";
                          moneyContainer.style.alignItems = "center";
                          moneyContainer.style.justifyContent = "flex-start";
                          moneyContainer.style.gap = "2px";
                          moneyContainer.style.whiteSpace = "nowrap";
                          moneyContainer.style.minWidth = "20px";

                          if (healthInsurance === "ชำระเงินเอง") {
                            const moneyImg = document.createElement("img");
                            moneyImg.src = moneyBag;
                            moneyImg.alt = "money icon";
                            moneyImg.style.width = "14px";
                            moneyImg.style.height = "14px";
                            moneyImg.style.flex = "0 0 auto";
                            moneyContainer.appendChild(moneyImg);
                          }

                          const items = info.event.extendedProps.items;

                          const hasAddOnPremium =
                            Array.isArray(items) &&
                            items.some(
                              (itemObj) =>
                                itemObj.item &&
                                itemObj.item.includes("Premium Add On"),
                            );

                          if (hasAddOnPremium) {
                            const iconWrapper = document.createElement("div");
                            iconWrapper.style.width = "12px";
                            iconWrapper.style.height = "12px";
                            iconWrapper.style.borderRadius = "50%";
                            iconWrapper.style.backgroundColor = "#FFD700";
                            iconWrapper.style.display = "flex";
                            iconWrapper.style.alignItems = "center";
                            iconWrapper.style.justifyContent = "center";
                            iconWrapper.style.margin = "0";
                            iconWrapper.style.flex = "0 0 auto";
                            iconWrapper.title = "Premium Add On";

                            const icon = document.createElement("i");
                            icon.className = "flaticon-381-add-2";
                            icon.style.color = "#000000";
                            icon.style.fontSize = "8px";

                            iconWrapper.appendChild(icon);
                            moneyContainer.appendChild(iconWrapper);
                          }

                          if (typeSymbol === "[HN]") {
                            const homeIcon = document.createElement("img");
                            homeIcon.src = house;
                            homeIcon.alt = "Home Study";
                            homeIcon.title = "Home Study";
                            homeIcon.style.width = "12px";
                            homeIcon.style.height = "12px";
                            homeIcon.style.margin = "0";
                            homeIcon.style.borderRadius = "50%";
                            homeIcon.style.flex = "0 0 auto";

                            moneyContainer.appendChild(homeIcon);
                          }

                          // ⬛ Center: order text
                          const orderTextContainer =
                            document.createElement("div");
                          orderTextContainer.style.flex = "1";
                          orderTextContainer.style.minWidth = "0";
                          orderTextContainer.style.textAlign = "center";
                          orderTextContainer.style.overflow = "hidden";
                          orderTextContainer.style.textOverflow = "ellipsis";
                          orderTextContainer.style.whiteSpace = "nowrap";
                          orderTextContainer.innerHTML = "";

                          // Create order span
                          const orderSpan = document.createElement("span");
                          orderSpan.innerText = order + " ";
                          orderTextContainer.appendChild(orderSpan);

                          // Create type symbol span
                          const typeSpan = document.createElement("span");
                          typeSpan.innerText = typeSymbol;

                          orderTextContainer.appendChild(typeSpan);

                          // 🟦 Right: report-readiness icon
                          const rightIconContainer =
                            document.createElement("div");
                          rightIconContainer.style.flex = "0 0 auto"; // fixed size
                          rightIconContainer.style.padding = "1px";
                          rightIconContainer.style.display = "flex";
                          rightIconContainer.style.alignItems = "center";
                          rightIconContainer.style.gap = "3px";

                          this.appendCalendarReportReadinessIcon(
                            rightIconContainer,
                            reportReadiness,
                          );

                          // Append all 3 parts
                          orderElement.appendChild(moneyContainer);
                          orderElement.appendChild(orderTextContainer);
                          orderElement.appendChild(rightIconContainer);

                          // Create a new element for the event title and description
                          const titleElement = document.createElement("div");
                          titleElement.style.textAlign = "center";

                          if (status === "Assigned to Doctor") {
                            titleElement.classList.add(
                              "left-align",
                              "text-black",
                            );
                          } else {
                            titleElement.classList.add(
                              "left-align",
                              "text-white",
                            );
                          }
                          // Clear previous content
                          titleElement.innerHTML = "";

                          // Create a container for title and icon
                          const titleContainer = document.createElement("div");
                          titleContainer.style.display = "flex";
                          titleContainer.style.justifyContent = "center";
                          titleContainer.style.alignItems = "center";
                          titleContainer.style.width = "100%";

                          // Create span for the title text
                          const titleText = document.createElement("span");
                          titleText.style.minWidth = "0";
                          titleText.style.flex = "0 1 auto";
                          titleText.innerText = info.event.extendedProps
                            .firstname
                            ? txt
                            : "(จองห้อง)";

                          // Append title text to container
                          titleContainer.appendChild(titleText);

                          // Show the sent-email icon beside the patient name,
                          // rather than on the order-number line above it.
                          if (email) {
                            const iconElement = document.createElement("i");
                            iconElement.classList.add("flaticon-381-compass-2");
                            iconElement.style.color =
                              status === "Assigned to Doctor"
                                ? "#000000"
                                : "#ffffff";
                            iconElement.style.fontSize = "10px";
                            iconElement.style.marginLeft = "3px";
                            iconElement.style.flex = "0 0 auto";
                            iconElement.title = "Email sent";
                            titleContainer.appendChild(iconElement);
                          }

                          // Check if items array contains "Add on Premium"
                          // const items = info.event.extendedProps.items;
                          // const hasAddOnPremium =
                          //   Array.isArray(items) &&
                          //   items.some(
                          //     (itemObj) =>
                          //       itemObj.item &&
                          //       itemObj.item.includes("Premium Add On"),
                          //   );
                          // const hasHomeStudy =
                          //   type == "Home Full Night Sleep Study";

                          // if (hasAddOnPremium) {
                          //   // Premium icon wrapper
                          //   const iconWrapper = document.createElement("div");
                          //   iconWrapper.style.width = "18px";
                          //   iconWrapper.style.height = "18px";
                          //   iconWrapper.style.borderRadius = "50%";
                          //   iconWrapper.style.backgroundColor = "#FFD700"; // Gold background
                          //   iconWrapper.style.display = "flex";
                          //   iconWrapper.style.alignItems = "center";
                          //   iconWrapper.style.justifyContent = "center";
                          //   iconWrapper.style.marginLeft = "3px";
                          //   iconWrapper.title = "Premium Add On";

                          //   // Premium icon
                          //   const icon = document.createElement("i");
                          //   icon.className = "flaticon-381-add-2";
                          //   icon.style.color = "#000000";
                          //   icon.style.fontSize = "12px";

                          //   iconWrapper.appendChild(icon);
                          //   titleContainer.appendChild(iconWrapper);

                          //   // 🔽 Add Home icon if hasHomeStudy is true
                          // }

                          // if (typeSymbol === "[HN]") {
                          //   const homeIcon = document.createElement("img");
                          //   homeIcon.src = house; // ✅ Replace with your actual home icon path
                          //   homeIcon.alt = "Home Study";
                          //   homeIcon.title = "Home Study";
                          //   homeIcon.style.width = "18px";
                          //   homeIcon.style.height = "18px";
                          //   homeIcon.style.marginLeft = "3px";
                          //   homeIcon.style.borderRadius = "50%"; // Optional if the icon needs to be rounded

                          //   titleContainer.appendChild(homeIcon);
                          // }

                          // Append the container to the titleElement
                          titleElement.appendChild(titleContainer);

                          const postConsultDoctor = String(postDoctor || "").trim();
                          if (
                            status === "Post-Consult" &&
                            postConsultDoctor &&
                            postConsultDoctor !== "กรุณาเลือก"
                          ) {
                            const doctorLine = document.createElement("div");
                            doctorLine.textContent = `Post Consult Doctor: ${postConsultDoctor}`;
                            doctorLine.style.whiteSpace = "normal";
                            doctorLine.style.overflowWrap = "anywhere";
                            titleElement.appendChild(doctorLine);
                          }

                          titleElement.title = description;

                          const isPremium =
                            status === "Sleep Test Scheduled" &&
                            (type === "Split Night Sleep Study" ||
                              type === "CPAP Titration" ||
                              type == "CPAP Titration Study");

                          if (isPremium) {
                            orderElement.classList.add("premium-event");
                            titleElement.classList.add("premium-event");
                          }

                          // Add yellow color if it's [SN] or [CT]
                          if (typeSymbol === "[SN]" || typeSymbol === "[CT]") {
                            if (status === "Sleep Test Scheduled") {
                              typeSpan.style.color = "#FFFF00";
                              orderSpan.style.color = "#FFFF00";
                              titleElement.style.color = "#FFFF00";
                            }
                          }

                          const eventContentWrapper =
                            document.createElement("div");
                          eventContentWrapper.setAttribute(
                            "data-booking-event-content",
                            "true",
                          );
                          eventContentWrapper.style.display = "flex";
                          eventContentWrapper.style.flexDirection = "column";
                          eventContentWrapper.style.alignItems = "stretch";
                          eventContentWrapper.style.justifyContent = "center";
                          eventContentWrapper.style.width = "100%";
                          eventContentWrapper.style.minWidth = "0";
                          eventContentWrapper.style.lineHeight = "1.15";
                          eventContentWrapper.style.overflow = "hidden";
                          eventContentWrapper.style.backgroundColor = eventColor;
                          eventContentWrapper.style.borderColor = eventColor;
                          orderElement.style.flex = "0 0 auto";
                          titleElement.style.flex = "0 0 auto";
                          titleElement.style.width = "100%";
                          titleElement.style.minWidth = "0";
                          titleContainer.style.minWidth = "0";
                          titleText.style.overflow = "hidden";
                          titleText.style.textOverflow = "ellipsis";
                          titleText.style.whiteSpace = "nowrap";

                          eventContentWrapper.appendChild(orderElement);
                          eventContentWrapper.appendChild(titleElement);

                          if (additionalEquipment.length) {
                            const equipmentElement = document.createElement("div");
                            equipmentElement.className = "booking-calendar-equipment";
                            equipmentElement.title = `Additional equipment required: ${additionalEquipment.join(", ")}`;
                            additionalEquipment.forEach((equipment) => {
                              const label = document.createElement("span");
                              label.className = "booking-calendar-equipment-label";
                              label.textContent = equipment;
                              equipmentElement.appendChild(label);
                            });
                            eventContentWrapper.appendChild(equipmentElement);
                          }

                          var domTmp = {
                            domNodes: [eventContentWrapper],
                          };
                          return domTmp;
                        }}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ) : (
              <Col>
                <div class="media d-flex align-items-center">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden"></span>
                  </div>
                </div>
              </Col>
            )}

            {/* <Col xl={2}>
              <Card>
                <Card.Body className="p-2">
                  <div className="col p-0 m-0">
                    {this.statusList.map((element, index) => {
                      return (
                        <div className="d-flex p-1 align-items-center">
                          <span
                            className="badge width30 height30 text-white"
                            style={{ backgroundColor: this.colorList[index] }}
                          >
                            {" "}
                          </span>
                          <text className="mb-2 mt-1 ml-1 pl-2 small">
                            {element}
                          </text>
                        </div>
                      );
                    })}
                  </div>
                  {!["sale", "accountant", "staff", "sleep_technician"].includes(
                    this.context.currentUser.roles[0],
                  ) && (
                    <>
                      {" "}
                      <div className="row px-0 ml-2 mt-4">
                        <h4 className="text-black">
                          <b>Add Booking</b>
                        </h4>
                      </div>
                      <div className="mt-2" id="external-events">
                        {this.state.events.map((event) => (
                          <div
                            className="fc-event mt-0 ml-0 mb-2 btn btn-block btn-primary"
                            id={event.id}
                            title={event.title}
                            data-order={event.order}
                            data-hn={event.hn}
                            data-type={event.type}
                            data-status={event.status}
                            data-node={event.node}
                            data-customer={event.customer}
                            data-color={event.color}
                            key={event.id}
                          >
                            {event.title}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col> */}

            <Col xl={1.5}>
              <Card>
                <Card.Body className="p-2">
                  <div className="col p-0 m-0">
                    {this.statusList.map((element, index) => {
                      return (
                        <div className="d-flex  align-items-center">
                          <span
                            className="badge width20 height20 text-white"
                            style={{ backgroundColor: this.colorList[index] }}
                          >
                            {" "}
                          </span>
                          <text className="mb-1 mt-1 ml-1 pl-2 small">
                            {element}
                          </text>
                        </div>
                      );
                    })}
                  </div>
                  {!["sale", "accountant", "staff", "sleep_technician"].includes(
                    this.context.currentUser.roles[0],
                  ) && (
                    <>
                      {" "}
                      <div className="row px-0 ml-2 mt-4">
                        <h4 className="text-black">
                          <b>Add Booking</b>
                        </h4>
                      </div>
                      <Button
                        variant=""
                        type="button"
                        className="btn btn-primary btn-block mb-2"
                        onClick={this.onCreateEventToday}
                      >
                        New Event
                      </Button>
                      <div className="mt-2" id="external-events">
                        {this.state.events.map((event) => (
                          <div
                            className="fc-event mt-0 ml-0 mb-2 btn btn-block btn-primary"
                            id={event.id}
                            title={event.title}
                            data-order={event.order}
                            data-hn={event.hn}
                            data-type={event.type}
                            data-status={event.status}
                            data-node={event.node}
                            data-customer={event.customer}
                            data-color={event.color}
                            key={event.id}
                          >
                            {event.title}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* addEventModal */}
          <Modal
            className="fade bd-example-modal-lg"
            show={this.state.isAddEventModal}
            onHide={() => this.onHideAddEventModal()}
            size="xl"
          >
            <Modal.Header>
              <Modal.Title>Add Event</Modal.Title>
              <Button
                variant=""
                className="close"
                onClick={() => this.onHideAddEventModal()}
              >
                <span>&times;</span>
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-12">
                    {/* <this.PatientDropDownForm
                      title="order"
                      id="order"
                      refvalue={this.orderRef}
                      selected={
                        eventProps.order == "" ||
                        eventProps.order == null ||
                        eventProps.order == undefined
                          ? "จองคิว"
                          : eventProps.order
                      }
                      options={this.orderList}
                    ></this.PatientDropDownForm> */}
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Create copies
                      </label>

                      <div className="col-lg-1">
                        <input
                          type="text"
                          className="form-control"
                          id="val-hn"
                          name="val-hn"
                          placeholder="Create X copies of this event"
                          ref={this.copyRef}
                          defaultValue={1}
                          // defaultValue={eventProps.order}
                          // ref={emailRef}
                          // value=""
                        />
                      </div>
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Create X copies of this event
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Order
                      </label>

                      <div className="col-lg-5">
                        <input
                          type="text"
                          className="form-control"
                          id="val-hn"
                          name="val-hn"
                          placeholder="Order"
                          ref={this.orderRef}
                          defaultValue={eventProps.order}
                          // ref={emailRef}
                          // value=""
                        />
                      </div>
                    </div>
                    <this.PatientDropDownForm
                      title="Node"
                      id="node"
                      refvalue={this.nodeRef}
                      selected={eventProps.node}
                      options={this.state.nodeList}
                      onChange={this.handleBookingNodeChange}
                    ></this.PatientDropDownForm>
                    <this.PatientDropDownForm
                      key={`add-customer-${
                        eventProps.node
                      }-${
                        eventProps.customer
                      }-${this.state.customerList.join("|")}`}
                      title="Customer"
                      id="customer"
                      refvalue={this.customerRef}
                      selected={eventProps.customer}
                      options={this.state.customerList}
                    ></this.PatientDropDownForm>

                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        HN (Company Number)
                      </label>

                      <div className="col-lg-5">
                        <input
                          type="text"
                          className="form-control"
                          id="val-hn"
                          name="val-hn"
                          placeholder="HN"
                          ref={this.hnRef}
                          defaultValue={normalizeBookingHn(eventProps.hn)}
                          onChange={trimBookingHnInput}
                          // ref={emailRef}
                          // value=""
                        />
                      </div>
                      <div className="col-lg-2">
                        <Button
                          variant=""
                          type="button"
                          className="btn btn-secondary"
                          onClick={this.onSearchPatient}
                          size="sm"
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                    {this.state.isNewPatient ? (
                      <div className="form-group row">
                        <label
                          className="col-lg-3 col-form-label"
                          htmlFor="val-username"
                        ></label>

                        <div className="col-lg-4">
                          <label className="text-danger">* New Patient</label>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {this.state.isAddEventModal ? (
                      <>
                        {" "}
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Full Name
                          </label>
                          <div className="col-lg-4">
                            <input
                              type="text"
                              className="form-control"
                              id="val-hn"
                              name="val-hn"
                              placeholder="Firstname"
                              ref={this.firstnameRef}
                              defaultValue={
                                eventProps.firstname
                              }
                            />
                          </div>
                          <div className="col-lg-4">
                            <input
                              type="text"
                              className="form-control"
                              id="val-hn"
                              name="val-hn"
                              placeholder="Lastname"
                              ref={this.lastnameRef}
                              defaultValue={
                                eventProps.lastname
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Gender
                          </label>

                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-hn"
                              name="val-hn"
                              placeholder="Gender"
                              ref={this.genderRef}
                              defaultValue={
                                eventProps.gender
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Phone
                          </label>
                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-phone"
                              name="val-phone"
                              placeholder="Phone"
                              ref={this.phoneRef}
                              defaultValue={
                                eventProps.phone
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Referring Hospital Number
                          </label>
                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-phone"
                              name="val-phone"
                              placeholder=""
                              ref={this.hospitalNumberRef}
                              defaultValue={
                                eventProps.hospitalNumber
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {" "}
                        <this.PatientTextInfo
                          title="Full Name"
                          value={
                            eventProps.firstname +
                            " " +
                            eventProps.lastname
                          }
                          bold={true}
                        />
                        <this.PatientTextInfo
                          title="Gender"
                          value={this.formatBookingGenderFull(
                            eventProps.gender,
                          )}
                          bold={true}
                        />
                        <this.PatientTextInfo
                          title="Phone"
                          value={eventProps.phone}
                          bold={true}
                        />
                        <this.PatientTextInfo
                          title="Referring Hospital Number"
                          value={
                            eventProps.hospitalNumber
                          }
                          bold={true}
                        />
                      </>
                    )}

                    <this.PatientDropDownForm
                      title="Health Insurance"
                      id="healthInsurance"
                      refvalue={this.healthInsuranceRef}
                      selected={
                        eventProps.healthInsurance
                      }
                      options={this.paymentPrivilages}
                    ></this.PatientDropDownForm>
                    <this.PatientDropDownForm
                      title="Type"
                      id="type"
                      refvalue={this.typeRef}
                      selected={eventProps.type}
                      options={this.typeList}
                    ></this.PatientDropDownForm>
                    {this.renderBookingAdditionalEquipmentField(eventProps, "add-calendar-equipment")}
                    <this.PatientDropDownForm
                      title="Status"
                      id="status"
                      refvalue={this.statusRef}
                      selected={eventProps.status}
                      options={this.statusList}
                      onChange={this.checkStatus}
                      isBold={true}
                    ></this.PatientDropDownForm>
                    <this.PatientDropDownForm
                      title="Recording Tech"
                      id="techrecord"
                      refvalue={this.techRecordRef}
                      selected={eventProps.techrecord}
                      options={this.state.techrecordList}
                    ></this.PatientDropDownForm>
                    {/* <this.PatientDropDownForm
                      title="Recording Tech"
                      id="techConsult"
                      refvalue={this.techConsultRef}
                      selected={eventProps.techConsult}
                      options={this.state.techrecordList}
                    ></this.PatientDropDownForm> */}
                    <this.PatientDropDownForm
                      title="Scoring Tech"
                      id="techscore"
                      refvalue={this.techRef}
                      selected={eventProps.technician}
                      options={this.state.technicianList}
                    ></this.PatientDropDownForm>
                    <this.PatientDropDownForm
                      title="Post Consult Tech"
                      id="techrecord"
                      refvalue={this.techConsultRef}
                      selected={eventProps.techConsult}
                      options={this.state.techrecordList}
                    ></this.PatientDropDownForm>
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Referring Doctor
                      </label>
                      <div className="col-lg-5">
                        <input
                          type="text"
                          className="form-control"
                          id="val-refDoctor"
                          name="val-refDoctor"
                          placeholder="Referring Doctor"
                          ref={this.referDocRef}
                          defaultValue={
                            eventProps.referDoctor
                          }
                        />
                      </div>
                    </div>
                    <this.PatientDropDownForm
                      title="Doctor"
                      id="doctor"
                      refvalue={this.docRef}
                      selected={eventProps.doctor}
                      options={this.state.doctorList}
                    ></this.PatientDropDownForm>
                    <this.PatientDropDownForm
                      title="Post Consult Doctor"
                      id="postDoctor"
                      refvalue={this.postDoctorRef}
                      selected={eventProps.postDoctor}
                      options={this.state.doctorList}
                    ></this.PatientDropDownForm>
                    {this.renderBookingSaleField(eventProps.sale)}
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Stop-Bang Score
                      </label>
                      <div className="col-lg-5">
                        <input
                          type="text"
                          className="form-control"
                          id="val-refDoctor"
                          name="val-refDoctor"
                          placeholder=""
                          ref={this.stopBangScoreRef}
                          defaultValue={
                            eventProps.stopBangScore
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        AHI
                      </label>
                      <div className="col-lg-5">
                        <input
                          type="text"
                          className="form-control"
                          id="val-refDoctor"
                          name="val-refDoctor"
                          placeholder=""
                          ref={this.ahiRef}
                          defaultValue={eventProps.ahi}
                        />
                      </div>
                    </div>
                    {this.state.isDatetime && (
                      <>
                        {" "}
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Time
                          </label>
                          <div className="col-lg-2 mt-2">
                            <input
                              type={"time"}
                              className="form-control"
                              defaultValue={
                                eventProps.time
                              }
                              // defaultValue={new Date(this.state.dateTmp + "T00:00")}
                              onChange={(event, props) =>
                                this.handleTime(event, props)
                              }
                            ></input>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Date
                      </label>
                      <div className="col-lg-2 mt-2">
                        <DatePicker
                          className="form-control"
                          dateFormat="yyyy-MM-dd"
                          selected={new Date(this.state.dateTmp)}
                          onChange={(event, props) =>
                            this.handleDate(event, props)
                          }
                          disabled={["staff"].includes(
                            this.context.currentUser.roles[0],
                          )}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Note
                      </label>
                      <div className="col-lg-5">
                        <textarea
                          type="area"
                          className="form-control"
                          id="val-phone"
                          name="val-phone"
                          rows="4"
                          placeholder="Note"
                          ref={this.noteRef}
                          defaultValue={eventProps.note}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-lg-5 col-form-label mt-2">
                        <b htmlFor="val-username">Add Item</b>
                        <Button
                          variant="secondary"
                          size="xs"
                          className="ml-2"
                          onClick={() => {
                            var tmpItems = this.state.items;
                            var tmpItemList = this.state.itemList;
                            var indexOfDefaultItem = tmpItemList.findIndex(
                              (obj) =>
                                obj.item ===
                                "Full Night Sleep Study - Social Security - Standard",
                            );

                            if (indexOfDefaultItem === -1) {
                              indexOfDefaultItem = 0;
                            }

                            var tmp = {
                              id: tmpItems.length + 1,
                              itemcode:
                                tmpItemList[indexOfDefaultItem].itemcode,
                              item: tmpItemList[indexOfDefaultItem].item,
                              unitcost:
                                tmpItemList[indexOfDefaultItem].unitcost,
                              qty: 1,
                              discount: 0,
                              total: tmpItemList[indexOfDefaultItem].unitcost,
                            };

                            tmpItems = [...tmpItems, tmp];
                            this.setState(
                              {
                                items: tmpItems,
                              },
                              () => {
                                this.getTotalValue();
                              },
                            );
                          }}
                        >
                          +
                        </Button>{" "}
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th className="center">No.</th>
                            <th className="center width300">Item Name</th>
                            {/* <th className="center width100">Item Code</th> */}
                            <th className="center width150">Unit Cost (THB)</th>
                            <th className="center width100">Qty</th>
                            <th className="center">Discount (THB)</th>
                            <th className="center">Total (THB)</th>
                            <th className="center"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.items.map((element, index) => {
                            return (
                              <tr>
                                <td className="">{element.id}</td>
                                <td>
                                  <select
                                    className="form-control"
                                    id={"item" + String(index)}
                                    name={"item" + String(index)}
                                    onChange={(evt) => {
                                      var item = evt.target.value;
                                      var tmpItems = [...this.state.items]; // clone to avoid mutation

                                      var indexOfItemList =
                                        this.state.itemList.findIndex(
                                          (obj) => obj.item === item,
                                        );

                                      if (indexOfItemList !== -1) {
                                        const selectedItem =
                                          this.state.itemList[indexOfItemList];

                                        tmpItems[index] = {
                                          ...tmpItems[index],
                                          itemcode: selectedItem.itemcode,
                                          item: selectedItem.item,
                                          unitcost: selectedItem.unitcost,
                                          qty: 1,
                                          discount: 0,
                                          total: selectedItem.unitcost,
                                        };

                                        this.setState(
                                          { items: tmpItems },
                                          () => {
                                            this.getTotalValue();
                                          },
                                        );
                                      }
                                    }}
                                  >
                                    {[...this.state.itemList]
                                      .sort((a, b) =>
                                        a.item.localeCompare(b.item),
                                      )
                                      .map((value) => (
                                        <option
                                          key={value.itemcode}
                                          value={value.item}
                                          selected={
                                            this.state.items[index].item ===
                                            value.item
                                              ? "selected"
                                              : ""
                                          }
                                        >
                                          {value.item}
                                        </option>
                                      ))}
                                  </select>
                                </td>

                                {/* <td className="left strong">
                                  <b>{this.state.items[index].itemcode}</b>
                                </td> */}
                                <td className="left">
                                  {" "}
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={"val-unitcost" + String(index)}
                                    name={"val-unitcost" + String(index)}
                                    placeholder="Unit Cost"
                                    onChange={(value) =>
                                      this.onUpdateItemValue(
                                        "unitcost",
                                        index,
                                        value,
                                      )
                                    }
                                    value={this.state.items[index].unitcost}
                                  />
                                </td>
                                <td className="right">
                                  {" "}
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={"val-qty" + String(index)}
                                    name={"val-qty" + String(index)}
                                    placeholder="QTY"
                                    onChange={(value) =>
                                      this.onUpdateItemValue(
                                        "qty",
                                        index,
                                        value,
                                      )
                                    }
                                    value={this.state.items[index].qty}
                                  />
                                </td>
                                <td className="center">
                                  {" "}
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={"val-discount" + String(index)}
                                    name={"val-discount" + String(index)}
                                    placeholder="Discount"
                                    onChange={(value) =>
                                      this.onUpdateItemValue(
                                        "discount",
                                        index,
                                        value,
                                      )
                                    }
                                    value={this.state.items[index].discount}
                                  />
                                </td>
                                <td className="right">
                                  {" "}
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={"val-total" + String(index)}
                                    name={"val-total" + String(index)}
                                    placeholder="Total"
                                    onChange={(value) =>
                                      this.onUpdateItemValue(
                                        "total",
                                        index,
                                        value,
                                      )
                                    }
                                    value={this.state.items[index].total}
                                  />
                                </td>
                                <td>
                                  <Button
                                    className="btn btn-danger btn-xs sharp"
                                    onClick={() => {
                                      var tmpItems = this.state.items;
                                      // console.log("items: ", tmpItems);
                                      tmpItems = tmpItems.filter(
                                        (item) => item.id != tmpItems[index].id,
                                      );
                                      for (
                                        let i = 0;
                                        i < tmpItems.length;
                                        i++
                                      ) {
                                        tmpItems[i].id = i + 1;
                                      }
                                      // console.log("items: ", tmpItems);
                                      this.setState({ items: tmpItems }, () => {
                                        this.getTotalValue();
                                      });
                                    }}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-sm-5 ml-auto">
                        <table className="table table-clear">
                          <tbody>
                            <tr>
                              <td className="left">
                                <strong>Total</strong>
                              </td>
                              <td className="right">
                                <strong>
                                  {this.state.totalValue + " THB"}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="light"
                onClick={() => this.onHideAddEventModal()}
              >
                Cancel
              </Button>
              <Button
                variant=""
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  // console.log("ondrop: ", eventTmp);
                  const selectedBookingDate =
                    getBookingEventDateInput(
                      eventTmp,
                      this.state.dateTmp,
                    ).dateString;
                  let api = this.calendarComponentRef.current.getApi();
                  var allEvents = api.getEvents().filter((obj) => {
                    return (
                      isSameLocalBookingDate(
                        this.getCalendarEventDateString(obj),
                        selectedBookingDate,
                      ) &&
                      normalizeBookingHn(obj.extendedProps.hn) !== "" &&
                      !this.isSameCalendarEvent(obj, eventTmp)
                    );
                  });
                  // console.log("allEvents:", allEvents);
                  const normalizedHn = normalizeBookingHn(
                    this.getInputValue(this.hnRef),
                  );
                  this.setInputValue(this.hnRef, normalizedHn);
                  let listHNEvent = allEvents.filter((element) => {
                    return (
                      normalizeBookingHn(element.extendedProps.hn) ===
                      normalizedHn
                    );
                  });
                  // console.log("listHNEvent 1403", listHNEvent);

                  if (listHNEvent.length >= 1) {
                    swal({
                      title: `HN${normalizedHn} is already booking on this day !`,
                      text: `Please recheck booking on ${selectedBookingDate}`,
                      icon: "warning",
                      buttons: ["Cancel", "Confirm"],
                      dangerMode: true,
                    }).then((willBooking) => {
                      if (willBooking) {
                        this.onAddEvent();
                      }
                    });
                  } else {
                    this.onAddEvent();
                  }
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          {/* NotiModal */}
          <Modal
            className="fade bd-example-modal-lg"
            show={this.state.isNoti}
            onHide={() => this.onHideNoti()}
            size="xl"
          >
            <Modal.Body>
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-12">
                    <this.PatientTextInfo
                      title="Order"
                      value={eventProps.order}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Node"
                      value={eventProps.node}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Customer"
                      value={eventProps.customer}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientLinkInfo
                      title="HN (Company Number)"
                      value={eventProps.hn}
                      bold={true}
                      path={getPatientPagePath(eventProps.hn)}
                    ></this.PatientLinkInfo>
                    <this.PatientLinkInfo
                      title="Full Name"
                      value={
                        eventProps.firstname +
                        " " +
                        eventProps.lastname
                      }
                      bold={true}
                      path={getPatientPagePath(eventProps.hn)}
                    ></this.PatientLinkInfo>
                    <this.PatientTextInfo
                      title="Gender"
                      value={this.formatBookingGenderFull(
                        eventProps.gender,
                      )}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Phone"
                      value={eventProps.phone}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Referring Hospital Number"
                      value={eventProps.hospitalNumber}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Health Insurance"
                      value={eventProps.healthInsurance}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Type"
                      value={eventProps.type}
                      bold={true}
                    ></this.PatientTextInfo>

                    <this.PatientTextInfo
                      title="Status"
                      value={eventProps.status}
                      bold={true}
                      titleBold={true}
                    ></this.PatientTextInfo>

                    <this.PatientTextInfo
                      title="Recording Tech"
                      value={eventProps.techrecord}
                      bold={true}
                    ></this.PatientTextInfo>

                    <this.PatientTextInfo
                      title="Scoring Tech"
                      value={eventProps.technician}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Post Consult Tech"
                      value={eventProps.techConsult}
                      bold={true}
                    ></this.PatientTextInfo>

                    <this.PatientTextInfo
                      title="Doctor"
                      value={eventProps.doctor}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Post Consult Doctor"
                      value={eventProps.postDoctor}
                      bold={true}
                    ></this.PatientTextInfo>
                    <this.PatientTextInfo
                      title="Sale"
                      value={eventProps.sale || "-"}
                      bold={true}
                    ></this.PatientTextInfo>

                    <this.PatientTextInfo
                      title="Date"
                      value={this.getCalendarEventDateString(
                        eventTmp,
                      )}
                      bold={true}
                    ></this.PatientTextInfo>
                    {/* <this.PatientTextInfo
                      title="Note"
                      value={eventTmp.note}
                      bold={true}
                    /> */}
                    <this.PatientTextInfo
                      title="Note"
                      value={eventProps.note}
                      bold={true}
                    ></this.PatientTextInfo>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th className="center">No.</th>
                            <th className="center width300">Item Name</th>
                            {/* <th className="center width100">Item Code</th> */}
                            <th className="center width150">Unit Cost (THB)</th>
                            <th className="center width100">Qty</th>
                            <th className="center">Discount (THB)</th>
                            <th className="center">Total (THB)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.items.map((element, index) => {
                            return (
                              <tr>
                                <td className="">
                                  <b>{element.id}</b>
                                </td>
                                <td>
                                  <b>{element.item}</b>
                                </td>
                                {/* <td className="left strong">
                                  <b>{element.itemcode}</b>
                                </td> */}
                                <td className="left">
                                  {" "}
                                  <b>{element.unitcost}</b>
                                </td>
                                <td className="right">
                                  {" "}
                                  <b>{element.qty}</b>
                                </td>
                                <td className="center">
                                  {" "}
                                  <b>{element.discount}</b>
                                </td>
                                <td className="right">
                                  {" "}
                                  <b>{element.total}</b>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-sm-5 ml-auto">
                        <table className="table table-clear">
                          <tbody>
                            <tr>
                              <td className="left">
                                <strong>Total</strong>
                              </td>
                              <td className="right">
                                <strong>
                                  {this.state.totalValue + " THB"}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center border-0">
              <Button
                variant=""
                type="button"
                className="btn btn-primary"
                onClick={() => this.onHideNoti()}
              >
                OK
              </Button>
            </Modal.Footer>
          </Modal>

          </>
          )}
          {/* <EditEvent /> */}
          <Modal
            className="fade bd-example-modal-lg"
            show={this.state.isEditEventModal}
            key={this.state.bookingEditorVersion}
            onHide={() => {
              if (this.state.isMovingBookingToRecovery) return;

              this.onHideEditEventModal();
              let evtmp = eventTmp;
              evtmp.setStart(this.state.resetDateTmp);
              evtmp.setEnd(getNextLocalBookingDateString(this.state.resetDateTmp));
              this.setState({ eventTmp: evtmp });
            }}
            size="xl"
            backdrop={
              this.state.isMovingBookingToRecovery ? "static" : true
            }
            keyboard={!this.state.isMovingBookingToRecovery}
          >
            {/* <Modal.Header>
              <Modal.Title>Edit Event</Modal.Title>
              <Button
                variant=""
                className="close"
                onClick={() => {
                  this.onHideEditEventModal();
                  this.onCancel();
                }}
              >
                <span>&times;</span>
              </Button>
            </Modal.Header> */}
            <Modal.Header style={{ position: "relative" }}>
              <div className="d-flex justify-content-between w-100 align-items-start">
                <Modal.Title>
                  {this.state.isMovingBookingToRecovery
                    ? "Moving Booking to Recovery"
                    : "Edit Event"}
                </Modal.Title>

                <div
                  className="text-right"
                  style={{
                    fontSize: "0.8rem",
                    color: "#888",
                    paddingRight: "50px",
                  }}
                >
                  <div>
                    Created At:{" "}
                    {this.formatDate(
                      eventProps.createdAt,
                    )}
                  </div>
                  <div>
                    CreatedBy: {eventProps.createBy || "-"}
                  </div>
                  <div>
                    Updated HN At:{" "}
                    {this.formatDate(
                      eventProps.updatedHN,
                    )}
                  </div>
                  <div>
                    Updated At:{" "}
                    {this.formatDate(
                      eventProps.updatedAt,
                    )}
                  </div>
                  <div>
                    UpdatedBy: {eventProps.updatedBy || "-"}
                  </div>
                </div>
              </div>

              {/* Close button absolutely positioned in top-right */}
              {!this.state.isMovingBookingToRecovery && (
                <Button
                  variant=""
                  className="close"
                  style={{ position: "absolute", top: "10px", right: "10px" }}
                  onClick={() => {
                    this.onHideEditEventModal();
                    this.onCancel();
                  }}
                >
                  <span>&times;</span>
                </Button>
              )}
            </Modal.Header>

            <Modal.Body
              onMouseDownCapture={this.unlockEditDropdownWheel}
              onChangeCapture={this.relockEditDropdownWheel}
              onBlurCapture={this.relockEditDropdownWheel}
              onWheelCapture={this.preventEditDropdownWheel}
            >
              {this.state.isMovingBookingToRecovery && (
                <div
                  className="text-center py-5"
                  role="status"
                  aria-live="assertive"
                >
                  <div
                    className="spinner-border text-danger mb-3"
                    aria-hidden="true"
                  />
                  <h5 className="mb-2">Moving booking to Recovery...</h5>
                  <p className="text-muted mb-3">
                    Please wait. Do not close this page or make another booking
                    change.
                  </p>
                  <p className="mb-1">
                    <strong>Order:</strong>{" "}
                    {this.state.bookingRecoveryProgressData.order}
                  </p>
                  <p className="mb-0">
                    <strong>Patient:</strong>{" "}
                    {this.state.bookingRecoveryProgressData.patientName}
                  </p>
                </div>
              )}
              <div
                style={{
                  display: this.state.isMovingBookingToRecovery
                    ? "none"
                    : undefined,
                }}
              >
              <div
                className="ml-4"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {/* Left: Edit Button */}
                {(isCurrentUserPartTimeSleepTechnician ||
                  !["staff"].includes(this.context.currentUser.roles[0])) && (
                  <Button
                    variant=""
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      if (eventProps.hn !== "") {
                        this.setState({
                          isEditBookingDetail: !this.state.isEditBookingDetail,
                        });
                      }
                    }}
                    size="sm"
                  >
                    {isCurrentUserPartTimeSleepTechnician
                      ? "Update Booking"
                      : "Edit"}
                  </Button>
                )}

                {/* Right: Money Bag Icon */}
                {eventProps.healthInsurance ===
                  "ชำระเงินเอง" && (
                  <img
                    className="mr-4"
                    src={moneyBag}
                    alt="Money Bag"
                    style={{ width: "40px", height: "40px" }}
                  />
                )}
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-xl-12">
                    {isCurrentUserPartTimeSleepTechnician &&
                    (eventProps.hn == "" ||
                      this.state.isEditBookingDetail == true) ? (
                      <>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="booking-date"
                          >
                            Date
                          </label>
                          <div className="col-lg-5">
                            <DatePicker
                              className="form-control"
                              id="booking-date"
                              dateFormat="yyyy-MM-dd"
                              selected={
                                getBookingEventDateInput(
                                  eventTmp,
                                  this.state.dateTmp,
                                ).date
                              }
                              onChange={(event, props) =>
                                this.handleDate(event, props)
                              }
                            />
                          </div>
                        </div>
                        <this.PatientDropDownForm
                          title="Type"
                          id="type"
                          refvalue={this.typeRef}
                          selected={eventProps.type}
                          options={this.typeList}
                        ></this.PatientDropDownForm>
                        {this.renderBookingAdditionalEquipmentField(eventProps, "part-time-equipment")}
                        <this.PatientDropDownForm
                          title="Status"
                          id="status"
                          refvalue={this.statusRef}
                          selected={eventProps.status}
                          options={partTimeTechnicianStatusOptions}
                          isBold={true}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Recording Tech"
                          id="techrecord"
                          refvalue={this.techRecordRef}
                          selected={eventProps.techrecord}
                          options={this.state.techrecordList}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Scoring Tech"
                          id="techscore"
                          refvalue={this.techRef}
                          selected={eventProps.technician}
                          options={this.state.technicianList}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Post Consult Tech"
                          id="techrecord"
                          refvalue={this.techConsultRef}
                          selected={eventProps.techConsult}
                          options={this.state.techrecordList}
                        ></this.PatientDropDownForm>
                        {this.renderBookingSaleField(eventProps.sale)}
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="booking-note"
                          >
                            Note
                          </label>
                          <div className="col-lg-5">
                            <textarea
                              className="form-control"
                              id="booking-note"
                              name="booking-note"
                              rows="4"
                              placeholder="Note"
                              ref={this.noteRef}
                              defaultValue={eventProps.note}
                            />
                          </div>
                        </div>
                      </>
                    ) : eventProps.hn == "" ||
                      this.state.isEditBookingDetail == true ? (
                      <>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Order
                          </label>

                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-hn"
                              name="val-hn"
                              placeholder="Order"
                              ref={this.orderRef}
                              disabled={["staff", "sleep_technician"].includes(
                                this.context.currentUser.roles[0],
                              )}
                              defaultValue={
                                eventProps.order
                              }
                            />
                          </div>
                        </div>
                        <this.PatientDropDownForm
                          title="Node"
                          id="node"
                          refvalue={this.nodeRef}
                          selected={eventProps.node}
                          options={this.state.nodeList}
                          disabled={["staff", "sleep_technician"].includes(
                            this.context.currentUser.roles[0],
                          )}
                          onChange={this.handleBookingNodeChange}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          key={`edit-customer-${
                            eventProps.node
                          }-${
                            eventProps.customer
                          }-${this.state.customerList.join("|")}`}
                          title="Customer"
                          id="customer"
                          refvalue={this.customerRef}
                          selected={eventProps.customer}
                          options={this.state.customerList}
                          disabled={["staff", "sleep_technician"].includes(
                            this.context.currentUser.roles[0],
                          )}
                        ></this.PatientDropDownForm>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            HN (Company Number)
                          </label>

                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-hn"
                              name="val-hn"
                              placeholder="HN"
                              ref={this.hnRef}
                              defaultValue={normalizeBookingHn(eventProps.hn)}
                              onChange={trimBookingHnInput}
                              disabled={["staff", "sleep_technician"].includes(
                                this.context.currentUser.roles[0],
                              )}

                              // ref={emailRef}
                              // value=""
                            />
                          </div>
                          <div className="col-lg-2">
                            {!["staff", "sleep_technician"].includes(
                              this.context.currentUser.roles[0],
                            ) && (
                              <Button
                                variant=""
                                type="button"
                                className="btn btn-secondary"
                                onClick={this.onSearchPatient}
                                size="sm"
                              >
                                Search
                              </Button>
                            )}
                          </div>
                        </div>
                        {this.state.isNewPatient ? (
                          <div className="form-group row">
                            <label
                              className="col-lg-3 col-form-label"
                              htmlFor="val-username"
                            ></label>

                            <div className="col-lg-4">
                              <label className="text-danger">
                                * New Patient
                              </label>
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        {this.state.isEditBookingDetail == true ? (
                          <>
                            {" "}
                            <div className="form-group row">
                              <label
                                className="col-lg-3 col-form-label"
                                htmlFor="val-username"
                              >
                                Full Name
                              </label>
                              <div className="col-lg-4">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="val-hn"
                                  name="val-hn"
                                  placeholder="Firstname"
                                  ref={this.firstnameRef}
                                  defaultValue={
                                    eventProps.firstname
                                  }
                                  disabled={[
                                    "staff",
                                    "sleep_technician",
                                  ].includes(this.context.currentUser.roles[0])}
                                />
                              </div>
                              <div className="col-lg-4">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="val-hn"
                                  name="val-hn"
                                  placeholder="Lastname"
                                  ref={this.lastnameRef}
                                  defaultValue={
                                    eventProps.lastname
                                  }
                                  disabled={[
                                    "staff",
                                    "sleep_technician",
                                  ].includes(this.context.currentUser.roles[0])}
                                />
                              </div>
                            </div>
                            {/* <div className="form-group row">
                              <label
                                className="col-lg-3 col-form-label"
                                htmlFor="val-username"
                              >
                                National ID
                              </label>

                              <div className="col-lg-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="val-hn"
                                  name="val-hn"
                                  placeholder="National ID"
                                  ref={this.nationalIdRef}
                                  defaultValue={
                                    eventProps.nationalId
                                  }
                                />
                              </div>
                            </div> */}
                            <div className="form-group row">
                              <label
                                className="col-lg-3 col-form-label"
                                htmlFor="val-username"
                              >
                                Gender
                              </label>
                              <div className="col-lg-5">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="val-phone"
                                  name="val-phone"
                                  placeholder="Phone"
                                  ref={this.genderRef}
                                  defaultValue={
                                    eventProps.gender
                                  }
                                  disabled={[
                                    "staff",
                                    "sleep_technician",
                                  ].includes(this.context.currentUser.roles[0])}
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label
                                className="col-lg-3 col-form-label"
                                htmlFor="val-username"
                              >
                                Phone
                              </label>
                              <div className="col-lg-5">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="val-phone"
                                  name="val-phone"
                                  placeholder="Phone"
                                  ref={this.phoneRef}
                                  defaultValue={
                                    eventProps.phone
                                  }
                                  disabled={[
                                    "staff",
                                    "sleep_technician",
                                  ].includes(this.context.currentUser.roles[0])}
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label
                                className="col-lg-3 col-form-label"
                                htmlFor="val-username"
                              >
                                Referring Hospital Number
                              </label>
                              <div className="col-lg-5">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="val-phone"
                                  name="val-phone"
                                  placeholder=""
                                  ref={this.hospitalNumberRef}
                                  defaultValue={
                                    eventProps
                                      .hospitalNumber
                                  }
                                  disabled={[
                                    "staff",
                                    "sleep_technician",
                                  ].includes(this.context.currentUser.roles[0])}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {" "}
                            <this.PatientTextInfo
                              title="Full Name"
                              value={
                                eventProps.firstname +
                                " " +
                                eventProps.lastname
                              }
                              bold={true}
                            />
                            <this.PatientTextInfo
                              title="Gender"
                              value={this.formatBookingGenderFull(
                                eventProps.gender,
                              )}
                              bold={true}
                            />
                            <this.PatientTextInfo
                              title="Phone"
                              value={eventProps.phone}
                              bold={true}
                            />
                            <this.PatientTextInfo
                              title="Referring Hospital Number"
                              value={
                                eventProps.hospitalNumber
                              }
                              bold={true}
                            />
                          </>
                        )}
                        <this.PatientDropDownForm
                          title="Health Insurance"
                          id="healthInsurance"
                          refvalue={this.healthInsuranceRef}
                          selected={
                            eventProps.healthInsurance
                          }
                          disabled={["staff", "sleep_technician"].includes(
                            this.context.currentUser.roles[0],
                          )}
                          options={this.paymentPrivilages}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Type"
                          id="type"
                          refvalue={this.typeRef}
                          selected={eventProps.type}
                          options={this.typeList}
                        ></this.PatientDropDownForm>
                        {this.renderBookingAdditionalEquipmentField(eventProps, "edit-booking-equipment")}
                        <this.PatientDropDownForm
                          title="Status"
                          id="status"
                          refvalue={this.statusRef}
                          selected={eventProps.status}
                          options={this.statusList}
                          onChange={this.checkStatus}
                          isBold={true}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Recording Tech"
                          id="techrecord"
                          refvalue={this.techRecordRef}
                          selected={
                            eventProps.techrecord
                          }
                          disabled={["staff"].includes(
                            this.context.currentUser.roles[0],
                          )}
                          options={this.state.techrecordList}
                          // onChange={this.checkStatus}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Scoring Tech"
                          id="techscore"
                          refvalue={this.techRef}
                          selected={
                            eventProps.technician
                          }
                          disabled={["staff"].includes(
                            this.context.currentUser.roles[0],
                          )}
                          options={this.state.technicianList}
                          // onChange={this.checkStatus}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Post Consult Tech"
                          id="techrecord"
                          refvalue={this.techConsultRef}
                          selected={
                            eventProps.techConsult
                          }
                          disabled={["staff"].includes(
                            this.context.currentUser.roles[0],
                          )}
                          options={this.state.techrecordList}
                          // onChange={this.checkStatus}
                        ></this.PatientDropDownForm>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Referring Doctor
                          </label>
                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-refDoctor"
                              name="val-refDoctor"
                              placeholder="Refer Doctor"
                              ref={this.referDocRef}
                              defaultValue={
                                eventProps.referDoctor
                              }
                              disabled={["staff", "sleep_technician"].includes(
                                this.context.currentUser.roles[0],
                              )}
                            />
                          </div>
                        </div>
                        <this.PatientDropDownForm
                          title="Doctor"
                          id="doctor"
                          refvalue={this.docRef}
                          selected={eventProps.doctor}
                          options={this.state.doctorList}
                          disabled={["staff", "sleep_technician"].includes(
                            this.context.currentUser.roles[0],
                          )}
                          // onChange={this.checkStatus}
                        ></this.PatientDropDownForm>
                        <this.PatientDropDownForm
                          title="Post Consult Doctor"
                          id="postDoctor"
                          refvalue={this.postDoctorRef}
                          selected={
                            eventProps.postDoctor
                          }
                          options={this.state.doctorList}
                          disabled={["staff", "sleep_technician"].includes(
                            this.context.currentUser.roles[0],
                          )}
                          // onChange={this.checkStatus}
                        ></this.PatientDropDownForm>
                        {this.renderBookingSaleField(eventProps.sale)}
                        {/* Report checklist */}
                        <this.PatientTextInfo
                          title="Report checklist"
                          value={this.renderBookingReportChecklist({
                            eventProps,
                            canUploadReportFiles,
                            canDeleteReportFiles,
                          })}
                          bold={true}
                          compactHeader={true}
                        />

                        <this.PatientTextInfo
                          title="Patient Forms"
                          value={this.renderBookingPatientNoteChecklist(
                            eventProps,
                          )}
                          bold={true}
                          compactHeader={true}
                        />

                        <this.PatientTextInfo
                          title="Sleep Study Data"
                          value={this.renderBookingSleepStudyFiles({
                            eventProps,
                            canUploadSleepStudyFiles,
                            canDownloadSleepStudyFiles,
                            canDeleteSleepStudyFiles,
                          })}
                          bold={true}
                          compactHeader={true}
                        />

                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Stop-Bang Score
                          </label>
                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-refDoctor"
                              name="val-refDoctor"
                              placeholder=""
                              ref={this.stopBangScoreRef}
                              defaultValue={
                                eventProps.stopBangScore
                              }
                              disabled={["staff", "sleep_technician"].includes(
                                this.context.currentUser.roles[0],
                              )}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            AHI
                          </label>
                          <div className="col-lg-5">
                            <input
                              type="text"
                              className="form-control"
                              id="val-refDoctor"
                              name="val-refDoctor"
                              placeholder=""
                              ref={this.ahiRef}
                              defaultValue={
                                eventProps.ahi
                              }
                              disabled={["staff", "sleep_technician"].includes(
                                this.context.currentUser.roles[0],
                              )}
                            />
                          </div>
                        </div>
                        {eventProps
                          .latestSleepStudyDate ? (
                          <this.PatientTextInfo
                            title="Sleep Study Date"
                            value={
                              eventProps
                                .latestSleepStudyDate
                            }
                            bold={true}
                          />
                        ) : (
                          <></>
                        )}
                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Date
                          </label>
                          <div className="col-lg-2 mt-2">
                            {/* <b>{eventTmp.startStr}</b> */}
                            {/* {this.state.isDatetime ? (
                              <>
                                <input
                                  type={"datetime-local"}
                                  className="form-control"
                                  defaultValue={this.state.dateTmp + "T00:00"}
                                  // defaultValue={new Date(this.state.dateTmp + "T00:00")}
                                  onChange={(event, props) =>
                                    this.handleDateTime(event, props)
                                  }
                                ></input>
                              </>
                            ) : (
                              <>
                                <DatePicker
                                  className="form-control"
                                  dateFormat="yyyy-MM-dd"
                                  selected={new Date(this.state.dateTmp)}
                                  onChange={(event, props) =>
                                    this.handleDate(event, props)
                                  }
                                />
                              </>
                            )} */}
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy-MM-dd"
                              // todayButton="Today"
                              selected={new Date(this.state.dateTmp)}
                              onChange={(event, props) =>
                                this.handleDate(event, props)
                              }
                              disabled={["staff"].includes(
                                this.context.currentUser.roles[0],
                              )}
                            />
                          </div>
                        </div>
                        {this.state.isDatetime ? (
                          <>
                            {" "}
                            <div className="form-group row">
                              <label
                                className="col-lg-3 col-form-label"
                                htmlFor="val-username"
                              >
                                Time
                              </label>
                              <div className="col-lg-2 mt-2">
                                <input
                                  type={"time"}
                                  className="form-control"
                                  defaultValue={
                                    eventProps.time
                                  }
                                  // defaultValue={new Date(this.state.dateTmp + "T00:00")}
                                  onChange={(event, props) =>
                                    this.handleTime(event, props)
                                  }
                                  disabled={[
                                    "staff",
                                    "sleep_technician",
                                  ].includes(this.context.currentUser.roles[0])}
                                ></input>
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        <div className="form-group row">
                          <label
                            className="col-lg-3 col-form-label"
                            htmlFor="val-username"
                          >
                            Note
                          </label>
                          <div className="col-lg-5">
                            <textarea
                              type="area"
                              className="form-control"
                              id="val-phone"
                              name="val-phone"
                              rows="4"
                              placeholder="Note"
                              ref={this.noteRef}
                              defaultValue={
                                eventProps.note
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-lg-5 col-form-label mt-2">
                            <b htmlFor="val-username">Add Item</b>
                            <Button
                              variant="secondary"
                              size="xs"
                              className="ml-2"
                              onClick={() => {
                                var tmpItems = this.state.items;
                                var tmpItemList = this.state.itemList;
                                var indexOfDefaultItem = tmpItemList.findIndex(
                                  (obj) =>
                                    obj.item ===
                                    "Full Night Sleep Study - Social Security - Standard",
                                );

                                if (indexOfDefaultItem === -1) {
                                  indexOfDefaultItem = 0;
                                }

                                var tmp = {
                                  id: tmpItems.length + 1,
                                  itemcode:
                                    tmpItemList[indexOfDefaultItem].itemcode,
                                  item: tmpItemList[indexOfDefaultItem].item,
                                  unitcost:
                                    tmpItemList[indexOfDefaultItem].unitcost,
                                  qty: 1,
                                  discount: 0,
                                  total:
                                    tmpItemList[indexOfDefaultItem].unitcost,
                                };

                                tmpItems = [...tmpItems, tmp];
                                this.setState(
                                  {
                                    items: tmpItems,
                                  },
                                  () => {
                                    this.getTotalValue();
                                  },
                                );
                              }}
                            >
                              +
                            </Button>{" "}
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th className="center">No.</th>
                                <th className="center width300">Item Name</th>
                                {/* <th className="center width100">Item Code</th> */}
                                <th className="center width150">
                                  Unit Cost (THB)
                                </th>
                                <th className="center width100">Qty</th>
                                <th className="center">Discount (THB)</th>
                                <th className="center">Total (THB)</th>
                                <th className="center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.items.map((element, index) => {
                                return (
                                  <tr>
                                    <td className="">{element.id}</td>
                                    <td>
                                      <select
                                        className="form-control"
                                        id={"item" + String(index)}
                                        name={"item" + String(index)}
                                        onChange={(evt) => {
                                          var item = evt.target.value;
                                          var tmpItems = [...this.state.items]; // clone to avoid mutation

                                          var indexOfItemList =
                                            this.state.itemList.findIndex(
                                              (obj) => obj.item === item,
                                            );

                                          if (indexOfItemList !== -1) {
                                            const selectedItem =
                                              this.state.itemList[
                                                indexOfItemList
                                              ];

                                            tmpItems[index] = {
                                              ...tmpItems[index],
                                              itemcode: selectedItem.itemcode,
                                              item: selectedItem.item,
                                              unitcost: selectedItem.unitcost,
                                              qty: 1,
                                              discount: 0,
                                              total: selectedItem.unitcost,
                                            };

                                            this.setState(
                                              { items: tmpItems },
                                              () => {
                                                this.getTotalValue();
                                              },
                                            );
                                          }
                                        }}
                                      >
                                        {[...this.state.itemList]
                                          .sort((a, b) =>
                                            a.item.localeCompare(b.item),
                                          )
                                          .map((value) => (
                                            <option
                                              key={value.itemcode}
                                              value={value.item}
                                              selected={
                                                this.state.items[index].item ===
                                                value.item
                                                  ? "selected"
                                                  : ""
                                              }
                                            >
                                              {value.item}
                                            </option>
                                          ))}
                                      </select>
                                    </td>

                                    {/* <td className="left strong">
                                      <b>{this.state.items[index].itemcode}</b>
                                    </td> */}
                                    <td className="left">
                                      {" "}
                                      <input
                                        type="number"
                                        className="form-control"
                                        id={"val-unitcost" + String(index)}
                                        name={"val-unitcost" + String(index)}
                                        placeholder="Unit Cost"
                                        onChange={(data) =>
                                          this.onUpdateItemValue(
                                            "unitcost",
                                            index,
                                            data,
                                          )
                                        }
                                        // defaultValue={
                                        //   this.state.items[index].unitcost
                                        // }
                                        value={this.state.items[index].unitcost}
                                      />
                                    </td>
                                    <td className="right">
                                      {" "}
                                      <input
                                        type="number"
                                        className="form-control"
                                        id={"val-qty" + String(index)}
                                        name={"val-qty" + String(index)}
                                        placeholder="QTY"
                                        onChange={(data) =>
                                          this.onUpdateItemValue(
                                            "qty",
                                            index,
                                            data,
                                          )
                                        }
                                        // defaultValue={this.state.items[index].qty}
                                        value={this.state.items[index].qty}
                                      />
                                    </td>
                                    <td className="center">
                                      {" "}
                                      <input
                                        type="number"
                                        className="form-control"
                                        id={"val-discount" + String(index)}
                                        name={"val-discount" + String(index)}
                                        placeholder="Discount"
                                        onChange={(data) => {
                                          this.onUpdateItemValue(
                                            "discount",
                                            index,
                                            data,
                                          );
                                        }}
                                        // defaultValue={
                                        //   this.state.items[index].discount
                                        // }
                                        value={this.state.items[index].discount}
                                      />
                                    </td>
                                    <td className="right">
                                      {" "}
                                      <input
                                        type="number"
                                        className="form-control"
                                        id={"val-total" + String(index)}
                                        name={"val-total" + String(index)}
                                        placeholder="Total"
                                        onChange={(data) =>
                                          this.onUpdateItemValue(
                                            "total",
                                            index,
                                            data,
                                          )
                                        }
                                        // defaultValue={this.state.items[index].total}
                                        value={this.state.items[index].total}
                                      />
                                    </td>
                                    <td>
                                      <Button
                                        className="btn btn-danger btn-xs sharp"
                                        onClick={() => {
                                          var tmpItems = this.state.items;
                                          // console.log("items: ", tmpItems);
                                          tmpItems = tmpItems.filter(
                                            (item) =>
                                              item.id != tmpItems[index].id,
                                          );
                                          for (
                                            let i = 0;
                                            i < tmpItems.length;
                                            i++
                                          ) {
                                            tmpItems[i].id = i + 1;
                                          }
                                          // console.log("items: ", tmpItems);
                                          this.setState(
                                            { items: tmpItems },
                                            () => {
                                              this.getTotalValue();
                                            },
                                          );
                                        }}
                                      >
                                        <i className="fa fa-trash"></i>
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        <div className="row">
                          <div className="col-lg-4 col-sm-5 ml-auto">
                            <table className="table table-clear">
                              <tbody>
                                <tr>
                                  <td className="left">
                                    <strong>Total</strong>
                                  </td>
                                  <td className="right">
                                    <strong>
                                      {this.state.totalValue + " THB"}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6">
                          {" "}
                          <this.PatientTextInfo
                            title="Order"
                            value={eventProps.order}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Node"
                            value={eventProps.node}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Customer"
                            value={eventProps.customer}
                            bold={true}
                          />
                          <this.PatientLinkInfo
                            title="HN (Company Number)"
                            value={eventProps.hn}
                            bold={true}
                            path={getPatientPagePath(eventProps.hn)}
                          ></this.PatientLinkInfo>
                          <this.PatientLinkInfo
                            title="Full Name"
                            value={
                              eventProps.firstname +
                              " " +
                              eventProps.lastname
                            }
                            bold={true}
                            path={getPatientPagePath(eventProps.hn)}
                          ></this.PatientLinkInfo>
                          <this.PatientTextInfo
                            title="Gender"
                            value={this.formatBookingGenderFull(
                              eventProps.gender,
                            )}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Date of Birth"
                            value={eventProps.dateOfBirth || eventProps.dob || "—"}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Phone"
                            value={eventProps.phone}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Referring Hospital Number"
                            value={
                              eventProps.hospitalNumber
                            }
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Health Insurance"
                            value={
                              eventProps.healthInsurance
                            }
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Date"
                            value={this.getCalendarEventDateString(
                              eventTmp,
                            )}
                            bold={true}
                          />
                          {eventProps
                            .latestSleepStudyDate ? (
                            <this.PatientTextInfo
                              title="Sleep Study Date"
                              value={
                                eventProps
                                  .latestSleepStudyDate
                              }
                              bold={true}
                            />
                          ) : (
                            <></>
                          )}

                        </div>
                        <div className="col-lg-6">
                          <this.PatientTextInfo
                            title="Type"
                            value={eventProps.type}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Additional equipment"
                            value={<BookingAdditionalEquipment value={eventProps.additionalEquipment} />}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Status"
                            value={eventProps.status}
                            bold={true}
                            titleBold={true}
                          />
                          <this.PatientTextInfo
                            title="Report Status"
                            value={this.renderBookingReportReadiness(
                              eventProps,
                              this.state.isBookingReportLoading,
                            )}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Recording Tech"
                            value={eventProps.techrecord}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Scoring Tech"
                            value={eventProps.technician}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Post Consult Tech"
                            value={
                              eventProps.techConsult
                            }
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Referring Doctor"
                            value={
                              eventProps.referDoctor
                            }
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Doctor"
                            value={eventProps.doctor}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Post Consult Doctor"
                            value={eventProps.postDoctor}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Sale"
                            value={eventProps.sale || "-"}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="AHI"
                            value={eventProps.ahi}
                            bold={true}
                          />
                          <this.PatientTextInfo
                            title="Stop-Bang Score"
                            value={
                              eventProps.stopBangScore
                            }
                            bold={true}
                          />
                        </div>
                        {/* Report checklist */}
                        <div className="col-lg-12">
                          <this.PatientTextInfo
                            title="Report checklist"
                            value={this.renderBookingReportChecklist({
                              eventProps,
                              canUploadReportFiles,
                              canDeleteReportFiles,
                            })}
                            bold={true}
                            compactHeader={true}
                          />

                          <this.PatientTextInfo
                            title="Patient Forms"
                            value={this.renderBookingPatientNoteChecklist(
                              eventProps,
                            )}
                            bold={true}
                            compactHeader={true}
                          />

                          <this.PatientTextInfo
                            title="Sleep Study Data"
                            value={this.renderBookingSleepStudyFiles({
                              eventProps,
                              canUploadSleepStudyFiles,
                              canDownloadSleepStudyFiles,
                              canDeleteSleepStudyFiles,
                            })}
                            bold={true}
                            compactHeader={true}
                          />

                          <this.PatientTextInfo
                            title="Note"
                            value={eventProps.note}
                            bold={true}
                          />
                          <div className="table-responsive">
                            <table className="table table-striped">
                              <thead>
                                <tr>
                                  <th className="center">No.</th>
                                  <th className="center">Item Name</th>
                                  {/* <th className="center">Item Code</th> */}
                                  <th className="center">Unit Cost (THB)</th>
                                  <th className="center">Qty</th>
                                  <th className="center">Discount (THB)</th>
                                  <th className="center">Total (THB)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.items.map((element, index) => {
                                  return (
                                    <tr>
                                      <td className="">
                                        <b>{element.id}</b>
                                      </td>
                                      <td>
                                        <b>{element.item}</b>
                                      </td>
                                      {/* <td className="left strong">
                                        <b>{element.itemcode}</b>
                                      </td> */}
                                      <td className="left">
                                        {" "}
                                        <b>{element.unitcost}</b>
                                      </td>
                                      <td className="right">
                                        {" "}
                                        <b>{element.qty}</b>
                                      </td>
                                      <td className="center">
                                        {" "}
                                        <b>{element.discount}</b>
                                      </td>
                                      <td className="right">
                                        {" "}
                                        <b>{element.total}</b>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          <div className="row">
                            <div className="col-lg-4 col-sm-5 ml-auto">
                              <table className="table table-clear">
                                <tbody>
                                  <tr>
                                    <td className="left">
                                      <strong>Total</strong>
                                    </td>
                                    <td className="right">
                                      <strong>
                                        {this.state.totalValue + " THB"}
                                      </strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              </div>
            </Modal.Body>
            <Modal.Footer
              className={
                this.state.isMovingBookingToRecovery
                  ? "justify-content-center"
                  : "justify-content-between"
              }
            >
              {this.state.isMovingBookingToRecovery ? (
                <span className="text-muted">
                  Recovery move in progress. Please wait...
                </span>
              ) : (
                <>
                {" "}
                {this.canManageBookingDeletion() ? (
                  <div>
                    <Button
                      variant=""
                      className="btn btn-danger"
                      onClick={this.handleMoveBookingToRecovery}
                    >
                      Move to Recovery
                    </Button>
                  </div>
                ) : (
                  <div></div>
                )}
                <div>
                    <Button
                      variant="light"
                      onClick={() => {
                        this.onHideEditEventModal();
                        this.onCancel();
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant=""
                      type="button"
                      className="btn btn-primary ml-2"
                      onClick={() => {
                        if (this.state.isEditBookingDetail) {
                          const selectedBookingDate =
                            getBookingEventDateInput(
                              eventTmp,
                              this.state.dateTmp,
                            ).dateString;
                          const bookingEvents = this.calendarComponentRef.current
                            ? this.calendarComponentRef.current.getApi().getEvents()
                            : this.props.bookingEvents || [];

                          var allEvents = bookingEvents.filter((obj) => {
                            return (
                              isSameLocalBookingDate(
                                this.getCalendarEventDateString(obj),
                                selectedBookingDate,
                              ) &&
                              normalizeBookingHn(obj.extendedProps.hn) !== "" &&
                              !this.isSameCalendarEvent(
                                obj,
                                eventTmp,
                              )
                            );
                          });

                          const normalizedHn = normalizeBookingHn(
                            this.getInputValue(this.hnRef, eventProps.hn),
                          );
                          this.setInputValue(this.hnRef, normalizedHn);
                          let listHNEvent = allEvents.filter((element) => {
                            return (
                              normalizeBookingHn(
                                element.extendedProps.hn,
                              ) === normalizedHn
                            );
                          });

                          if (listHNEvent.length >= 1) {
                            swal({
                              title: `HN ${normalizedHn} is already booking on this day!`,
                              text: `Please recheck booking on ${selectedBookingDate}`,
                              icon: "warning",
                              buttons: true,
                              dangerMode: true,
                            }).then((willBooking) => {
                              if (willBooking) {
                                this.onEditEvent();
                              }
                            });
                          } else {
                            this.onEditEvent();
                          }
                        } else {
                          this.onHideEditEventModal();
                          this.onCancel();
                        }
                      }}
                    >
                      Done
                    </Button>
                </div>
                </>
              )}
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.dateChangeConfirmVisible}
            onHide={() => this.handleDateChangeConfirm(false)}
            centered
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Date Change</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p className="mb-3">
                You changed the booking date. The booking status will remain
                unchanged. Please review the values before saving.
              </p>

              <dl className="row mb-3">
                <dt className="col-sm-4 mb-1">Order</dt>
                <dd className="col-sm-8 mb-2 text-break">
                  {this.state.dateChangeConfirmData.order}
                </dd>
                <dt className="col-sm-4 mb-1">Patient</dt>
                <dd className="col-sm-8 mb-0 text-break">
                  {this.state.dateChangeConfirmData.patientName}
                </dd>
              </dl>

              <div className="table-responsive">
                <table className="table table-sm table-bordered mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Field</th>
                      <th scope="col">Current booking</th>
                      <th scope="col">After save</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Date</th>
                      <td>{this.state.dateChangeConfirmData.oldDate}</td>
                      <td className="font-weight-bold text-primary">
                        {this.state.dateChangeConfirmData.newDate}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Status</th>
                      <td>{this.state.dateChangeConfirmData.oldStatus}</td>
                      <td>
                        {this.state.dateChangeConfirmData.newStatus}
                        <span className="badge badge-warning ml-2">
                          Unchanged
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="mt-3 mb-0">
                <strong>Updating as:</strong>{" "}
                {this.state.dateChangeConfirmData.updatedBy}
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => this.handleDateChangeConfirm(false)}
              >
                Review Booking
              </Button>
              <Button
                variant="primary"
                onClick={() => this.handleDateChangeConfirm(true)}
              >
                Confirm and Save
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.confirmVisible}
            onHide={() => this.handleConfirm(false)}
            centered
            size="lg"
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Assignment Change</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p className="mb-3">
                This order already has an assignment. Review the scoring
                technician and doctor before saving.
              </p>

              <dl className="row mb-3">
                <dt className="col-sm-4 mb-1">Order</dt>
                <dd className="col-sm-8 mb-2 text-break">
                  {this.state.confirmData.order}
                </dd>
                <dt className="col-sm-4 mb-1">Patient</dt>
                <dd className="col-sm-8 mb-0 text-break">
                  {this.state.confirmData.patientName}
                </dd>
              </dl>

              <div className="table-responsive">
                <table className="table table-sm table-bordered mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Field</th>
                      <th scope="col">Current booking</th>
                      <th scope="col">After save</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Status</th>
                      <td>{this.state.confirmData.oldStatus}</td>
                      <td
                        className={
                          this.state.confirmData.statusChanged
                            ? "font-weight-bold text-primary"
                            : ""
                        }
                      >
                        {this.state.confirmData.newStatus}
                        {this.state.confirmData.statusChanged && (
                          <span className="badge badge-warning ml-2">
                            Changed
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Scoring Tech</th>
                      <td>{this.state.confirmData.oldTechnician}</td>
                      <td
                        className={
                          this.state.confirmData.technicianChanged
                            ? "font-weight-bold text-primary"
                            : ""
                        }
                      >
                        {this.state.confirmData.newTechnician}
                        {this.state.confirmData.technicianChanged && (
                          <span className="badge badge-warning ml-2">
                            Changed
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Doctor</th>
                      <td>{this.state.confirmData.oldDoctor}</td>
                      <td
                        className={
                          this.state.confirmData.doctorChanged
                            ? "font-weight-bold text-primary"
                            : ""
                        }
                      >
                        {this.state.confirmData.newDoctor}
                        {this.state.confirmData.doctorChanged && (
                          <span className="badge badge-warning ml-2">
                            Changed
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="mt-3 mb-1">
                <strong>Previously updated by:</strong>{" "}
                {this.state.confirmData.previousUpdatedBy}
              </p>
              <p className="mb-0">
                <strong>Updating as:</strong>{" "}
                {this.state.confirmData.updatedBy}
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => this.handleConfirm(false)}
              >
                Review Booking
              </Button>
              <Button
                variant="primary"
                onClick={() => this.handleConfirm(true)}
              >
                Confirm and Save
              </Button>
            </Modal.Footer>
          </Modal>

          <ConfirmUploadModal
            show={this.state.confirmUploadModal.show}
            message={this.state.confirmUploadModal.message}
            onConfirm={this.handleConfirmYes}
            onCancel={this.handleConfirmNo}
          />
          <BookingPatientConflictModal
            conflict={this.state.bookingPatientConflict}
            loading={this.state.isReloadingBookingPatient}
            onClose={() => {
              if (!this.state.isReloadingBookingPatient) this.setState({ bookingPatientConflict: null });
            }}
            onReload={this.reloadBookingPatient}
          />
        </div>
      </Fragment>
    );
  }
}

export default EventCalendar;
